var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _mask, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _mask2, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroLostBgTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 801,
    viewBox: "0 0 1080 801",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6004_59723)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 800,
    transform: "translate(0 0.5)",
    fill: "url(#paint0_linear_6004_59723)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H1080.06V800.5H0V0.5Z",
    fill: "url(#paint1_linear_6004_59723)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.185 480.373H137.163V480.4H137.185V480.373Z",
    fill: "url(#paint2_linear_6004_59723)",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1058.36 396.756L1059.43 336.779L1061.2 396.927C1061.6 396.927 1061.93 397.253 1061.93 397.65V404.859H1062.65C1063.05 404.859 1063.38 405.184 1063.38 405.581V408.488C1063.91 408.968 1064.26 409.635 1064.33 410.391L1064.48 412.266C1064.71 415.013 1064.7 417.776 1064.45 420.523L1064.34 421.703C1064.22 423.027 1063.21 424.075 1061.93 424.285V430.81H1062.65C1063.05 430.81 1063.38 431.135 1063.38 431.532V432.255C1063.38 432.652 1063.05 432.977 1062.65 432.977H1061.93V436.579H1062.65C1063.05 436.579 1063.38 436.904 1063.38 437.302V438.741C1063.38 439.138 1063.05 439.464 1062.65 439.464H1061.93V445.227H1062.65C1063.05 445.227 1063.38 445.553 1063.38 445.95V447.39C1063.38 447.787 1063.05 448.112 1062.65 448.112H1061.93V448.835H1062.65C1063.05 448.835 1063.38 449.16 1063.38 449.557V450.997C1063.38 451.394 1063.05 451.719 1062.65 451.719H1061.93V453.159H1063.37C1063.77 453.159 1064.1 453.484 1064.1 453.881V458.928C1064.1 459.325 1063.77 459.651 1063.37 459.651H1062.65V474.786C1063.05 474.786 1063.37 475.111 1063.37 475.508V476.948C1063.37 477.345 1063.05 477.67 1062.65 477.67V479.11C1063.05 479.11 1063.37 479.435 1063.37 479.832V481.272C1063.37 481.669 1063.05 481.994 1062.65 481.994V498.569H1064.09C1064.49 498.569 1064.82 498.894 1064.82 499.291V506.815H1070.29C1071.08 506.815 1071.74 507.46 1071.74 508.254V509.374H1086.55V504.857C1086.55 504.426 1086.2 504.079 1085.77 504.079C1085.34 504.079 1084.99 503.731 1084.99 503.301V500.56C1084.99 499.931 1084.48 499.418 1083.84 499.418C1083.05 499.418 1082.49 498.618 1082.77 497.874L1089.63 479.849C1089.84 479.286 1090.37 478.917 1090.98 478.917H1176.46C1176.98 478.917 1177.45 479.181 1177.71 479.623L1188.54 497.885C1188.94 498.563 1188.46 499.418 1187.66 499.418C1187.11 499.418 1186.64 499.871 1186.64 500.433V502.634C1186.64 503.428 1186 504.073 1185.2 504.073H1184.98C1184.18 504.073 1183.53 504.719 1183.53 505.513V509.363H1193.04V474.587C1193.04 474.228 1193.33 473.936 1193.69 473.936C1194.05 473.936 1194.35 473.644 1194.35 473.285V460.362C1194.35 459.568 1194.99 458.923 1195.8 458.923H1219.65V457.483C1219.65 456.689 1220.3 456.044 1221.09 456.044H1227.62C1228.26 456.044 1228.82 455.63 1229.01 455.023L1232.36 444.091C1232.54 443.484 1233.11 443.071 1233.75 443.071H1315.51C1316.3 443.071 1316.95 443.716 1316.95 444.51V509.368V585.518H956.656H388.755H36.8613V495.585V491.746C36.8613 490.952 37.5091 490.306 38.3065 490.306H39.0872C39.8845 490.306 40.5323 489.661 40.5323 488.867V481.895C40.5323 481.101 41.1801 480.456 41.9774 480.456H68.1948C68.9921 480.456 69.6399 481.101 69.6399 481.895V488.867C69.6399 489.661 70.2877 490.306 71.085 490.306H73.8757C74.6564 490.306 75.2876 490.935 75.2876 491.713C75.2876 492.491 75.9188 493.119 76.6995 493.119H84.5896C85.1267 493.119 85.6251 493.417 85.8687 493.892L91.2339 504.068C91.3447 504.272 91.4001 504.504 91.4001 504.735V509.992H97.6125V499.859C97.6125 498.999 98.8638 498.867 99.0465 499.711L99.3788 501.255L101.344 501.249L101.549 499.871C101.666 499.065 102.823 499.038 102.972 499.837L103.238 501.216V501.255L107.131 501.249L107.335 499.871C107.452 499.065 108.609 499.038 108.758 499.837L109.024 501.216V501.255L110.021 501.249L110.226 499.871C110.342 499.065 111.499 499.038 111.649 499.837L111.909 501.216C111.914 501.222 111.914 501.238 111.914 501.238V501.255L112.191 501.249L112.396 499.871C112.512 499.065 113.67 499.038 113.819 499.837L114.085 501.216V501.238V501.255H114.495L114.827 499.711C115.01 498.861 116.261 498.994 116.261 499.859V509.992H131.831V470.373H131.947L132.091 469.099C132.191 468.266 133.398 468.239 133.531 469.071L133.724 470.373H134.295L134.439 469.099C134.544 468.266 135.751 468.239 135.873 469.071L136.094 470.522H141.62L141.781 469.099C141.88 468.266 143.087 468.239 143.22 469.071L143.436 470.522H143.973L144.134 469.099C144.239 468.266 145.446 468.239 145.568 469.071L145.789 470.522H146.072V480.312H149.748V458.669H149.975V458.641V458.597L150.252 455.966C150.341 455.089 151.625 455.106 151.692 455.983L151.897 458.614V458.669H155.269V458.597L155.545 455.966C155.634 455.089 156.919 455.106 156.985 455.983L157.19 458.614V458.669H157.987V439.061H158.641L158.823 438.311C159.012 437.555 160.097 437.588 160.241 438.349L160.374 439.055H160.839L163.574 431.152L164.637 415.642H164.598C163.386 415.642 162.4 414.66 162.4 413.447C162.4 412.233 163.375 411.251 164.598 411.251C165.822 411.251 166.807 412.233 166.807 413.447C166.807 414.566 165.96 415.493 164.875 415.625L166.071 431.152L168.524 439.055H168.856L169.393 437.439C169.62 436.755 170.611 436.789 170.783 437.495L171.165 439.061H171.215V439.298C171.22 439.348 171.22 439.397 171.215 439.442V458.669H173.203V458.641V458.597L173.48 455.966C173.568 455.089 174.853 455.106 174.919 455.983L175.124 458.614V458.669L175.262 458.663V458.63C175.262 458.619 175.268 458.597 175.268 458.597L175.534 455.966C175.622 455.089 176.907 455.106 176.973 455.983L177.178 458.614C177.178 458.63 177.184 458.669 177.184 458.669H177.389V480.312H178.562V470.522H178.845L179.066 469.071C179.199 468.244 180.406 468.266 180.5 469.099L180.666 470.522H181.192L181.414 469.071C181.547 468.244 182.754 468.266 182.848 469.099L183.014 470.522H188.534L188.756 469.071C188.889 468.244 190.096 468.266 190.19 469.099L190.339 470.373H190.904L191.109 469.071C191.242 468.244 192.449 468.266 192.543 469.099L192.693 470.373H192.953V509.992H202.299L202.211 498.878C202.2 498.023 203.429 497.868 203.634 498.701L204.221 501.1H204.791L205.001 499.148C205.095 498.304 206.319 498.282 206.441 499.12L206.723 501.095H206.961L207.172 499.142C207.266 498.299 208.489 498.277 208.611 499.115L208.894 501.089H209.132L209.342 499.137C209.436 498.293 210.66 498.271 210.782 499.109L211.064 501.084H212.028L212.238 499.131C212.332 498.288 213.556 498.265 213.678 499.104L213.96 501.078H214.198L214.409 499.126C214.503 498.282 215.726 498.26 215.848 499.098L216.153 501.222H217.077L217.304 499.126C217.398 498.282 218.622 498.26 218.744 499.098L219.048 501.222H219.397L219.885 499.247C220.095 498.42 221.313 498.569 221.307 499.424L221.263 509.964H229.325V486.131C229.325 485.651 229.081 485.199 228.683 484.934L228.494 484.813C228.09 484.543 227.852 484.09 227.852 483.611V482.722C227.852 481.928 228.5 481.283 229.297 481.283H229.419C229.962 481.283 230.466 480.98 230.709 480.5L236.789 468.685C237.038 468.205 237.536 467.902 238.079 467.902H279.849C280.414 467.902 280.929 468.227 281.167 468.735L286.87 480.996C286.959 481.184 287.009 481.393 287.009 481.603V486.181C287.009 486.539 287.302 486.832 287.662 486.832C288.022 486.832 288.321 487.124 288.321 487.482V509.964H330.468L351.165 492.292C351.431 492.071 351.758 491.95 352.106 491.95H359.709C360.057 491.95 360.395 492.077 360.655 492.303L363.823 495.05L369.293 432.856H371.823L382.166 509.964H388.755V483.395C388.755 483.098 388.849 482.805 389.021 482.563L403.113 462.646C403.257 462.442 403.445 462.287 403.65 462.188V461.675H446.345C446.982 461.675 447.546 462.089 447.729 462.695L451.085 473.627C451.267 474.234 451.832 474.648 452.469 474.648H458.997C459.789 474.648 460.442 475.293 460.442 476.087V514.283H473.465V483.357C473.465 483.081 473.548 482.811 473.697 482.579L485.906 463.65C486.576 462.602 488.171 462.839 488.508 464.036L502.76 514.283H518.696V504.724C518.696 504.294 518.352 503.947 517.92 503.947C517.489 503.947 517.14 503.599 517.14 503.169V500.428C517.14 499.799 516.625 499.286 515.988 499.286C515.196 499.286 514.637 498.486 514.919 497.741L521.78 479.716C521.99 479.154 522.522 478.784 523.131 478.784H561.103C561.452 478.784 561.734 478.509 561.734 478.161C561.734 477.814 561.452 477.538 561.103 477.538H560.793C560.278 477.538 559.857 477.119 559.857 476.606V476.451C559.857 475.85 560.35 475.365 560.948 475.365H578.721C579.491 475.365 580.122 475.988 580.122 476.76V477.223C580.122 477.736 579.702 478.156 579.181 478.156H578.561C578.389 478.156 578.251 478.293 578.251 478.464C578.251 478.635 578.389 478.773 578.561 478.773H608.604C609.119 478.773 609.59 479.038 609.85 479.479L620.686 497.741C621.085 498.42 620.603 499.275 619.805 499.275C619.252 499.275 618.787 499.727 618.787 500.29V502.49C618.787 503.285 618.144 503.93 617.342 503.93H617.115C616.323 503.93 615.669 504.575 615.669 505.37V509.219H625.176V473.721C625.176 473.363 625.47 473.07 625.83 473.07C626.19 473.07 626.489 472.778 626.489 472.419V459.496C626.489 458.702 627.131 458.057 627.934 458.057H684.837C685.629 458.057 686.282 458.702 686.282 459.496V472.419C686.282 472.778 686.575 473.07 686.935 473.07C687.295 473.07 687.594 473.363 687.594 473.721V478.205H701.785L705.002 467.72C705.185 467.113 705.75 466.7 706.387 466.7H747.637C748.428 466.7 749.082 467.345 749.082 468.139V478.205H798.659L804.678 466.49C804.927 466.01 805.426 465.707 805.968 465.707H847.739C848.304 465.707 848.818 466.032 849.057 466.54L854.76 478.801C854.848 478.988 854.898 479.198 854.898 479.408V483.986C854.898 484.344 855.191 484.636 855.551 484.636C855.911 484.636 856.21 484.929 856.21 485.287V509.214H896.674L919.464 489.755H928.146L950.571 509.214H956.656V481.206C956.656 480.908 956.75 480.616 956.921 480.373L971.013 460.456C971.157 460.252 971.345 460.097 971.55 459.998V459.485H1014.25C1014.88 459.485 1015.45 459.899 1015.63 460.506L1018.98 471.438C1019.17 472.044 1019.73 472.458 1020.37 472.458H1026.9C1027.69 472.458 1028.34 473.103 1028.34 473.898V509.208H1041.37V508.089C1041.37 507.295 1042.01 506.649 1042.81 506.649H1054.75V499.126C1054.75 498.729 1055.07 498.403 1055.47 498.403H1056.92V481.829C1056.52 481.829 1056.19 481.504 1056.19 481.106V479.667C1056.19 479.27 1056.52 478.944 1056.92 478.944V477.505C1056.52 477.505 1056.19 477.179 1056.19 476.782V475.343C1056.19 474.945 1056.52 474.62 1056.92 474.62V459.485H1056.19C1055.79 459.485 1055.47 459.16 1055.47 458.763V453.716C1055.47 453.319 1055.79 452.993 1056.19 452.993H1057.64V451.554H1056.91C1056.51 451.554 1056.19 451.228 1056.19 450.831V449.392C1056.19 448.995 1056.51 448.669 1056.91 448.669H1057.64V447.947H1056.91C1056.51 447.947 1056.19 447.621 1056.19 447.224V445.784C1056.19 445.387 1056.51 445.062 1056.91 445.062H1057.64V439.298H1056.91C1056.51 439.298 1056.19 438.973 1056.19 438.576V437.136C1056.19 436.739 1056.51 436.413 1056.91 436.413H1057.64V432.812H1056.91C1056.51 432.812 1056.19 432.486 1056.19 432.089V431.367C1056.19 430.97 1056.51 430.644 1056.91 430.644H1057.64V424.152C1056.38 424.081 1055.33 423.132 1055.16 421.869C1054.64 418.118 1054.62 414.323 1055.09 410.573L1055.15 410.088C1055.25 409.326 1055.63 408.67 1056.19 408.218V405.41C1056.19 405.013 1056.51 404.688 1056.91 404.688H1057.64V397.479C1057.64 397.082 1057.96 396.756 1058.36 396.756ZM137.185 480.373H137.163V480.4H137.185V480.373Z",
    fill: "url(#paint3_linear_6004_59723)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.28 550.468H-58.668V570.033H1217.28V550.468Z",
    fill: "#CFCDC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-57.1133 558.358L1210.18 558.259",
    stroke: "white",
    strokeWidth: 0.552045,
    strokeDasharray: "2.76 2.76"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.51 537.346H1079.55C1081.63 537.346 1083.62 536.468 1085.02 534.928L1087.76 531.911C1088.23 531.399 1088.56 530.782 1088.73 530.112L1089.18 528.313C1090.12 524.563 1085.43 522.041 1082.82 524.897V521.794C1082.82 517.74 1077.59 516.108 1075.29 519.444C1076.43 514.029 1069.99 510.3 1065.87 513.99L1065.5 512.65C1064.5 508.981 1060.5 507.039 1057 508.528C1053.98 509.809 1052.47 513.192 1053.51 516.296L1054.57 519.447C1049.45 519.447 1046.4 525.156 1049.25 529.406L1052.37 534.067C1053.74 536.116 1056.05 537.346 1058.51 537.346H1058.51Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.47 536.956H1078.43C1080.48 536.956 1082.44 536.104 1083.84 534.603L1086.2 532.074C1086.63 531.607 1086.94 531.038 1087.1 530.421L1087.48 528.953C1088.37 525.51 1084.07 523.154 1081.64 525.751V523.056C1081.64 519.324 1076.85 517.799 1074.7 520.843C1075.76 515.929 1069.95 512.495 1066.16 515.801L1066 515.935L1065.68 514.758C1064.75 511.423 1061.11 509.653 1057.91 510.982C1055.09 512.149 1053.67 515.306 1054.66 518.189L1055.58 520.846C1050.89 520.846 1048.13 526.1 1050.78 529.963L1053.38 533.745C1054.76 535.755 1057.03 536.956 1059.47 536.956Z",
    fill: "#6F9392"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.899 544.391L266.872 543.372C270.017 543.173 272.692 540.999 273.529 537.961L273.901 536.606C274.071 535.989 274.083 535.343 273.94 534.72L273.594 533.246C272.787 529.782 267.894 529.681 266.944 533.109L265.696 530.718C263.968 527.409 259.012 528.278 258.509 531.974C257.181 527.126 250.438 526.771 248.609 531.456L248.535 531.644L247.698 530.753C245.33 528.228 241.285 528.344 239.064 531.001C237.11 533.339 237.309 536.793 239.522 538.89L241.562 540.82C239.394 541.952 240.344 545.243 242.784 545.046L250.896 544.388L250.899 544.391Z",
    fill: "#FAEAC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M338.066 544.391L354.039 543.372C357.187 543.173 359.856 540.999 360.699 537.961L361.071 536.606C361.238 535.989 361.253 535.343 361.107 534.72L360.764 533.246C359.954 529.782 355.064 529.681 354.111 533.109L352.866 530.718C351.138 527.409 346.179 528.278 345.679 531.974C344.351 527.126 337.608 526.771 335.779 531.456L335.705 531.644L334.868 530.753C332.503 528.228 328.455 528.344 326.234 531.001C324.28 533.339 324.479 536.793 326.692 538.89L328.732 540.82C326.564 541.952 327.514 545.243 329.953 545.046L338.066 544.388V544.391Z",
    fill: "#FAEAC7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.207 544.391L220.18 543.372C223.325 543.173 225.999 540.999 226.836 537.961L227.209 536.606C227.378 535.989 227.39 535.343 227.247 534.72L226.902 533.246C226.095 529.782 221.201 529.681 220.251 533.109L219.003 530.718C217.276 527.409 212.32 528.278 211.817 531.974C210.488 527.126 203.745 526.771 201.917 531.456L201.842 531.644L201.005 530.753C198.638 528.228 194.593 528.344 192.371 531.001C190.417 533.339 190.617 536.793 192.83 538.89L194.87 540.82C192.702 541.952 193.652 545.243 196.091 545.046L204.204 544.388L204.207 544.391Z",
    fill: "#FAEAC7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M294.138 541.404L309.495 536.892C312.518 536.004 314.647 533.294 314.796 530.146L314.862 528.743C314.891 528.106 314.76 527.471 314.483 526.896L313.822 525.532C312.27 522.334 307.475 523.311 307.303 526.864L305.557 524.806C303.145 521.958 298.502 523.897 298.826 527.614C296.462 523.177 289.805 524.317 289.054 529.291L289.025 529.491L288.012 528.806C285.144 526.864 281.225 527.867 279.646 530.95C278.255 533.66 279.211 536.987 281.832 538.545L284.247 539.98C282.383 541.562 284.033 544.564 286.368 543.834L294.138 541.407V541.404Z",
    fill: "#FAEAC7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.617 538.042L400.825 533.938C398.297 532.606 396.763 529.941 396.879 527.088L396.992 524.419C397.019 523.728 397.219 523.058 397.573 522.462L398.514 520.866C400.483 517.536 405.594 519.043 405.436 522.909L407.619 520.702C410.472 517.819 415.336 520.336 414.63 524.33C417.617 519.672 424.822 521.548 425.161 527.073L426.364 526.376C429.656 524.47 433.87 525.905 435.314 529.423C436.556 532.452 435.255 535.927 432.333 537.399L429.367 538.897H412.063C410.859 538.897 409.677 538.605 408.614 538.045L408.617 538.042Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M403.177 536.639L400.661 534.614C398.856 533.164 397.834 530.951 397.903 528.637L397.992 525.64C398.007 525.003 398.186 524.381 398.51 523.83L399.273 522.522C401.063 519.451 405.768 520.792 405.67 524.345L407.564 522.427C410.188 519.773 414.671 522.058 414.063 525.742C416.758 521.498 423.308 523.142 423.68 528.157L423.695 528.36L426.003 526.814C428.222 525.331 431.129 525.381 433.291 526.942L434.077 527.508C436.058 528.937 436.773 531.558 435.793 533.798C435.307 534.918 434.435 535.826 433.342 536.368L427.659 539.183H414.063L406.829 538.212C405.494 538.033 404.229 537.491 403.177 536.645V536.639Z",
    fill: "#6F9392"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M329.876 523.566H316.819V534.038H329.876V523.566Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M329.942 523.157H316.754V523.416H329.942V523.157Z",
    stroke: "#615E66",
    strokeWidth: 0.196569
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M317.943 521.476L316.975 523.052H329.725L328.757 521.476C328.65 521.303 328.462 521.199 328.259 521.199H318.44C318.237 521.199 318.05 521.303 317.943 521.476Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M329.876 530.461H316.819V534.038H329.876V530.461Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M319.017 531.498H318.028V532.832H319.017V531.498Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M321.257 531.498H320.269V532.832H321.257V531.498Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M326.084 531.498H325.096V532.832H326.084V531.498Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M328.498 531.498H327.509V532.832H328.498V531.498Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M328.328 527.015H327.682V529.555H328.328V527.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M328.328 524.254H327.682V525.415H328.328V524.254Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M325.915 527.015H325.441V529.555H325.915V527.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M325.915 524.254H325.441V525.415H325.915V524.254Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 527.015H323.026V529.555H323.5V527.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 524.254H323.026V525.415H323.5V524.254Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M321.088 527.015H320.614V529.555H321.088V527.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M321.088 524.254H320.614V525.415H321.088V524.254Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M318.845 527.015H318.371V529.555H318.845V527.015Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M318.845 524.254H318.371V525.415H318.845V524.254Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M323.842 531.498H322.854V534.039H323.842V531.498Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M483.131 518.861H445.018V534.039H483.131V518.861Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M483.131 529.511H445.018V534.038H483.131V529.511Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M447.499 521.936H446.864V523.8H447.499V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M484.352 519.897H443.8V520.511H484.352V519.897Z",
    fill: "#615E66"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M447.499 526.235H446.864V528.1H447.499V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M447.705 530.535H445.841V534.038H447.705V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M452.621 530.535H449.732V534.038H452.621V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M457.128 530.535H454.239V534.038H457.128V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M461.633 530.535H458.744V534.038H461.633V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M462.838 531.162C462.838 530.477 463.395 529.923 464.08 529.923C464.765 529.923 465.316 530.477 465.316 531.162V534.039H462.838V531.162Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M469.416 530.535H466.527V534.038H469.416V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M473.923 530.535H471.034V534.038H473.923V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M478.631 530.535H475.742V534.038H478.631V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M482.112 530.535H480.453V534.038H482.112V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M450.98 521.936H450.346V523.8H450.98V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M450.98 526.235H450.346V528.1H450.98V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M453.234 521.936H452.6V523.8H453.234V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M453.234 526.235H452.6V528.1H453.234V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M455.486 521.936H454.852V523.8H455.486V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M455.486 526.235H454.852V528.1H455.486V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M457.532 521.936H456.897V523.8H457.532V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M457.532 526.235H456.897V528.1H457.532V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M459.993 521.936H459.358V523.8H459.993V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M459.993 526.235H459.358V528.1H459.993V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M462.039 521.936H461.404V523.8H462.039V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M462.039 526.235H461.404V528.1H462.039V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M464.499 521.936H463.864V523.8H464.499V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M464.499 526.235H463.864V528.1H464.499V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M466.957 521.936H466.322V523.8H466.957V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M466.957 526.235H466.322V528.1H466.957V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 521.936H468.573V523.8H469.208V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M469.208 526.235H468.573V528.1H469.208V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M471.254 521.936H470.62V523.8H471.254V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M471.254 526.235H470.62V528.1H471.254V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M473.714 521.936H473.08V523.8H473.714V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M473.714 526.235H473.08V528.1H473.714V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M475.969 521.936H475.335V523.8H475.969V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M475.97 526.235H475.336V528.1H475.97V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M478.014 521.936H477.38V523.8H478.014V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M478.014 526.235H477.38V528.1H478.014V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M481.292 521.936H480.657V523.8H481.292V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M481.291 526.235H480.656V528.1H481.291V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M483.751 518.861H444.407V519.907H483.751V518.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M386.628 518.861H348.515V534.039H386.628V518.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M386.691 530.535H348.557V534.038H386.691V530.535Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M350.993 521.936H350.358V523.8H350.993V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M387.85 519.897H347.297V520.511H387.85V519.897Z",
    fill: "#615E66"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M386.691 526.256H348.557V529.368H386.691V526.256Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M351.282 530.535H348.557V534.038H351.282V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M386.691 530.535H348.557V534.038H386.691V530.535Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M356.116 530.535H353.227V534.038H356.116V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M361.398 530.535H358.286V534.038H361.398V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M365.127 530.535H362.238V534.038H365.127V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M366.334 531.162C366.334 530.477 366.891 529.923 367.576 529.923C368.261 529.923 368.812 530.477 368.812 531.162V534.039H366.334V531.162Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M372.91 530.535H370.021V534.038H372.91V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M377.416 530.535H374.527V534.038H377.416V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M382.125 530.535H379.236V534.038H382.125V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M386.693 530.535H383.968V534.038H386.693V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M387.471 521.586H348.557V525.088H387.471V521.586Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M387.471 521.586H348.557V521.976H387.471V521.586Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M387.471 526.256H348.557V526.646H387.471V526.256Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M387.471 530.535H348.557V530.925H387.471V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M384.784 526.235H384.149V528.1H384.784V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M387.247 518.861H347.903V520.294H387.247V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M387.471 518.861H348.557V519.251H387.471V518.861Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M819.344 518.861H781.23V534.039H819.344V518.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M819.407 530.535H781.272V534.038H819.407V530.535Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M783.71 521.936H783.075V523.8H783.71V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M820.565 519.897H780.013V520.511H820.565V519.897Z",
    fill: "#615E66"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M819.407 526.256H781.272V529.368H819.407V526.256Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M783.998 530.535H781.272V534.038H783.998V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M819.407 530.535H781.272V534.038H819.407V530.535Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M788.832 530.535H785.943V534.038H788.832V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M794.112 530.535H791V534.038H794.112V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M797.844 530.535H794.955V534.038H797.844V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M799.048 531.162C799.048 530.477 799.605 529.923 800.29 529.923C800.975 529.923 801.526 530.477 801.526 531.162V534.039H799.048V531.162Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M805.626 530.535H802.737V534.038H805.626V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M810.132 530.535H807.243V534.038H810.132V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M814.84 530.535H811.951V534.038H814.84V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M819.411 530.535H816.686V534.038H819.411V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M820.187 521.586H781.272V525.088H820.187V521.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M820.187 521.586H781.272V521.976H820.187V521.586Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M820.187 526.256H781.272V526.646H820.187V526.256Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M820.187 530.535H781.272V530.925H820.187V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M817.501 526.235H816.866V528.1H817.501V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M819.965 518.861H780.621V520.294H819.965V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M820.187 518.861H781.272V519.251H820.187V518.861Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M945.039 511.079H906.926V534.039H945.039V511.079Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.297831
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M945.097 528.592H906.963V534.039H945.097V528.592Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.297831
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M909.4 515.689H908.766V518.68H909.4V515.689Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.297831
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M945.487 522.17H906.572V527.034H945.487V522.17Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.297831
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M909.688 528.592H906.963V534.039H909.688V528.592Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.297831
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M945.098 528.593H906.964V534.04H945.098V528.593Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M914.746 528.593H911.634V534.04H914.746V528.593Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M919.412 528.593H916.3V534.04H919.412V528.593Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M924.082 528.593H920.97V534.04H924.082V528.593Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M928.752 528.593H925.64V534.04H928.752V528.593Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M933.423 528.593H930.311V534.04H933.423V528.593Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M938.093 528.593H934.98V534.04H938.093V528.593Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M942.764 528.593H939.651V534.04H942.764V528.593Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M945.487 515.165H906.572V520.612H945.487V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M945.487 515.165H906.572V515.942H945.487V515.165Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M945.487 522.172H906.572V522.949H945.487V522.172Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M945.487 528.593H906.572V529.37H945.487V528.593Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M945.487 511.08H906.572V513.609H945.487V511.08Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M945.487 511.08H906.572V511.857H945.487V511.08Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M945.682 512.639H906.38V513.806H945.682V512.639Z",
    fill: "#615E66"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M910.076 515.165H906.964V518.668H910.076V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M913.578 515.165H910.466V518.668H913.578V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M917.078 515.165H913.966V518.668H917.078V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M920.58 515.165H917.468V518.668H920.58V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M924.082 515.165H920.97V518.668H924.082V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M927.585 515.165H924.473V518.668H927.585V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M931.088 515.165H927.976V518.668H931.088V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M934.59 515.165H931.478V518.668H934.59V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M938.093 515.165H934.98V518.668H938.093V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M941.596 515.165H938.483V518.668H941.596V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M945.098 515.165H941.985V518.668H945.098V515.165Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M910.076 522.172H906.964V525.284H910.076V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M913.578 522.172H910.466V525.284H913.578V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M917.078 522.172H913.966V525.284H917.078V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M920.58 522.172H917.468V525.284H920.58V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M924.082 522.172H920.97V525.284H924.082V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M927.585 522.172H924.473V525.284H927.585V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M931.088 522.172H927.976V525.284H931.088V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M934.59 522.172H931.478V525.284H934.59V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M938.093 522.172H934.98V525.284H938.093V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M941.596 522.172H938.483V525.284H941.596V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M945.098 522.172H941.985V525.284H945.098V522.172Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M757.859 518.861H719.745V534.039H757.859V518.861Z",
    fill: "#E4D4B1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M757.859 529.511H719.745V534.038H757.859V529.511Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M722.224 521.936H721.59V523.8H722.224V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M759.08 519.897H718.527V520.511H759.08V519.897Z",
    fill: "#615E66"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M722.224 526.235H721.59V528.1H722.224V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M722.433 530.535H720.568V534.038H722.433V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M727.346 530.535H724.457V534.038H727.346V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M731.852 530.535H728.963V534.038H731.852V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M736.357 530.535H733.468V534.038H736.357V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M737.564 531.162C737.564 530.477 738.121 529.923 738.806 529.923C739.491 529.923 740.042 530.477 740.042 531.162V534.039H737.564V531.162Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M744.141 530.535H741.252V534.038H744.141V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M748.648 530.535H745.759V534.038H748.648V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M753.357 530.535H750.468V534.038H753.357V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M756.842 530.535H755.183V534.038H756.842V530.535Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M725.709 521.936H725.074V523.8H725.709V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M725.709 526.235H725.074V528.1H725.709V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M727.961 521.936H727.326V523.8H727.961V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M727.961 526.235H727.326V528.1H727.961V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M730.214 521.936H729.58V523.8H730.214V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M730.214 526.235H729.58V528.1H730.214V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M732.26 521.936H731.626V523.8H732.26V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M732.26 526.235H731.626V528.1H732.26V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M734.72 521.936H734.086V523.8H734.72V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M734.72 526.235H734.086V528.1H734.72V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M736.766 521.936H736.132V523.8H736.766V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M736.766 526.235H736.132V528.1H736.766V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M739.227 521.936H738.593V523.8H739.227V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M739.227 526.235H738.593V528.1H739.227V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M741.68 521.936H741.046V523.8H741.68V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M741.68 526.235H741.046V528.1H741.68V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M743.934 521.936H743.3V523.8H743.934V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M743.934 526.235H743.3V528.1H743.934V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M745.981 521.936H745.347V523.8H745.981V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M745.981 526.235H745.347V528.1H745.981V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M748.442 521.936H747.808V523.8H748.442V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M748.442 526.235H747.808V528.1H748.442V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M750.693 521.936H750.059V523.8H750.693V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M750.693 526.235H750.059V528.1H750.693V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M752.74 521.936H752.105V523.8H752.74V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M752.74 526.235H752.105V528.1H752.74V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M756.019 521.936H755.385V523.8H756.019V521.936Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M756.019 526.235H755.385V528.1H756.019V526.235Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M758.477 518.861H719.134V519.907H758.477V518.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M194.099 510.924H186.758V534.038H194.099V510.924Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M197.479 512.169H194.244V534.039H197.479V512.169Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M192.166 510.924H188.69V534.038H192.166V510.924Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M204.97 510.924H197.629V534.038H204.97V510.924Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M203.037 510.924H199.562V534.038H203.037V510.924Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M203.034 510.924H201.491V534.038H203.034V510.924Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M192.163 510.924H190.62V534.038H192.163V510.924Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M189.885 507.056H189.763V510.826H189.885V507.056Z",
    stroke: "#615E66",
    strokeWidth: 0.0923277
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M191.335 509.545H191.213V510.826H191.335V509.545Z",
    stroke: "#615E66",
    strokeWidth: 0.0923277
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M774.56 512.168H771.325V534.038H774.56V512.168Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M781.66 506.408H774.268V534.038H781.66V506.408Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M779.716 506.408H776.214V534.038H779.716V506.408Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M779.718 506.408H778.16V534.038H779.718V506.408Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M636.124 500.574H621.727V534.039H636.124V500.574Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M636.516 499.793H621.339V500.183H636.516V499.793Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M636.029 500.574H621.825V502.132H636.029V500.574Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M636.029 519.641H621.825V521.198H636.029V519.641Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M629.216 500.574H623.283V517.306H629.216V500.574Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M628.343 530.926H623.283V534.038H628.343V530.926Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M628.343 530.926H625.618V534.038H628.343V530.926Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M634.377 530.926H629.316V534.038H634.377V530.926Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M634.569 530.926H631.844V534.038H634.569V530.926Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M625.326 522.363H623.283V523.531H625.326V522.363Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M628.246 522.363H626.203V523.531H628.246V522.363Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M634.568 522.363H629.606V524.698H634.568V522.363Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M631.65 522.363H629.606V523.531H631.65V522.363Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M634.568 522.363H632.525V523.531H634.568V522.363Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M629.216 502.909H623.283V506.802H629.216V502.909Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M629.216 508.356H623.283V512.249H629.216V508.356Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M629.216 513.413H623.283V517.306H629.216V513.413Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M629.121 502.909H627.953V506.802H629.121V502.909Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M629.121 508.356H627.953V512.249H629.121V508.356Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M629.121 513.413H627.953V517.306H629.121V513.413Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M636.029 518.084H621.825V518.474H636.029V518.084Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M634.569 502.909H632.04V506.802H634.569V502.909Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M634.569 508.356H632.04V512.249H634.569V508.356Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M634.569 513.413H632.04V517.306H634.569V513.413Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M634.568 502.909H633.791V506.802H634.568V502.909Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M634.568 508.356H633.791V512.249H634.568V508.356Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M634.568 513.413H633.791V517.306H634.568V513.413Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M627.273 502.909H624.744V506.802H627.273V502.909Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M627.273 508.356H624.744V512.249H627.273V508.356Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M627.273 513.413H624.744V517.306H627.273V513.413Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.52 500.574H1073.12V534.039H1087.52V500.574Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.91 499.794H1072.73V500.184H1087.91V499.794Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.42 500.574H1073.22V502.132H1087.42V500.574Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.42 519.642H1073.22V521.199H1087.42V519.642Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.61 500.574H1074.68V517.306H1080.61V500.574Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.74 528.979H1074.68V534.039H1079.74V528.979Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.72 522.364H1074.68V523.532H1076.72V522.364Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.64 522.364H1077.6V523.532H1079.64V522.364Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.61 502.909H1074.68V506.802H1080.61V502.909Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.61 508.357H1074.68V512.25H1080.61V508.357Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.61 513.413H1074.68V517.306H1080.61V513.413Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.52 502.909H1079.35V506.802H1080.52V502.909Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.52 508.357H1079.35V512.25H1080.52V508.357Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.52 513.413H1079.35V517.306H1080.52V513.413Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.42 518.085H1073.22V518.475H1087.42V518.085Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.67 502.909H1076.14V506.802H1078.67V502.909Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.67 508.357H1076.14V512.25H1078.67V508.357Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.67 513.413H1076.14V517.306H1078.67V513.413Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M389.779 534.232H404.188C406.059 534.232 407.867 533.52 409.237 532.239L410.553 531.012C410.907 530.679 411.167 530.259 411.304 529.791L411.414 529.425C412.167 526.863 409.061 524.942 407.11 526.762V525.377C407.11 522.56 403.569 521.303 401.794 523.489C402.643 520.076 398.723 517.497 395.927 519.626L395.149 520.216L394.932 519.537C394.181 517.196 391.641 515.945 389.324 516.782C387.027 517.613 385.869 520.18 386.768 522.452L387.176 523.489C383.748 523.489 381.833 527.441 383.951 530.134L385.565 532.183C386.581 533.475 388.138 534.232 389.782 534.232H389.779Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M390.114 534.23H403.403C405.184 534.23 406.906 533.584 408.249 532.414L409.3 531.496C409.631 531.207 409.875 530.832 410.009 530.412C410.736 528.113 407.99 526.284 406.167 527.869V526.895C406.167 524.339 402.995 523.154 401.318 525.081C402.108 522.124 398.763 519.803 396.267 521.576L395.26 522.293L395.073 521.751C394.373 519.711 392.157 518.621 390.114 519.312C387.955 520.042 386.873 522.451 387.761 524.548L387.987 525.084C384.938 525.084 383.279 528.649 385.247 530.981L386.617 532.607C387.484 533.638 388.765 534.233 390.117 534.233L390.114 534.23Z",
    fill: "#AACAC9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M358.674 533.288C358.674 531.626 359.016 529.985 359.678 528.463L360.342 526.938C361.628 523.978 365.834 523.978 367.12 526.938L367.785 528.463C368.446 529.985 368.788 531.626 368.788 533.288C368.788 533.702 368.455 534.038 368.038 534.038H359.421C359.004 534.038 358.671 533.702 358.671 533.288H358.674Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M360.038 533.096C360.038 531.741 360.321 530.401 360.872 529.162L361.188 528.453C362.394 525.737 366.248 525.737 367.454 528.453L367.77 529.162C368.318 530.401 368.604 531.741 368.604 533.096C368.604 533.507 368.27 533.844 367.856 533.844H360.789C360.375 533.844 360.041 533.51 360.041 533.096H360.038Z",
    fill: "#AACAC9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M363.732 531.119V534.231",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M366.261 530.342L363.732 532.677",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M361.789 531.509L363.734 533.65",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M369.267 534.231H376.099C377.1 534.231 378.059 533.852 378.791 533.17L379.316 532.679C379.491 532.518 379.616 532.316 379.682 532.089L379.732 531.922C380.099 530.686 378.601 529.754 377.654 530.633V529.972C377.654 528.61 375.941 528 375.08 529.057C375.491 527.413 373.606 526.165 372.251 527.19L371.867 527.482L371.766 527.157C371.399 526.028 370.175 525.424 369.058 525.826C367.944 526.228 367.384 527.47 367.822 528.569L368.016 529.057C366.363 529.057 365.437 530.966 366.464 532.265L367.238 533.248C367.73 533.867 368.474 534.231 369.267 534.231Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M371.517 534.038L369.182 530.342",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M370.739 532.48L372.1 529.562",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M374.825 534.231L376.77 531.702",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M374.629 531.119L375.99 532.48",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M373.461 534.037L369.568 527.616",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M762.179 534.234H776.588C778.458 534.234 780.266 533.522 781.636 532.241L782.952 531.014C783.307 530.681 783.566 530.261 783.703 529.793L783.813 529.427C784.567 526.865 781.46 524.944 779.509 526.764V525.379C779.509 522.562 775.968 521.305 774.193 523.491C775.042 520.078 771.123 517.499 768.326 519.628L767.549 520.218L767.331 519.539C766.581 517.198 764.04 515.947 761.723 516.784C759.427 517.615 758.268 520.182 759.168 522.454L759.576 523.491C756.148 523.491 754.233 527.443 756.35 530.135L757.964 532.185C758.98 533.477 760.538 534.234 762.182 534.234H762.179Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M762.511 534.233H775.801C777.582 534.233 779.303 533.587 780.646 532.417L781.698 531.499C782.028 531.21 782.272 530.835 782.406 530.415C783.133 528.116 780.387 526.287 778.564 527.872V526.898C778.564 524.342 775.392 523.157 773.716 525.084C774.505 522.127 771.16 519.806 768.664 521.579L767.658 522.296L767.47 521.754C766.77 519.714 764.554 518.624 762.511 519.315C760.352 520.045 759.271 522.454 760.158 524.551L760.385 525.087C757.335 525.087 755.676 528.652 757.645 530.984L759.015 532.61C759.881 533.641 761.162 534.236 762.514 534.236L762.511 534.233Z",
    fill: "#E9A59B"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M769.987 533.846L775.047 526.647",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M772.322 530.729L779.327 529.952",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M771.738 524.896L773.683 528.592",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M771.545 531.705L769.601 528.979",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.28 546.299H-58.668V550.191H1217.28V546.299Z",
    fill: "#FFF9DE"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M250.886 524.312H231.429V534.04H250.886V524.312Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M250.886 530.147H231.429V534.04H250.886V530.147Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M235.703 531.759H234.148V534.04H235.703V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M238.86 531.759H237.306V534.04H238.86V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M242.502 531.759H240.947V534.04H242.502V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M245.659 531.759H244.104V534.04H245.659V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M249.06 531.759H247.505V534.04H249.06V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M235.703 525.444H234.148V528.941H235.703V525.444Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M238.86 525.444H237.306V528.941H238.86V525.444Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M242.502 525.444H240.947V528.941H242.502V525.444Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M245.659 525.444H244.104V528.941H245.659V525.444Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M249.06 525.444H247.505V528.941H249.06V525.444Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M241.236 519.351L232.006 524.309H250.317L241.236 519.351Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M231.038 524.896L230.064 524.232L241.358 518.281L252.286 524.232L251.467 525.093L241.156 519.449L231.038 524.896Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M654.028 524.312H634.57V534.04H654.028V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M654.028 530.146H634.57V534.039H654.028V530.146Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M638.846 531.759H637.291V534.04H638.846V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M642 531.759H640.445V534.04H642V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M645.643 531.759H644.088V534.04H645.643V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M648.798 531.759H647.243V534.04H648.798V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M652.198 531.759H650.644V534.04H652.198V531.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M638.846 525.443H637.291V528.94H638.846V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M642 525.443H640.445V528.94H642V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M645.642 525.443H644.087V528.94H645.642V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M648.798 525.443H647.243V528.94H648.798V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M652.198 525.443H650.644V528.94H652.198V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M644.38 519.351L635.15 524.309H653.458L644.38 519.351Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M634.18 524.896L633.206 524.232L644.5 518.281L655.43 524.232L654.608 525.093L644.297 519.449L634.18 524.896Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M950.158 524.312H930.7V534.04H950.158V524.312Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M950.158 530.147H930.7V534.04H950.158V530.147Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M934.975 531.758H933.42V534.039H934.975V531.758Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M938.132 531.758H936.577V534.039H938.132V531.758Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M941.77 531.758H940.216V534.039H941.77V531.758Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M944.927 531.758H943.372V534.039H944.927V531.758Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M948.329 531.758H946.774V534.039H948.329V531.758Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M934.975 525.443H933.42V528.94H934.975V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M938.132 525.443H936.577V528.94H938.132V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M941.77 525.443H940.216V528.94H941.77V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M944.927 525.443H943.372V528.94H944.927V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M948.329 525.443H946.774V528.94H948.329V525.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M940.509 519.35L931.279 524.309H949.587L940.509 519.35Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M930.31 524.896L929.336 524.232L940.63 518.281L951.56 524.232L950.738 525.093L940.427 519.449L930.31 524.896Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.623 526.449C294.932 526.449 311.396 509.985 311.396 489.676C311.396 469.366 294.932 452.902 274.623 452.902C254.314 452.902 237.85 469.366 237.85 489.676C237.85 509.985 254.314 526.449 274.623 526.449ZM274.623 523.336C293.213 523.336 308.284 508.266 308.284 489.676C308.284 471.085 293.213 456.015 274.623 456.015C256.032 456.015 240.962 471.085 240.962 489.676C240.962 508.266 256.032 523.336 274.623 523.336Z",
    fill: "#EBC7B6"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.624 509.328C285.477 509.328 294.274 500.616 294.274 489.87C294.274 479.125 285.477 470.413 274.624 470.413C263.771 470.413 254.973 479.125 254.973 489.87C254.973 500.616 263.771 509.328 274.624 509.328ZM274.624 506.606C283.973 506.606 291.552 499.115 291.552 489.873C291.552 480.632 283.973 473.141 274.624 473.141C265.275 473.141 257.695 480.632 257.695 489.873C257.695 499.115 265.275 506.606 274.624 506.606Z",
    fill: "#EBC7B6"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M274.623 526.449C294.932 526.449 311.396 509.985 311.396 489.676C311.396 469.366 294.932 452.902 274.623 452.902C254.314 452.902 237.85 469.366 237.85 489.676C237.85 509.985 254.314 526.449 274.623 526.449Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M275.012 523.336V526.448",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M268.201 522.754L267.617 525.673",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M274.624 523.336C293.214 523.336 308.285 508.266 308.285 489.676C308.285 471.085 293.214 456.015 274.624 456.015C256.033 456.015 240.963 471.085 240.963 489.676C240.963 508.266 256.033 523.336 274.624 523.336Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M274.625 519.447C291.065 519.447 304.393 506.206 304.393 489.872C304.393 473.539 291.065 460.298 274.625 460.298C258.184 460.298 244.856 473.539 244.856 489.872C244.856 506.206 258.184 519.447 274.625 519.447Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M274.623 515.554C288.7 515.554 300.112 504.056 300.112 489.872C300.112 475.689 288.7 464.19 274.623 464.19C260.546 464.19 249.135 475.689 249.135 489.872C249.135 504.056 260.546 515.554 274.623 515.554Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M274.623 512.444C286.981 512.444 296.999 502.339 296.999 489.874C296.999 477.409 286.981 467.305 274.623 467.305C262.265 467.305 252.247 477.409 252.247 489.874C252.247 502.339 262.265 512.444 274.623 512.444Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M274.624 509.331C285.476 509.331 294.274 500.619 294.274 489.873C294.274 479.127 285.476 470.416 274.624 470.416C263.771 470.416 254.973 479.127 254.973 489.873C254.973 500.619 263.771 509.331 274.624 509.331Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M274.624 506.605C283.974 506.605 291.553 499.114 291.553 489.873C291.553 480.632 283.974 473.141 274.624 473.141C265.275 473.141 257.695 480.632 257.695 489.873C257.695 499.114 265.275 506.605 274.624 506.605Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M274.623 500.38C280.533 500.38 285.324 495.676 285.324 489.873C285.324 484.07 280.533 479.365 274.623 479.365C268.713 479.365 263.922 484.07 263.922 489.873C263.922 495.676 268.713 500.38 274.623 500.38Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M297.386 528.977H295.441C294.974 528.2 295.248 527.226 295.441 526.836H297.386C297.854 527.771 297.58 528.653 297.386 528.977Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M288.437 531.314H286.492C286.025 530.537 286.299 529.563 286.492 529.173H288.437C288.905 530.108 288.631 530.99 288.437 531.314Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M280.264 532.871H278.319C277.852 532.094 278.126 531.12 278.319 530.729H280.264C280.732 531.665 280.458 532.546 280.264 532.871Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M271.706 532.871H269.761C269.293 532.094 269.567 531.12 269.761 530.729H271.706C272.173 531.665 271.899 532.546 271.706 532.871Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M263.922 531.703H261.978C261.51 530.926 261.784 529.952 261.978 529.562H263.922C264.39 530.497 264.116 531.378 263.922 531.703Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M304.392 523.922H302.447C301.98 523.144 302.254 522.17 302.447 521.78H304.392C304.86 522.715 304.586 523.597 304.392 523.922Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M310.616 516.916H308.671C308.203 516.138 308.477 515.165 308.671 514.774H310.616C311.083 515.71 310.809 516.591 310.616 516.916Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M314.899 509.134H312.954C312.487 508.356 312.761 507.382 312.954 506.992H314.899C315.367 507.927 315.093 508.809 314.899 509.134Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M318.01 500.574H316.065C315.598 499.797 315.872 498.823 316.065 498.433H318.01C318.478 499.368 318.204 500.249 318.01 500.574Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M318.788 491.623H316.843C316.375 490.846 316.649 489.872 316.843 489.481H318.788C319.255 490.417 318.981 491.298 318.788 491.623Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M317.622 482.672H315.677C315.209 481.894 315.483 480.92 315.677 480.53H317.622C318.089 481.465 317.815 482.347 317.622 482.672Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M314.509 474.112H312.564C312.097 473.335 312.371 472.361 312.564 471.971H314.509C314.977 472.906 314.703 473.787 314.509 474.112Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M310.229 465.94H308.284C307.817 465.163 308.091 464.189 308.284 463.799H310.229C310.697 464.734 310.423 465.616 310.229 465.94Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M304.001 459.715H302.056C301.588 458.937 301.862 457.963 302.056 457.573H304.001C304.468 458.508 304.194 459.39 304.001 459.715Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M296.61 454.267H294.665C294.197 453.49 294.471 452.516 294.665 452.126H296.61C297.077 453.061 296.803 453.943 296.61 454.267Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M288.437 451.151H286.492C286.025 450.374 286.299 449.4 286.492 449.01H288.437C288.905 449.945 288.631 450.827 288.437 451.151Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M279.487 449.207H277.542C277.074 448.429 277.348 447.456 277.542 447.065H279.487C279.954 448.001 279.68 448.882 279.487 449.207Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M270.538 449.596H268.593C268.125 448.819 268.399 447.845 268.593 447.455H270.538C271.005 448.39 270.731 449.272 270.538 449.596Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M261.587 451.542H259.643C259.175 450.764 259.449 449.791 259.643 449.4H261.587C262.055 450.336 261.781 451.217 261.587 451.542Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M253.806 455.044H251.861C251.394 454.266 251.668 453.293 251.861 452.902H253.806C254.274 453.838 254 454.719 253.806 455.044Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M246.41 460.492H244.465C243.997 459.715 244.271 458.741 244.465 458.351H246.41C246.877 459.286 246.603 460.167 246.41 460.492Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M240.572 467.106H238.627C238.159 466.329 238.433 465.355 238.627 464.965H240.572C241.039 465.9 240.765 466.782 240.572 467.106Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M235.905 475.279H233.96C233.492 474.502 233.766 473.528 233.96 473.138H235.905C236.372 474.073 236.098 474.954 235.905 475.279Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M233.571 483.451H231.626C231.158 482.674 231.432 481.7 231.626 481.31H233.571C234.038 482.245 233.764 483.126 233.571 483.451Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M232.79 492.402H230.845C230.377 491.625 230.651 490.651 230.845 490.261H232.79C233.257 491.196 232.983 492.078 232.79 492.402Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M233.571 501.351H231.626C231.158 500.574 231.432 499.6 231.626 499.21H233.571C234.038 500.145 233.764 501.027 233.571 501.351Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M236.293 509.91H234.348C233.88 509.133 234.154 508.159 234.348 507.769H236.293C236.76 508.704 236.486 509.585 236.293 509.91Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M240.962 517.693H239.018C238.55 516.916 238.824 515.942 239.018 515.552H240.962C241.43 516.487 241.156 517.369 240.962 517.693Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M247.191 524.311H245.246C244.779 523.534 245.053 522.56 245.246 522.17H247.191C247.659 523.105 247.385 523.987 247.191 524.311Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M254.582 529.369H252.637C252.169 528.592 252.443 527.618 252.637 527.228H254.582C255.049 528.163 254.775 529.044 254.582 529.369Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M240.769 466.137L274.233 489.68",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M246.8 459.714L274.233 489.676",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M253.805 454.851L274.233 489.482",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M261.587 451.542L274.429 489.483",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M269.953 449.597L274.43 489.482",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M278.319 449.206L274.623 488.898",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M286.685 451.151L274.623 489.482",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M294.664 454.267L274.623 489.679",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M301.863 458.935L274.623 489.677",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M308.087 464.968L274.623 489.679",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M312.369 472.36L275.012 489.676",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M315.676 480.533L274.816 489.677",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M317.621 489.481L274.427 489.872",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M316.844 498.433L275.014 489.873",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M313.925 506.798L274.623 489.869",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M309.645 514.776L274.43 489.678",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M303.615 521.779L274.82 489.869",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M296.413 526.84L274.427 489.677",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M287.659 528.979L274.43 489.677",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M236.099 473.334L274.43 489.873",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M233.765 481.699L274.234 489.872",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M232.986 490.455L274.623 489.678",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M233.569 499.209L274.429 489.869",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M235.515 507.771L275.013 489.678",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M239.989 515.555L274.234 489.873",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M246.217 522.168L274.817 489.481",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M253.608 527.227L274.62 489.479",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M262.364 529.562L274.623 489.286",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M270.73 530.728L274.623 489.481",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M279.487 530.534L274.427 489.481",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M254.39 462.826L252.639 460.298",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M249.135 467.496L246.8 465.745",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M245.243 473.334L242.715 471.776",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M242.323 479.757L239.404 478.979",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M240.962 486.953L238.237 486.562",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M241.156 493.955L238.237 494.345",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M242.714 500.767L239.989 501.934",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M245.826 506.992L243.298 508.55",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M249.912 512.637L247.771 514.778",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M255.36 517.305L253.608 519.833",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M260.613 458.935L259.252 456.406",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M267.229 456.796L266.451 453.877",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M274.232 452.902V456.015",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M282.016 453.685L281.433 456.603",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M289.41 456.019L288.049 458.744",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M296.026 459.908L294.274 462.243",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M301.667 464.771L299.332 466.913",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M306.336 471.192L303.808 472.553",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M309.449 478.005L306.724 478.979",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M311.199 485.59L308.087 485.98",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M311.2 493.372L308.281 492.981",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M309.84 500.575L306.921 499.798",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M306.533 507.575L304.004 506.018",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M302.056 513.802L299.915 512.051",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M296.413 519.058L294.662 516.723",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M289.604 522.946L288.437 520.417",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M282.599 522.56L283.376 525.285",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M253.999 453.293L261.975 455.044",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M256.527 457.572L259.836 451.348",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M261.781 449.597L269.37 453.293",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M263.922 454.461L268.398 449.014",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M270.927 448.233L276.764 452.903",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M271.512 453.099L277.349 448.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M284.545 454.267L279.875 448.623",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M279.293 453.099L286.298 449.206",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M288.63 450.766L291.939 457.187",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M286.687 454.851L294.275 453.1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M296.412 454.267L298.163 461.465",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M293.69 457.963L302.057 457.573",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M299.915 463.021L308.281 463.798",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M303.418 466.719V459.714",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M304.976 468.858L313.342 471.777",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M307.698 473.527L308.672 465.938",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M308.478 475.086L316.65 480.533",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M310.422 480.924L313.147 474.115",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M310.617 482.284L317.426 489.483",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M315.676 482.478L311.396 488.509",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M311.396 490.65L316.844 498.239",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M310.812 496.29L316.65 491.036",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M310.617 498.042L313.926 506.798",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M308.671 503.492L315.869 499.016",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M308.087 505.241L309.645 514.581",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M305.169 510.3L312.758 507.771",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M304.001 511.857L303.808 521.585",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M308.671 514.971L299.915 516.332",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M298.748 517.499L296.803 526.839",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M294.08 520.809L302.446 521.782",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M295.442 526.839L286.299 524.895",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M292.523 521.585L288.63 529.367",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M263.922 524.895L254.582 527.23",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M256.723 521.976L261.976 529.368",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M245.049 511.663L236.489 508.354",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M241.546 505.824L239.795 515.358",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M241.156 505.047L233.957 500.184",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M239.018 498.823L235.709 507.773",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M237.849 489.482L233.569 483.451",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M238.434 483.451L232.013 490.26",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M238.627 481.701L235.901 475.086",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M240.186 476.254L233.765 481.314",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M241.157 474.305L239.989 467.106",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M244.074 469.249L235.901 473.142",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 467.69V460.491",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M248.745 463.411L240.379 464.772",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M254.972 458.547H246.605",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M250.495 461.852L251.856 455.044",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M238.627 497.265L232.983 491.817",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M237.849 491.233L232.596 499.209",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M245.632 512.637V521.977",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M249.719 516.723L240.963 515.556",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M255.943 521.394L247.187 522.171",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M251.081 517.891L253.61 527.231",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M254.193 534.232L273.844 489.286L274.622 491.815L257.499 534.229H254.19L254.193 534.232Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M293.884 535.012L275.207 488.512L274.43 491.04L291.162 535.012H293.887H293.884Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M274.427 493.375C276.362 493.375 277.93 491.807 277.93 489.873C277.93 487.938 276.362 486.37 274.427 486.37C272.493 486.37 270.925 487.938 270.925 489.873C270.925 491.807 272.493 493.375 274.427 493.375Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.297831
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M264.7 525.088L269.76 530.535",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M270.146 526.256L264.115 529.758",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M272.678 526.449L278.125 530.729",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M278.126 526.449L271.705 530.926",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M280.071 526.062L286.296 529.371",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M284.934 525.088L280.458 530.732",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M696.888 540.847L714.696 542.828C717.841 543.176 720.855 541.49 722.201 538.628L723.08 536.764C723.375 536.138 723.509 535.45 723.473 534.762L723.375 532.91C723.175 529.047 717.945 528.017 716.295 531.513L715.381 528.544C714.189 524.669 708.715 524.645 707.488 528.511C706.994 522.998 699.745 521.324 696.885 526.063L696.141 524.886C694.11 521.673 689.708 520.994 686.798 523.442C684.296 525.551 683.837 529.232 685.744 531.891L687.683 534.593C684.996 535.418 685.324 539.316 688.105 539.683L696.885 540.844L696.888 540.847Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M697.592 540.845L713.485 542.755C716.612 543.13 719.638 541.48 721.014 538.645L721.627 537.379C721.907 536.804 722.041 536.17 722.009 535.532L721.937 534.019C721.773 530.466 716.978 529.477 715.424 532.673L714.628 530.094C713.535 526.526 708.502 526.475 707.338 530.019C706.915 525.01 700.347 523.434 697.694 527.705L697.59 527.878L696.931 526.85C695.061 523.935 691.064 523.312 688.392 525.519C686.046 527.461 685.614 530.898 687.407 533.361L689.06 535.63C686.722 536.348 687.055 539.758 689.488 540.009L697.587 540.843L697.592 540.845Z",
    fill: "#62AE80"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M670.502 541.154L662.711 537.05C660.183 535.719 658.649 533.053 658.765 530.2L658.878 527.531C658.905 526.84 659.105 526.17 659.459 525.575L660.4 523.978C662.369 520.648 667.479 522.155 667.322 526.021L669.505 523.814C672.358 520.931 677.222 523.448 676.516 527.442C679.503 522.784 686.707 524.66 687.047 530.185L688.25 529.488C691.541 527.582 695.756 529.018 697.2 532.535C698.442 535.564 697.14 539.04 694.219 540.511L691.252 542.009H673.948C672.745 542.009 671.563 541.717 670.5 541.157L670.502 541.154Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M665.063 539.752L662.546 537.726C660.741 536.276 659.72 534.063 659.788 531.749L659.878 528.753C659.893 528.115 660.071 527.493 660.396 526.942L661.158 525.634C662.948 522.564 667.654 523.904 667.556 527.457L669.45 525.539C672.074 522.885 676.556 525.17 675.949 528.854C678.644 524.61 685.193 526.254 685.566 531.269L685.581 531.472L686.644 530.867C689.649 529.149 693.482 530.45 694.822 533.643C696.002 536.452 694.795 539.695 692.064 541.05L689.548 542.295H675.952L668.717 541.324C667.383 541.145 666.117 540.603 665.066 539.758L665.063 539.752Z",
    fill: "#7CC69A"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M635.206 528.772C636.538 527.373 636.803 525.27 635.859 523.584L630.504 513.997C629.982 513.065 628.642 513.065 628.121 513.997L622.611 523.867C621.75 525.404 621.938 527.316 623.079 528.659C623.88 529.603 625.056 530.145 626.298 530.145H632.008C633.217 530.145 634.372 529.648 635.206 528.772Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M634.886 528.97C636.17 527.773 636.423 525.831 635.491 524.345L631.023 517.259C630.415 516.291 629.001 516.291 628.393 517.259L623.291 525.354C622.72 526.266 622.839 527.451 623.583 528.231C624.641 529.333 626.1 529.956 627.628 529.956H632.396C633.322 529.956 634.213 529.604 634.892 528.973L634.886 528.97Z",
    fill: "#E9A59B"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M629.315 520.225V534.622",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M626.397 521.394L629.123 524.119",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M632.234 524.503L629.509 527.228",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M631.844 521.394L629.119 524.119",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M644.056 534.403C645.867 532.774 645.608 529.867 643.544 528.58L640.116 526.448C639.586 526.12 638.913 526.132 638.401 526.484L635.357 528.56C633.388 529.906 633.126 532.708 634.812 534.394C634.836 534.415 634.862 534.427 634.892 534.427H643.991C644.015 534.427 644.039 534.418 644.056 534.4V534.403Z",
    fill: "#E1F1F1"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M644.056 534.4C644.039 534.418 644.015 534.427 643.991 534.427H634.892C634.862 534.427 634.836 534.415 634.812 534.394C633.126 532.708 633.388 529.906 635.357 528.56L638.401 526.484C638.913 526.132 639.586 526.12 640.116 526.448L643.544 528.58C645.608 529.867 645.867 532.774 644.056 534.403V534.4ZM644.056 534.4L644.188 534.546",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M644.563 534.152C645.745 532.731 645.364 530.587 643.764 529.658L639.928 527.433C639.505 527.189 638.978 527.195 638.561 527.448L635.931 529.053C634.061 530.194 633.927 532.86 635.675 534.182C635.714 534.215 635.765 534.23 635.818 534.23H644.384C644.455 534.23 644.515 534.2 644.563 534.146V534.152Z",
    fill: "#62AE80"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M639.822 531.12V534.232",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M637.294 530.343L639.823 532.678",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M641.767 531.51L639.822 533.651",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M764.15 490.458H755.59V497.463H764.15V490.458Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M753.642 492.298V497.459H755.586V490.675L753.642 492.295V492.298Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M767.262 499.794H647.799V502.129H767.262V499.794Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M647.328 505.631L645.994 503.296H769.805L768.135 505.631H647.328Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M660.254 505.631H647.411V534.038H660.254V505.631Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M660.254 505.631H647.411V508.356H660.254V505.631Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M768.042 505.631H755.199V508.356H768.042V505.631Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M657.526 523.923H650.134V534.04H657.526V523.923Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M658.696 521.586H649.356V522.363H658.696V521.586Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M650.071 523.922L649.448 522.364H658.547L657.612 523.922H650.071Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M655.58 525.479H652.468V534.039H655.58V525.479Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M656.36 516.525H651.69V518.083H656.36V516.525Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M654.804 526.257H653.246V530.149H654.804V526.257Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M768.042 505.631H755.199V534.038H768.042V505.631Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M755.2 505.631H660.251V507.966H755.2V505.631Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M755.2 507.967H660.251V511.079H755.2V507.967Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M664.921 511.079H660.251V534.039H664.921V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M677.764 511.079H673.094V534.039H677.764V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M691.77 511.079H687.1V534.039H691.77V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M705.002 511.079H700.332V534.039H705.002V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M716.288 511.079H711.618V534.039H716.288V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M729.904 511.079H724.457V534.039H729.904V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M743.525 511.079H736.91V534.039H743.525V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M755.2 511.079H748.585V534.039H755.2V511.079Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M662.976 507.967H660.251V509.134H662.976V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M662.586 509.134H660.251V534.038H662.586V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M755.202 507.967H752.477V509.134H755.202V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M755.199 509.134H752.864V534.038H755.199V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M675.814 507.967H672.702V509.134H675.814V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M675.429 509.134H673.094V534.038H675.429V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M689.825 507.967H686.713V509.134H689.825V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M689.435 509.134H687.1V534.038H689.435V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M703.056 507.967H699.943V509.134H703.056V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M702.667 509.134H700.332V534.038H702.667V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M716.675 507.967H713.562V509.134H716.675V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M716.287 509.134H713.952V534.038H716.287V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M730.294 507.967H727.182V509.134H730.294V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M729.907 509.134H727.572V534.038H729.907V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M743.914 507.967H740.802V509.134H743.914V507.967Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M743.528 509.134H741.193V534.038H743.528V509.134Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M647.704 498.626L646.828 497.459H769.016L768.141 498.626H647.704Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M647.704 499.794L646.828 498.627H769.016L768.141 499.794H647.704Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M645.791 503.296L644.889 502.129H770.952L770.049 503.296H645.791Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M654.025 515.753C655.53 515.753 656.75 514.533 656.75 513.028C656.75 511.523 655.53 510.303 654.025 510.303C652.52 510.303 651.3 511.523 651.3 513.028C651.3 514.533 652.52 515.753 654.025 515.753Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M654.027 514.972C655.101 514.972 655.972 514.101 655.972 513.027C655.972 511.953 655.101 511.082 654.027 511.082C652.953 511.082 652.082 511.953 652.082 513.027C652.082 514.101 652.953 514.972 654.027 514.972Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M704.222 491.235L706.363 492.793L709.282 497.463C708.57 497.463 706.908 497.424 705.973 497.269C704.105 496.179 704.287 493.573 704.612 492.406L704.222 491.238V491.235Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M702.668 492.012L704.809 493.373L707.728 497.459C707.016 497.459 705.354 497.426 704.419 497.289C702.552 496.336 702.734 494.055 703.058 493.033L702.668 492.012Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M701.11 492.402L703.252 493.668L706.17 497.462C705.459 497.462 703.797 497.43 702.862 497.305C700.994 496.42 701.176 494.3 701.501 493.352L701.11 492.402Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M699.166 493.18L701.307 494.249L704.226 497.46C703.514 497.46 701.852 497.433 700.917 497.325C699.05 496.575 699.231 494.785 699.556 493.981L699.166 493.18Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M697.998 494.739L700.139 495.421L703.058 497.464C702.346 497.464 700.685 497.447 699.749 497.378C697.882 496.902 698.064 495.761 698.388 495.249L697.998 494.739Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M713.172 491.235L711.031 492.793L708.112 497.463C708.824 497.463 710.486 497.424 711.421 497.269C713.289 496.179 713.107 493.573 712.782 492.406L713.172 491.238V491.235Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M714.73 492.012L712.589 493.373L709.67 497.459C710.382 497.459 712.044 497.426 712.979 497.289C714.846 496.336 714.665 494.055 714.34 493.033L714.73 492.012Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M716.287 492.402L714.145 493.668L711.227 497.462C711.938 497.462 713.6 497.43 714.535 497.305C716.403 496.42 716.221 494.3 715.897 493.352L716.287 492.402Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M718.233 493.18L716.092 494.249L713.173 497.46C713.885 497.46 715.547 497.433 716.482 497.325C718.349 496.575 718.168 494.785 717.843 493.981L718.233 493.18Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M719.399 494.739L717.258 495.421L714.339 497.464C715.051 497.464 716.713 497.447 717.648 497.378C719.515 496.902 719.333 495.761 719.009 495.249L719.399 494.739Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M708.699 496.683C710.095 496.683 711.227 495.551 711.227 494.155C711.227 492.758 710.095 491.626 708.699 491.626C707.302 491.626 706.17 492.758 706.17 494.155C706.17 495.551 707.302 496.683 708.699 496.683Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M708.698 495.905C709.666 495.905 710.45 495.121 710.45 494.154C710.45 493.186 709.666 492.402 708.698 492.402C707.731 492.402 706.947 493.186 706.947 494.154C706.947 495.121 707.731 495.905 708.698 495.905Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M650.294 511.342L650.08 510.603C650.008 510.356 650.196 510.106 650.458 510.106H651.423C651.474 510.106 651.521 510.097 651.563 510.079L653.865 509.194C653.967 509.156 654.08 509.162 654.178 509.209L656.593 510.415C656.692 510.466 656.808 510.469 656.912 510.427L657.32 510.264C657.535 510.177 657.776 510.296 657.838 510.517L658.077 511.336C658.1 511.419 658.097 511.509 658.062 511.586L657.8 512.244C657.749 512.363 657.764 512.497 657.835 512.605L658.005 512.861C658.071 512.962 658.086 513.087 658.053 513.2L657.782 514.007C657.746 514.12 657.761 514.246 657.829 514.347L657.99 514.585C658.068 514.701 658.077 514.85 658.014 514.975L657.812 515.377C657.758 515.488 657.758 515.616 657.812 515.726L658.038 516.173C658.089 516.271 658.092 516.387 658.05 516.491L657.806 517.111C657.755 517.23 657.77 517.364 657.841 517.471L657.972 517.668C658.059 517.799 658.059 517.968 657.972 518.1L657.85 518.278C657.773 518.394 657.764 518.543 657.826 518.668L658.029 519.07C658.083 519.181 658.083 519.309 658.029 519.419L657.8 519.875C657.752 519.967 657.761 520.077 657.82 520.16C657.946 520.351 657.809 520.607 657.579 520.607H650.544C650.413 520.607 650.291 520.542 650.217 520.435L650.068 520.211C649.99 520.095 649.982 519.946 650.044 519.821L650.247 519.419C650.3 519.309 650.3 519.181 650.247 519.07L650.044 518.668C649.982 518.543 649.99 518.394 650.068 518.278L650.19 518.1C650.276 517.968 650.276 517.799 650.19 517.668L650.059 517.471C649.988 517.364 649.973 517.23 650.023 517.111L650.267 516.491C650.309 516.387 650.306 516.271 650.256 516.173L650.029 515.726C649.976 515.616 649.976 515.488 650.029 515.377L650.247 514.945C650.3 514.835 650.3 514.707 650.247 514.597L650.02 514.15C649.97 514.052 649.967 513.936 650.008 513.832L650.253 513.212C650.303 513.093 650.288 512.959 650.217 512.852L650.053 512.608C649.982 512.5 649.967 512.366 650.017 512.247L650.279 511.589C650.315 511.509 650.318 511.419 650.294 511.339V511.342Z",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M765.317 523.923H757.925V534.04H765.317V523.923Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M766.484 521.586H757.145V522.363H766.484V521.586Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M757.862 523.922L757.239 522.364H766.338L765.403 523.922H757.862Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M763.372 525.479H760.26V534.039H763.372V525.479Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M764.15 516.525H759.479V518.083H764.15V516.525Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M762.595 526.257H761.037V530.149H762.595V526.257Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M761.815 515.753C763.32 515.753 764.54 514.533 764.54 513.028C764.54 511.523 763.32 510.303 761.815 510.303C760.31 510.303 759.09 511.523 759.09 513.028C759.09 514.533 760.31 515.753 761.815 515.753Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M761.813 514.972C762.887 514.972 763.758 514.101 763.758 513.027C763.758 511.953 762.887 511.082 761.813 511.082C760.739 511.082 759.868 511.953 759.868 513.027C759.868 514.101 760.739 514.972 761.813 514.972Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M758.082 511.342L757.868 510.603C757.796 510.356 757.984 510.106 758.246 510.106H759.211C759.262 510.106 759.309 510.097 759.351 510.079L761.656 509.194C761.758 509.156 761.871 509.162 761.966 509.209L764.382 510.415C764.48 510.466 764.596 510.469 764.7 510.427L765.108 510.264C765.323 510.177 765.564 510.296 765.626 510.517L765.865 511.336C765.889 511.419 765.886 511.509 765.85 511.586L765.588 512.244C765.537 512.363 765.552 512.497 765.623 512.605L765.793 512.861C765.859 512.962 765.874 513.087 765.841 513.2L765.57 514.007C765.534 514.12 765.549 514.246 765.618 514.347L765.778 514.585C765.856 514.701 765.865 514.85 765.802 514.975L765.6 515.377C765.546 515.488 765.546 515.616 765.6 515.726L765.826 516.173C765.877 516.271 765.88 516.387 765.838 516.491L765.594 517.111C765.543 517.23 765.558 517.364 765.629 517.471L765.76 517.668C765.847 517.799 765.847 517.968 765.76 518.1L765.641 518.278C765.564 518.394 765.555 518.543 765.618 518.668L765.82 519.07C765.874 519.181 765.874 519.309 765.82 519.419L765.591 519.875C765.543 519.967 765.552 520.077 765.612 520.16C765.737 520.351 765.6 520.607 765.37 520.607H758.336C758.205 520.607 758.082 520.542 758.008 520.435L757.859 520.211C757.782 520.095 757.773 519.946 757.835 519.821L758.038 519.419C758.091 519.309 758.091 519.181 758.038 519.07L757.835 518.668C757.773 518.543 757.782 518.394 757.859 518.278L757.978 518.1C758.065 517.968 758.065 517.799 757.978 517.668L757.847 517.471C757.776 517.364 757.761 517.23 757.811 517.111L758.056 516.491C758.097 516.387 758.094 516.271 758.044 516.173L757.817 515.726C757.764 515.616 757.764 515.488 757.817 515.377L758.035 514.945C758.088 514.835 758.088 514.707 758.035 514.597L757.808 514.15C757.758 514.052 757.755 513.936 757.796 513.832L758.041 513.212C758.091 513.093 758.076 512.959 758.005 512.852L757.841 512.608C757.77 512.5 757.755 512.366 757.805 512.247L758.067 511.589C758.103 511.509 758.106 511.419 758.082 511.339V511.342Z",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M659.859 490.458H651.3V497.463H659.859V490.458Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M661.808 492.298V497.459H659.863V490.675L661.808 492.295V492.298Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M649.523 493.275L650.267 497.146C650.303 497.331 650.467 497.462 650.651 497.462H692.55C692.765 497.462 692.941 497.286 692.941 497.072V496.041C692.941 495.952 692.911 495.866 692.854 495.797L692.232 495.02C692.184 494.96 692.157 494.889 692.151 494.814L691.973 493.036C691.97 493.001 691.961 492.968 691.949 492.935L691.439 491.613C691.323 491.303 690.868 491.354 690.82 491.684C690.769 492.03 690.287 492.062 690.189 491.726L690.174 491.663C690.075 491.333 689.605 491.342 689.524 491.675L689.411 492.125C689.325 492.47 688.827 492.459 688.756 492.11L688.702 491.83C688.643 491.547 688.244 491.538 688.172 491.818L688.148 491.917C688.083 492.173 687.717 492.164 687.666 491.905C687.615 491.66 687.273 491.634 687.186 491.869L687.008 492.369C686.915 492.619 686.555 492.605 686.487 492.348C686.406 492.059 685.989 492.089 685.95 492.384L685.941 492.432C685.903 492.744 685.459 492.765 685.385 492.459L685.197 491.657C685.125 491.371 684.726 491.351 684.634 491.634L684.563 491.839C684.476 492.095 684.104 492.051 684.08 491.782C684.056 491.517 683.69 491.467 683.601 491.717L683.499 491.988C683.401 492.262 683.014 492.262 682.916 491.988L682.764 491.568C682.662 491.291 682.266 491.312 682.192 491.598L682.15 491.768C682.085 492.042 681.688 492.027 681.641 491.747C681.593 491.476 681.212 491.449 681.132 491.714L680.962 492.277C680.884 492.524 680.53 492.509 680.476 492.259L680.452 492.149C680.405 491.937 680.113 491.917 680.035 492.119C679.955 492.333 679.639 492.292 679.616 492.065V492.03C679.589 491.791 679.258 491.75 679.175 491.976L679.1 492.179C679.002 492.447 678.615 492.408 678.57 492.125L678.534 491.905C678.496 491.64 678.123 491.628 678.061 491.887L678.052 491.92C677.992 492.176 677.623 492.158 677.59 491.899L677.569 491.75C677.534 491.506 677.179 491.5 677.147 491.747C677.108 491.979 676.78 491.994 676.727 491.768L676.673 491.55C676.607 491.285 676.226 491.291 676.167 491.559L676.119 491.774C676.048 492.101 675.583 492.101 675.511 491.774L675.5 491.723C675.428 491.395 674.969 491.38 674.877 491.702L674.806 491.943C674.701 492.31 674.183 492.313 674.07 491.946C673.957 491.574 673.427 491.583 673.325 491.958L673.296 492.077C673.191 492.468 672.634 492.462 672.542 492.065L672.426 491.565C672.351 491.261 671.917 491.267 671.857 491.574L671.833 491.675C671.774 491.973 671.348 491.964 671.3 491.663C671.258 491.386 670.877 491.348 670.779 491.607L670.636 491.979C670.517 492.298 670.049 492.241 670.002 491.905C669.954 491.547 669.448 491.514 669.355 491.863L669.302 492.077C669.209 492.417 668.733 492.438 668.617 492.107L668.563 491.964C668.459 491.678 668.051 491.696 667.97 491.988C667.884 492.301 667.437 492.292 667.363 491.976L667.273 491.58C667.202 491.282 666.8 491.243 666.675 491.523L666.565 491.765C666.475 491.967 666.174 491.937 666.13 491.72C666.076 491.476 665.725 491.482 665.677 491.726L665.597 492.128C665.543 492.399 665.15 492.387 665.114 492.113C665.078 491.839 664.685 491.827 664.632 492.098L664.602 492.247C664.542 492.536 664.131 492.536 664.072 492.247L664.042 492.098C663.982 491.797 663.551 491.803 663.497 492.104C663.443 492.417 662.988 492.393 662.949 492.077C662.913 491.777 662.487 491.735 662.407 492.03C662.335 492.283 661.987 492.307 661.886 492.065L661.874 492.039C661.772 491.809 661.445 491.806 661.344 492.036L661.123 492.539C660.998 492.819 660.614 492.852 660.441 492.596L659.932 491.83C659.816 491.654 659.551 491.669 659.452 491.86C659.336 492.098 658.982 492.048 658.934 491.785L658.925 491.735C658.866 491.428 658.434 491.407 658.35 491.711L658.336 491.777C658.258 492.057 657.877 492.086 657.755 491.824L657.442 491.136C657.338 490.91 657.007 490.937 656.939 491.175L656.84 491.529C656.781 491.744 656.468 491.717 656.447 491.494C656.426 491.273 656.12 491.243 656.054 491.455L656.001 491.645C655.929 491.872 655.61 491.872 655.542 491.645L655.491 491.476C655.405 491.193 655 491.202 654.931 491.488L654.896 491.622C654.83 491.896 654.437 491.881 654.386 491.604C654.339 491.342 653.978 491.312 653.883 491.562L653.794 491.809C653.683 492.113 653.246 492.095 653.159 491.782L653.106 491.586C653.031 491.306 652.638 491.297 652.546 491.571C652.459 491.839 652.078 491.839 651.992 491.571L651.977 491.529C651.884 491.249 651.485 491.249 651.393 491.529L651.256 491.94C651.191 492.14 650.925 492.188 650.797 492.024C650.637 491.827 650.324 491.937 650.324 492.191V492.941C650.324 493.155 650.056 493.251 649.919 493.087C649.767 492.905 649.475 493.045 649.517 493.278L649.523 493.275Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M766.318 493.275L765.574 497.146C765.538 497.331 765.374 497.462 765.189 497.462H723.291C723.076 497.462 722.9 497.286 722.9 497.072V496.041C722.9 495.952 722.93 495.866 722.987 495.797L723.609 495.02C723.657 494.96 723.684 494.889 723.69 494.814L723.868 493.036C723.871 493.001 723.88 492.968 723.892 492.935L724.401 491.613C724.518 491.303 724.973 491.354 725.021 491.684C725.072 492.03 725.554 492.062 725.652 491.726L725.667 491.663C725.766 491.333 726.236 491.342 726.317 491.675L726.43 492.125C726.516 492.47 727.013 492.459 727.085 492.11L727.139 491.83C727.198 491.547 727.597 491.538 727.669 491.818L727.692 491.917C727.758 492.173 728.124 492.164 728.175 491.905C728.226 491.66 728.568 491.634 728.654 491.869L728.833 492.369C728.925 492.619 729.286 492.605 729.354 492.348C729.435 492.059 729.852 492.089 729.89 492.384L729.899 492.432C729.938 492.744 730.382 492.765 730.456 492.459L730.644 491.657C730.715 491.371 731.115 491.351 731.207 491.634L731.278 491.839C731.365 492.095 731.737 492.051 731.761 491.782C731.785 491.517 732.151 491.467 732.24 491.717L732.342 491.988C732.44 492.262 732.827 492.262 732.925 491.988L733.077 491.568C733.179 491.291 733.575 491.312 733.649 491.598L733.691 491.768C733.756 492.042 734.152 492.027 734.2 491.747C734.248 491.476 734.629 491.449 734.709 491.714L734.879 492.277C734.957 492.524 735.311 492.509 735.365 492.259L735.388 492.149C735.436 491.937 735.728 491.917 735.805 492.119C735.886 492.333 736.202 492.292 736.225 492.065V492.03C736.252 491.791 736.583 491.75 736.666 491.976L736.741 492.179C736.839 492.447 737.226 492.408 737.271 492.125L737.306 491.905C737.345 491.64 737.717 491.628 737.78 491.887L737.789 491.92C737.849 492.176 738.218 492.158 738.251 491.899L738.271 491.75C738.307 491.506 738.662 491.5 738.694 491.747C738.733 491.979 739.061 491.994 739.114 491.768L739.168 491.55C739.233 491.285 739.615 491.291 739.674 491.559L739.722 491.774C739.793 492.101 740.258 492.101 740.329 491.774L740.341 491.723C740.413 491.395 740.871 491.38 740.964 491.702L741.035 491.943C741.14 492.31 741.658 492.313 741.771 491.946C741.884 491.574 742.414 491.583 742.516 491.958L742.545 492.077C742.65 492.468 743.207 492.462 743.299 492.065L743.415 491.565C743.489 491.261 743.924 491.267 743.984 491.574L744.008 491.675C744.067 491.973 744.493 491.964 744.541 491.663C744.582 491.386 744.964 491.348 745.062 491.607L745.205 491.979C745.327 492.298 745.792 492.241 745.839 491.905C745.887 491.547 746.393 491.514 746.486 491.863L746.539 492.077C746.632 492.417 747.108 492.438 747.224 492.107L747.278 491.964C747.382 491.678 747.79 491.696 747.87 491.988C747.957 492.301 748.404 492.292 748.478 491.976L748.567 491.58C748.639 491.282 749.041 491.243 749.166 491.523L749.276 491.765C749.366 491.967 749.666 491.937 749.711 491.72C749.765 491.476 750.116 491.482 750.164 491.726L750.244 492.128C750.298 492.399 750.691 492.387 750.727 492.113C750.762 491.839 751.156 491.827 751.209 492.098L751.239 492.247C751.299 492.536 751.71 492.536 751.769 492.247L751.799 492.098C751.859 491.797 752.29 491.803 752.344 492.104C752.398 492.417 752.853 492.393 752.892 492.077C752.928 491.777 753.354 491.735 753.434 492.03C753.506 492.283 753.854 492.307 753.955 492.065L753.967 492.039C754.068 491.809 754.396 491.806 754.497 492.036L754.718 492.539C754.843 492.819 755.227 492.852 755.4 492.596L755.909 491.83C756.025 491.654 756.29 491.669 756.388 491.86C756.505 492.098 756.859 492.048 756.907 491.785L756.916 491.735C756.975 491.428 757.407 491.407 757.49 491.711L757.505 491.777C757.583 492.057 757.964 492.086 758.086 491.824L758.399 491.136C758.503 490.91 758.834 490.937 758.902 491.175L759 491.529C759.06 491.744 759.373 491.717 759.394 491.494C759.414 491.273 759.721 491.243 759.787 491.455L759.84 491.645C759.912 491.872 760.23 491.872 760.299 491.645L760.35 491.476C760.436 491.193 760.841 491.202 760.91 491.488L760.945 491.622C761.011 491.896 761.404 491.881 761.455 491.604C761.502 491.342 761.863 491.312 761.958 491.562L762.047 491.809C762.157 492.113 762.595 492.095 762.682 491.782L762.735 491.586C762.81 491.306 763.203 491.297 763.295 491.571C763.382 491.839 763.763 491.839 763.849 491.571L763.864 491.529C763.956 491.249 764.355 491.249 764.448 491.529L764.585 491.94C764.65 492.14 764.915 492.188 765.043 492.024C765.204 491.827 765.517 491.937 765.517 492.191V492.941C765.517 493.155 765.785 493.251 765.922 493.087C766.074 492.905 766.366 493.045 766.324 493.278L766.318 493.275Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M723.097 497.265L723.168 493.98C723.18 493.426 723.63 492.985 724.184 492.985C724.729 492.985 725.179 493.417 725.199 493.962L725.324 497.265L725.435 493.918C725.456 493.399 725.881 492.985 726.4 492.985C726.918 492.985 727.344 493.396 727.365 493.915L727.49 497.265L727.618 493.944C727.639 493.408 728.076 492.985 728.613 492.985C729.149 492.985 729.589 493.408 729.607 493.944L729.732 497.265L729.887 493.828C729.911 493.355 730.301 492.982 730.775 492.982C731.26 492.982 731.659 493.379 731.659 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M731.655 497.265L731.727 493.98C731.739 493.426 732.188 492.985 732.742 492.985C733.287 492.985 733.737 493.417 733.758 493.962L733.883 497.265L733.993 493.918C734.014 493.399 734.44 492.985 734.958 492.985C735.476 492.985 735.902 493.396 735.923 493.915L736.048 497.265L736.176 493.944C736.197 493.408 736.635 492.985 737.171 492.985C737.707 492.985 738.148 493.408 738.166 493.944L738.291 497.265L738.446 493.828C738.47 493.355 738.86 492.982 739.333 492.982C739.819 492.982 740.218 493.379 740.218 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M740.218 497.265L740.289 493.98C740.301 493.426 740.754 492.985 741.305 492.985C741.85 492.985 742.3 493.417 742.32 493.962L742.446 497.265L742.556 493.918C742.577 493.399 743.003 492.985 743.521 492.985C744.039 492.985 744.465 493.396 744.486 493.915L744.611 497.265L744.739 493.944C744.76 493.408 745.198 492.985 745.734 492.985C746.27 492.985 746.711 493.408 746.728 493.944L746.853 497.265L747.008 493.828C747.032 493.355 747.422 492.982 747.896 492.982C748.381 492.982 748.78 493.379 748.78 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M748.777 497.265L748.849 493.98C748.861 493.426 749.313 492.985 749.864 492.985C750.41 492.985 750.859 493.417 750.88 493.962L751.005 497.265L751.115 493.918C751.136 493.399 751.562 492.985 752.08 492.985C752.599 492.985 753.024 493.396 753.045 493.915L753.17 497.265L753.298 493.944C753.319 493.408 753.757 492.985 754.293 492.985C754.829 492.985 755.27 493.408 755.288 493.944L755.413 497.265L755.568 493.828C755.592 493.355 755.982 492.982 756.455 492.982C756.941 492.982 757.34 493.379 757.34 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M757.34 497.265L757.411 493.98C757.423 493.426 757.876 492.985 758.427 492.985C758.972 492.985 759.422 493.417 759.443 493.962L759.568 497.265L759.678 493.918C759.699 493.399 760.125 492.985 760.643 492.985C761.161 492.985 761.587 493.396 761.608 493.915L761.733 497.265L761.861 493.944C761.882 493.408 762.32 492.985 762.856 492.985C763.392 492.985 763.833 493.408 763.85 493.944L763.976 497.265L764.13 493.828C764.154 493.355 764.544 492.982 765.018 492.982C765.503 492.982 765.902 493.379 765.902 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M649.55 497.265L649.621 493.98C649.633 493.426 650.083 492.985 650.637 492.985C651.182 492.985 651.632 493.417 651.653 493.962L651.778 497.265L651.888 493.918C651.909 493.399 652.335 492.985 652.853 492.985C653.371 492.985 653.797 493.396 653.818 493.915L653.943 497.265L654.071 493.944C654.092 493.408 654.53 492.985 655.066 492.985C655.602 492.985 656.042 493.408 656.06 493.944L656.185 497.265L656.34 493.828C656.364 493.355 656.754 492.982 657.228 492.982C657.713 492.982 658.112 493.379 658.112 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M658.112 497.265L658.184 493.98C658.196 493.426 658.645 492.985 659.199 492.985C659.744 492.985 660.194 493.417 660.215 493.962L660.34 497.265L660.45 493.918C660.471 493.399 660.897 492.985 661.415 492.985C661.934 492.985 662.359 493.396 662.38 493.915L662.505 497.265L662.633 493.944C662.654 493.408 663.092 492.985 663.628 492.985C664.164 492.985 664.605 493.408 664.623 493.944L664.748 497.265L664.903 493.828C664.927 493.355 665.317 492.982 665.79 492.982C666.276 492.982 666.675 493.379 666.675 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M666.671 497.265L666.742 493.98C666.754 493.426 667.204 492.985 667.758 492.985C668.303 492.985 668.753 493.417 668.774 493.962L668.899 497.265L669.009 493.918C669.03 493.399 669.456 492.985 669.974 492.985C670.492 492.985 670.918 493.396 670.939 493.915L671.064 497.265L671.192 493.944C671.213 493.408 671.651 492.985 672.187 492.985C672.723 492.985 673.164 493.408 673.181 493.944L673.307 497.265L673.461 493.828C673.485 493.355 673.875 492.982 674.349 492.982C674.834 492.982 675.234 493.379 675.234 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M675.231 497.265L675.303 493.98C675.315 493.426 675.765 492.985 676.318 492.985C676.864 492.985 677.313 493.417 677.334 493.962L677.459 497.265L677.569 493.918C677.59 493.399 678.016 492.985 678.534 492.985C679.053 492.985 679.479 493.396 679.499 493.915L679.624 497.265L679.753 493.944C679.773 493.408 680.211 492.985 680.747 492.985C681.283 492.985 681.724 493.408 681.742 493.944L681.867 497.265L682.022 493.828C682.046 493.355 682.436 492.982 682.91 492.982C683.395 492.982 683.794 493.379 683.794 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M683.794 497.265L683.865 493.98C683.877 493.426 684.327 492.985 684.881 492.985C685.426 492.985 685.876 493.417 685.897 493.962L686.022 497.265L686.132 493.918C686.153 493.399 686.579 492.985 687.097 492.985C687.615 492.985 688.041 493.396 688.062 493.915L688.187 497.265L688.315 493.944C688.336 493.408 688.774 492.985 689.31 492.985C689.846 492.985 690.287 493.408 690.305 493.944L690.43 497.265L690.585 493.828C690.608 493.355 690.998 492.982 691.472 492.982C691.958 492.982 692.357 493.379 692.357 493.867V497.262",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M657.526 498.627H650.134V500.962H657.526V498.627Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M673.48 499.794H674.648C675.291 499.794 675.815 500.315 675.815 500.961C675.815 501.605 675.294 502.129 674.648 502.129H673.48C672.837 502.129 672.312 501.608 672.312 500.961C672.312 500.318 672.834 499.794 673.48 499.794Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M755.59 494.355C756.897 494.454 757.925 495.547 757.925 496.878V497.462H755.59V494.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M767.261 494.355C765.953 494.454 764.926 495.547 764.926 496.878V497.462H767.261V494.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M729.907 495.514C729.907 494.871 729.386 494.347 728.74 494.347C728.093 494.347 727.572 494.868 727.572 495.514V497.459H729.907V495.514Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M743.524 495.514C743.524 494.871 743.003 494.347 742.357 494.347C741.711 494.347 741.189 494.868 741.189 495.514V497.459H743.524V495.514Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M687.49 499.794H688.657C689.301 499.794 689.825 500.315 689.825 500.961C689.825 501.605 689.304 502.129 688.657 502.129H687.49C686.846 502.129 686.322 501.608 686.322 500.961C686.322 500.318 686.843 499.794 687.49 499.794Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M728.349 499.794H729.517C730.16 499.794 730.684 500.315 730.684 500.961C730.684 501.605 730.163 502.129 729.517 502.129H728.349C727.706 502.129 727.182 501.608 727.182 500.961C727.182 500.318 727.703 499.794 728.349 499.794Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M741.969 499.794H743.137C743.78 499.794 744.304 500.315 744.304 500.961C744.304 501.605 743.78 502.129 743.137 502.129H741.969C741.326 502.129 740.802 501.608 740.802 500.961C740.802 500.318 741.326 499.794 741.969 499.794Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M648.188 494.355C649.496 494.454 650.523 495.547 650.523 496.878V497.462H648.188V494.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M659.863 494.355C658.556 494.454 657.528 495.547 657.528 496.878V497.462H659.863V494.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M675.037 495.514C675.037 494.871 674.516 494.347 673.87 494.347C673.223 494.347 672.702 494.868 672.702 495.514V497.459H675.037V495.514Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M689.048 495.514C689.048 494.871 688.527 494.347 687.88 494.347C687.234 494.347 686.713 494.868 686.713 495.514V497.459H689.048V495.514Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M765.317 498.627H757.925V500.962H765.317V498.627Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M421.91 498.626L325.794 521.779V523.724L345.835 519.831L426.386 503.487L431.056 505.044L412.379 516.719L403.039 524.892C408.1 522.363 419.11 516.954 422.69 515.552C427.167 513.8 445.26 505.044 447.789 503.877C452.652 501.631 451.097 498.623 447.789 498.039C439.071 496.172 426.905 497.649 421.91 498.623V498.626Z",
    fill: "#FAEAC7"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M344.084 534.234H338.053L339.423 529.322C339.908 527.586 338.601 525.867 336.799 525.867H325.794V523.726L424.072 504.069C427.295 503.426 430.562 503.03 433.847 502.89C435.003 502.842 435.476 504.352 434.499 504.972L402.959 525.028C401.288 526.088 400.564 528.155 401.205 530.025L402.643 534.231H397.78V528.584C397.78 527.753 396.934 527.187 396.165 527.506L392.139 529.173V525.864L414.125 510.493C414.938 510.05 414.402 508.7 413.505 508.936C397.431 513.135 372.208 518.544 364.315 520.417C357.129 522.124 350.109 523.979 345.999 525.296C344.376 525.814 343.414 527.407 343.577 529.102L344.081 534.231L344.084 534.234Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M338.052 521.197V526.257",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M342.916 520.418V525.282",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M355.757 517.891V522.367",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M347.002 519.444V524.698",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M351.089 518.667V523.531",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M338.247 526.255L347.39 524.504",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M398.951 534.233V528.904C398.951 527.722 399.484 526.605 400.414 525.873C402.457 524.261 405.14 522.179 407.666 520.258C409.256 518.981 411.183 517.542 413.503 515.937C413.822 515.714 414.102 515.52 414.349 515.356C418.712 512.387 424.368 508.881 431.638 504.849C422.691 509.81 417.283 513.405 414.352 515.353H414.349C414.06 515.553 413.78 515.743 413.503 515.934C412.065 516.947 409.926 518.537 407.666 520.255C403.326 523.734 401.495 525.998 401.09 527.028V534.227H398.948L398.951 534.233Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M341.775 528.333L340.581 534.04H344.084C343.955 533.522 344.006 531.86 343.693 529.37C343.381 526.88 344.733 525.867 345.638 525.674L361.203 521.197L344.977 525.045C343.363 525.429 342.112 526.71 341.775 528.333Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M392.143 527.227L424.246 508.55L431.835 504.854",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M421.91 498.627L325.794 521.78V520.613L421.91 495.902C427.554 494.8 440.629 493.257 447.789 495.902C450.591 496.837 452.003 497.718 452.459 498.043C452.459 499.601 452.652 501.352 451.681 502.129C450.904 502.752 418.929 517.566 403.039 524.893C408.1 522.364 419.11 516.955 422.69 515.553C427.167 513.801 445.26 505.045 447.789 503.878C452.652 501.632 451.097 498.624 447.789 498.04C439.071 496.173 426.905 497.65 421.91 498.624V498.627Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M325.794 518.668V520.612L353.227 513.607C374.951 507.576 421.249 495.318 432.611 494.54C443.973 493.763 450.576 496.551 452.456 498.043V494.204C452.456 493.281 452.193 492.354 451.476 491.779C449.623 490.305 446.046 488.861 442.728 488.703C432.456 487.768 420.808 490.389 416.266 491.815L325.794 518.665V518.668Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M325.794 521.587V523.728",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M413.545 508.94L431.638 504.854",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M434.556 497.266L431.831 502.91",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M425.8 498.042L429.886 503.102",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M442.729 497.266L433.389 502.91",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M430.471 497.459V503.103",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M794.116 534.233V512.053H882.837L891.787 506.8L901.127 510.496L912.218 503.881L914.36 534.233H794.119H794.116Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M796.451 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M798.787 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M801.118 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M803.453 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M805.789 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M808.122 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M810.458 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M812.793 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M815.128 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M817.464 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M819.799 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M822.133 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M824.468 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M826.803 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M829.139 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M831.473 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M833.807 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M836.141 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M838.476 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M840.811 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M843.145 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M845.479 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M847.814 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M850.151 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M852.485 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M854.82 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M857.153 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M859.489 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M861.825 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M864.16 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M866.495 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M868.827 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M871.162 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M873.497 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M875.831 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M878.166 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M880.502 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M882.837 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M885.173 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M887.508 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M889.843 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M892.177 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M894.512 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M896.848 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M899.183 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M901.518 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M903.849 515.165V534.232",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M906.184 514.583V534.234",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M908.519 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M910.854 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M913.188 513.61V534.235",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M794.31 505.242C790.107 505.397 783.737 503.881 781.08 503.101C791.004 513.218 792.559 515.163 794.31 516.137C802.482 516.914 800.534 514.969 811.042 514.969C821.549 514.969 827.387 517.694 832.834 517.888C838.282 518.081 839.643 514.969 846.26 514.969C852.878 514.969 856.378 519.446 860.854 519.446C865.331 519.446 865.134 514.776 871.165 514.582C877.196 514.388 879.921 520.613 882.84 520.613C888.484 520.613 885.565 514.192 891.206 513.998C896.85 513.805 896.653 521.39 900.35 521.39C904.046 521.39 903.852 514.192 908.522 513.608C913.192 513.024 912.998 529.953 914.359 534.036C918.056 523.335 919.807 503.101 914.359 503.101C908.912 503.101 909.299 514.969 904.632 515.163C899.962 515.356 902.881 505.239 896.656 504.462C890.432 503.684 890.432 513.218 885.565 513.605C880.702 513.995 881.673 504.462 874.864 504.462C868.056 504.462 867.275 511.66 862.022 511.66C856.768 511.66 855.213 504.462 846.26 504.462C840.229 504.462 837.117 508.938 831.667 508.938C826.216 508.938 820.051 504.572 812.6 503.878C804.233 503.101 799.564 505.045 794.31 505.239V505.242Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M907.352 513.804C914.044 500.73 914.812 521.587 914.356 533.649C912.995 518.471 911.631 516.878 910.854 515.165C909.88 513.024 908.519 513.608 907.352 513.804Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M794.311 522.561H796.452",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M794.311 528.786H796.452",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M801.118 519.445H803.26",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M801.118 525.674H803.26",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M801.118 531.897H803.26",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M805.789 519.445H807.93",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M805.789 525.674H807.93",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M805.789 531.897H807.93",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M810.458 519.445H812.599",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M810.458 525.674H812.599",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M810.458 531.897H812.599",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M815.128 519.445H817.269",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M815.128 525.674H817.269",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M815.128 531.897H817.269",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M819.799 519.445H821.94",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M819.799 525.674H821.94",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M819.799 531.897H821.94",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M824.468 519.445H826.609",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M824.468 525.674H826.609",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M824.468 531.897H826.609",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M829.139 519.445H831.28",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M829.139 525.674H831.28",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M829.139 531.897H831.28",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M833.807 519.445H835.948",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M833.807 525.674H835.948",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M833.807 531.897H835.948",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M838.476 519.445H840.617",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M838.476 525.674H840.617",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M838.476 531.897H840.617",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M843.145 519.445H845.286",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M843.145 525.674H845.286",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M843.145 531.897H845.286",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M847.814 519.445H849.956",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M847.814 525.674H849.956",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M847.814 531.897H849.956",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M852.485 519.445H854.627",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M852.485 525.674H854.627",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M852.485 531.897H854.627",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M857.153 519.445H859.295",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M857.153 525.674H859.295",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M857.153 531.897H859.295",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M861.825 519.445H863.967",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M861.825 525.674H863.967",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M861.825 531.897H863.967",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M866.495 519.445H868.637",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M866.495 525.674H868.637",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M866.495 531.897H868.637",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M871.163 519.445H873.304",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M871.163 525.674H873.304",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M871.162 531.897H873.303",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M875.831 519.445H877.972",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M875.831 525.674H877.972",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M875.831 531.897H877.972",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M889.843 519.445H891.984",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M889.843 525.674H891.984",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M889.843 531.897H891.984",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M894.512 519.445H896.653",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M894.512 525.674H896.653",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M894.512 531.897H896.653",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M903.849 519.445H905.99",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M903.849 525.674H905.99",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M903.849 531.897H905.99",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M880.502 525.674H882.643",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M880.502 531.897H882.643",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M885.173 525.674H887.314",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M885.173 531.897H887.314",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M796.644 519.445H798.785",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M796.644 525.674H798.785",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M796.644 531.897H798.785",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M798.979 522.561H801.121",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M798.979 528.786H801.121",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M803.649 522.561H805.791",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M803.649 528.786H805.791",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M808.32 522.561H810.462",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M808.32 528.786H810.462",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M812.986 522.561H815.128",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M812.986 528.786H815.128",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M817.656 522.561H819.798",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M817.656 528.786H819.798",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M822.327 522.561H824.469",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M822.327 528.786H824.469",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M826.996 522.561H829.137",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M826.996 528.786H829.137",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M831.666 522.561H833.807",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M831.666 528.786H833.807",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M836.336 522.561H838.477",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M836.336 528.786H838.477",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M841.007 522.561H843.148",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M841.007 528.786H843.148",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M845.674 522.561H847.815",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M845.674 528.786H847.815",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M850.343 522.561H852.484",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M850.343 528.786H852.484",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M855.013 522.561H857.154",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M855.013 528.786H857.154",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M859.685 522.561H861.826",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M859.685 528.786H861.826",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M864.354 522.561H866.496",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M864.354 528.786H866.495",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M869.023 522.561H871.165",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M869.023 528.786H871.165",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M873.694 522.561H875.836",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M873.694 528.786H875.836",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M878.363 522.561H880.505",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M878.363 528.786H880.505",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M883.031 522.561H885.173",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M883.031 528.786H885.173",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M887.7 522.561H889.842",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M887.7 528.786H889.842",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M892.37 522.561H894.512",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M892.37 528.786H894.512",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M897.04 522.561H899.181",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M897.04 528.786H899.181",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M901.709 522.561H903.85",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M901.709 528.786H903.85",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M906.381 522.561H908.522",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M906.381 528.786H908.522",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M911.051 522.561H912.802",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M911.051 528.786H913.192",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M895.873 513.805C894.423 512.473 890.426 512.053 888.091 515.166C891.983 512.441 893.907 514.43 895.096 515.75C896.847 517.694 896.847 521.715 900.74 521.197C897.237 518.278 898.211 515.943 895.876 513.805H895.873Z",
    fill: "#615E66"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M876.782 513.924C874.641 512.452 868.44 512.637 865.521 516.917C869.218 513.414 873.381 514.769 875.055 515.359C878.364 516.527 879.335 520.937 883.228 520.419C880.172 519.642 879.898 516.065 876.782 513.924Z",
    fill: "#615E66"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M851.511 513.805C849.012 513.09 844.119 513.221 838.281 516.724C845.09 513.999 849.253 514.966 850.927 515.556C854.236 516.724 856.571 519.059 860.654 519.252C857.599 518.475 855.594 514.972 851.511 513.805Z",
    fill: "#615E66"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M818.24 513.415C814.154 513.024 808.698 512.846 799.563 516.14C809.487 514.195 814.985 514.99 817.657 515.166C822.91 515.511 826.44 517.706 832.834 517.891C828.057 517.158 824.7 514.031 818.24 513.415Z",
    fill: "#615E66"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M594.685 518.668H480.669V534.233H594.685V518.668Z",
    fill: "#D8D0C3"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M601.882 475.279L597.989 495.708L605.381 496.291L601.879 475.279H601.882Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M601.883 475.279L600.521 496.291H605.385L601.883 475.279Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M599.938 496.291C599.938 495.647 600.459 495.123 601.105 495.123C601.751 495.123 602.273 495.644 602.273 496.291V502.712H599.938V496.291Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M597.989 496.097C597.989 495.561 598.424 495.123 598.963 495.123C599.502 495.123 599.937 495.558 599.937 496.097V502.712H597.992V496.097H597.989Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M602.273 496.681C602.273 495.82 602.97 495.123 603.831 495.123C604.692 495.123 605.389 495.82 605.389 496.681V502.712H602.276V496.681H602.273Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M601.106 501.935C601.106 500.538 602.238 499.406 603.635 499.406C605.032 499.406 606.164 500.538 606.164 501.935V506.215H601.104V501.935H601.106Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M597.213 501.744C597.213 500.668 598.086 499.799 599.158 499.799C600.23 499.799 601.103 500.671 601.103 501.744V508.165H597.21V501.744H597.213Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M602.273 502.619C602.273 501.919 602.842 501.354 603.539 501.354H603.733C604.43 501.354 604.999 501.919 604.999 502.619C604.999 503.319 604.43 503.885 603.733 503.885H603.539C602.842 503.885 602.273 503.319 602.273 502.619Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M598.38 502.909C598.38 502.48 598.731 502.132 599.157 502.132C599.583 502.132 599.935 502.48 599.935 502.909V503.493C599.935 503.922 599.583 504.27 599.157 504.27C598.731 504.27 598.38 503.922 598.38 503.493V502.909Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M598.963 511.86L604.994 504.271L618.42 511.86H598.963Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinejoin: "round"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M604.995 504.271L593.32 510.109L593.71 510.499V514.002L598.964 512.057L604.995 504.274V504.271Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M618.224 534.622V511.858H599.157L593.71 514V534.625H618.224V534.622Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M593.71 518.862H481.64V534.427H593.71V518.862Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M481.639 512.248V518.862H593.71V510.303H480.105L481.595 512.125L481.636 512.179V512.248H481.639Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M535.535 453.488H534.758C534.435 453.488 534.174 453.75 534.174 454.072V511.273C534.174 511.596 534.435 511.857 534.758 511.857H535.535C535.857 511.857 536.119 511.596 536.119 511.273V454.072C536.119 453.75 535.857 453.488 535.535 453.488Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M540.205 453.488H539.427C539.105 453.488 538.844 453.75 538.844 454.072V511.273C538.844 511.596 539.105 511.857 539.427 511.857H540.205C540.527 511.857 540.789 511.596 540.789 511.273V454.072C540.789 453.75 540.527 453.488 540.205 453.488Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M487.866 524.312H482.419V534.43H487.866V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M487.866 524.312H482.419V526.257H487.866V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M483.586 520.029H482.419V522.754H483.586V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M485.922 520.029H484.364V522.754H485.922V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M487.866 520.029H486.698V522.754H487.866V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M496.816 524.312H491.369V534.43H496.816V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M492.537 520.029H491.369V522.754H492.537V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M494.872 520.029H493.314V522.754H494.872V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M496.817 520.029H495.649V522.754H496.817V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M513.939 524.312H508.491V534.43H513.939V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M509.659 520.029H508.491V522.754H509.659V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M511.995 520.029H510.438V522.754H511.995V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M513.939 520.029H512.771V522.754H513.939V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M522.889 524.312H517.441V534.43H522.889V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M518.609 520.029H517.441V522.754H518.609V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M520.944 520.029H519.387V522.754H520.944V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M522.889 520.029H521.722V522.754H522.889V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M531.839 524.312H526.392V534.43H531.839V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M527.559 520.029H526.392V522.754H527.559V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M529.894 520.029H528.336V522.754H529.894V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M531.838 520.029H530.671V522.754H531.838V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M549.348 524.312H543.9V534.43H549.348V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M545.068 520.029H543.9V522.754H545.068V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M547.406 520.029H545.849V522.754H547.406V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M549.348 520.029H548.181V522.754H549.348V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M558.298 524.312H552.851V534.43H558.298V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M554.018 520.029H552.851V522.754H554.018V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M556.357 520.029H554.799V522.754H556.357V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M558.301 520.029H557.134V522.754H558.301V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M592.933 524.312H587.485V534.43H592.933V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M588.653 520.029H587.485V522.754H588.653V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M590.988 520.029H589.431V522.754H590.988V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M604.218 527.424H601.883V534.429H604.218V527.424Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M598.38 527.812H597.213V532.091H598.38V527.812Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M596.045 527.812H594.878V532.091H596.045V527.812Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M597.213 525.867H598.38V521.251L597.213 521.543V525.867Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M594.878 525.866H596.045V521.64L594.878 521.932V525.866Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M597.213 515.318V518.255L598.38 518.109V515.026L597.213 515.318Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M594.878 515.707V518.644L596.045 518.498V515.415L594.878 515.707Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M615.893 527.812H613.558V532.091H615.893V527.812Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M592.933 520.029H591.766V522.754H592.933V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M583.982 524.312H578.535V534.43H583.982V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M579.703 520.029H578.535V522.754H579.703V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M582.038 520.029H580.48V522.754H582.038V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M583.984 520.029H582.816V522.754H583.984V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M567.249 524.312H561.802V534.43H567.249V524.312Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M562.969 520.029H561.802V522.754H562.969V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M565.305 520.029H563.747V522.754H565.305V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M567.25 520.029H566.083V522.754H567.25V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M586.705 517.306H584.76V534.428H586.705V517.306Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M561.022 517.306H559.077V534.428H561.022V517.306Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M552.073 517.306H550.128V534.428H552.073V517.306Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M525.61 517.306H523.665V534.428H525.61V517.306Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M516.662 517.306H514.717V534.428H516.662V517.306Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M490.589 517.306H488.645V534.428H490.589V517.306Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M497.984 519.057C497.984 516.371 500.165 514.193 502.848 514.193C505.531 514.193 507.712 516.371 507.712 519.057V534.428H497.984V519.057Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M568.028 519.057C568.028 516.371 570.208 514.193 572.892 514.193C575.575 514.193 577.755 516.371 577.755 519.057V534.428H568.028V519.057Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M599.158 510.692C599.158 510.264 599.51 509.915 599.936 509.915C600.361 509.915 600.713 510.264 600.713 510.692V534.623H599.155V510.692H599.158Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M613.945 515.36C613.945 514.931 614.297 514.583 614.723 514.583C615.149 514.583 615.5 514.931 615.5 515.36V517.889H613.942V515.36H613.945Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M602.273 515.36C602.273 514.931 602.624 514.583 603.05 514.583C603.476 514.583 603.827 514.931 603.827 515.36V517.889H602.27V515.36H602.273Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M601.883 521.585C601.883 520.942 602.404 520.418 603.05 520.418C603.697 520.418 604.218 520.939 604.218 521.585V525.282H601.883V521.585Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M613.558 521.585C613.558 520.942 614.079 520.418 614.725 520.418C615.371 520.418 615.893 520.939 615.893 521.585V525.282H613.558V521.585Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M533.007 517.11C533.007 514.423 535.187 512.246 537.87 512.246C540.554 512.246 542.734 514.423 542.734 517.11V534.426H533.007V517.11Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M481.639 534.43V516.724L476.969 515.75H459.069V534.427H481.639V534.43Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M460.044 515.748L472.496 506.992L477.166 515.748H460.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M476.972 515.556L472.692 507.189L480.085 510.498L481.642 512.25V516.92L476.972 515.559V515.556Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M462.185 531.315H464.52V525.09C464.52 524.447 463.998 523.923 463.352 523.923C462.706 523.923 462.185 524.444 462.185 525.09V531.315Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M462.572 521.198H464.13V519.253C464.13 518.824 463.778 518.476 463.353 518.476C462.927 518.476 462.575 518.824 462.575 519.253V521.198H462.572Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M472.688 521.198H474.246V519.253C474.246 518.824 473.895 518.476 473.469 518.476C473.043 518.476 472.691 518.824 472.691 519.253V521.198H472.688Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M472.302 531.315H474.637V525.09C474.637 524.447 474.116 523.923 473.469 523.923C472.823 523.923 472.302 524.444 472.302 525.09V531.315Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M466.074 515.556C466.074 514.159 467.206 513.027 468.603 513.027C470 513.027 471.131 514.159 471.131 515.556V534.429H466.071V515.556H466.074Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M459.069 513.998C459.069 513.462 459.504 513.024 460.043 513.024C460.582 513.024 461.017 513.459 461.017 513.998V534.427H459.072V513.998H459.069Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M475.805 513.805C475.805 513.376 476.156 513.027 476.582 513.027C477.008 513.027 477.359 513.376 477.359 513.805V534.429H475.802V513.805H475.805Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M467.633 521.198H469.19V519.253C469.19 518.824 468.839 518.476 468.413 518.476C467.987 518.476 467.636 518.824 467.636 519.253V521.198H467.633Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M467.242 531.315H469.967V525.284C469.967 524.53 469.357 523.923 468.606 523.923C467.856 523.923 467.245 524.533 467.245 525.284V531.315H467.242Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M498.762 519.446C498.762 517.188 500.59 515.359 502.848 515.359C505.106 515.359 506.934 517.188 506.934 519.446V534.427H498.762V519.446Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M499.929 534.43H505.376V527.038C505.376 525.534 504.158 524.312 502.651 524.312C501.144 524.312 499.926 525.531 499.926 527.038V534.43H499.929Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M501.097 520.029H499.93V522.754H501.097V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M503.432 520.029H501.874V522.754H503.432V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M505.375 520.029H504.208V522.754H505.375V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M568.806 519.446C568.806 517.188 570.634 515.359 572.892 515.359C575.149 515.359 576.978 517.188 576.978 519.446V534.427H568.806V519.446Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M533.783 517.499C533.783 515.242 535.612 513.413 537.869 513.413C540.127 513.413 541.956 515.242 541.956 517.499V534.428H533.783V517.499Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M534.951 534.43H540.399V527.038C540.399 525.534 539.18 524.312 537.673 524.312C536.166 524.312 534.948 525.531 534.948 527.038V534.43H534.951Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M536.119 520.029H534.951V522.754H536.119V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M538.455 520.029H536.897V522.754H538.455V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M540.399 520.029H539.231V522.754H540.399V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M569.973 534.43H575.42V527.038C575.42 525.534 574.202 524.312 572.695 524.312C571.188 524.312 569.97 525.531 569.97 527.038V534.43H569.973Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M569.972 534.429H575.419V528.591C575.419 527.087 574.201 525.866 572.694 525.866C571.187 525.866 569.969 527.084 569.969 528.591V534.429H569.972Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M534.95 534.429H540.398V528.591C540.398 527.087 539.179 525.866 537.672 525.866C536.165 525.866 534.947 527.084 534.947 528.591V534.429H534.95Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M499.929 534.429H505.376V528.591C505.376 527.087 504.158 525.866 502.651 525.866C501.144 525.866 499.926 527.084 499.926 528.591V534.429H499.929Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M571.14 520.029H569.973V522.754H571.14V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M573.477 520.029H571.919V522.754H573.477V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M575.42 520.029H574.253V522.754H575.42V520.029Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M605.386 512.443C605.386 510.4 607.039 508.747 609.082 508.747C611.125 508.747 612.778 510.403 612.778 512.443V534.623H605.386V512.443Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M610.832 527.812H607.72V532.091H610.832V527.812Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M606.94 515.36C606.94 514.931 607.292 514.583 607.718 514.583C608.144 514.583 608.495 514.931 608.495 515.36V517.889H606.938V515.36H606.94Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M609.665 515.36C609.665 514.931 610.016 514.583 610.442 514.583C610.868 514.583 611.22 514.931 611.22 515.36V517.889H609.662V515.36H609.665Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M607.72 521.779C607.72 521.026 608.33 520.418 609.081 520.418C609.831 520.418 610.442 521.029 610.442 521.779V525.282H607.717V521.779H607.72Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M496.816 524.312H491.369V526.257H496.816V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M513.939 524.312H508.491V526.257H513.939V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M522.889 524.312H517.441V526.257H522.889V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M531.839 524.312H526.392V526.257H531.839V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M549.348 524.312H543.9V526.257H549.348V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M558.298 524.312H552.851V526.257H558.298V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M567.249 524.312H561.802V526.257H567.249V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M583.982 524.312H578.535V526.257H583.982V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M592.933 524.312H587.485V526.257H592.933V524.312Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M617.057 510.692C617.057 510.264 617.408 509.915 617.834 509.915C618.26 509.915 618.611 510.264 618.611 510.692V534.623H617.054V510.692H617.057Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M62.937 512.245H-7.49707V534.425H62.937V512.245Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M171.505 512.245H99.9033V534.425H171.505V512.245Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.882761 517.306C-0.882761 516.231 -0.0101163 515.361 1.06208 515.361C2.13427 515.361 3.00691 516.234 3.00691 517.306V520.418H-0.885742V517.306H-0.882761Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78618 517.306C3.78618 516.231 4.65883 515.361 5.73102 515.361C6.80321 515.361 7.67586 516.234 7.67586 517.306V520.418H3.7832V517.306H3.78618Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4561 517.306C8.4561 516.231 9.32874 515.361 10.4009 515.361C11.4731 515.361 12.3458 516.234 12.3458 517.306V520.418H8.45312V517.306H8.4561Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1241 517.306C13.1241 516.231 13.9967 515.361 15.0689 515.361C16.1411 515.361 17.0137 516.234 17.0137 517.306V520.418H13.1211V517.306H13.1241Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M17.794 517.306C17.794 516.231 18.6666 515.361 19.7388 515.361C20.811 515.361 21.6837 516.234 21.6837 517.306V520.418H17.791V517.306H17.794Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8545 517.306C22.8545 516.231 23.7272 515.361 24.7994 515.361C25.8716 515.361 26.7442 516.234 26.7442 517.306V520.418H22.8516V517.306H22.8545Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5245 517.306C27.5245 516.231 28.3971 515.361 29.4693 515.361C30.5415 515.361 31.4141 516.234 31.4141 517.306V520.418H27.5215V517.306H27.5245Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1934 517.306C32.1934 516.231 33.066 515.361 34.1382 515.361C35.2104 515.361 36.0831 516.234 36.0831 517.306V520.418H32.1904V517.306H32.1934Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8614 517.306C36.8614 516.231 37.734 515.361 38.8062 515.361C39.8784 515.361 40.7511 516.234 40.7511 517.306V520.418H36.8584V517.306H36.8614Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5303 517.306C41.5303 516.231 42.403 515.361 43.4752 515.361C44.5473 515.361 45.42 516.234 45.42 517.306V520.418H41.5273V517.306H41.5303Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2002 517.306C46.2002 516.231 47.0729 515.361 48.1451 515.361C49.2173 515.361 50.0899 516.234 50.0899 517.306V520.418H46.1973V517.306H46.2002Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8711 517.306C50.8711 516.231 51.7438 515.361 52.816 515.361C53.8882 515.361 54.7608 516.234 54.7608 517.306V520.418H50.8682V517.306H50.8711Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5411 517.306C55.5411 516.231 56.4137 515.361 57.4859 515.361C58.5581 515.361 59.4307 516.234 59.4307 517.306V520.418H55.5381V517.306H55.5411Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M60.212 517.306C60.212 516.231 61.0846 515.361 62.1568 515.361C63.229 515.361 64.1016 516.234 64.1016 517.306V520.418H60.209V517.306H60.212Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M100.29 517.306C100.29 516.231 101.163 515.361 102.235 515.361C103.307 515.361 104.18 516.234 104.18 517.306V520.418H100.287V517.306H100.29Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M104.96 517.306C104.96 516.231 105.833 515.361 106.905 515.361C107.977 515.361 108.85 516.234 108.85 517.306V520.418H104.957V517.306H104.96Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M109.631 517.306C109.631 516.231 110.504 515.361 111.576 515.361C112.648 515.361 113.521 516.234 113.521 517.306V520.418H109.628V517.306H109.631Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8426 502.127H69.5479V512.244H94.8426V502.127Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M114.3 517.306C114.3 516.231 115.173 515.361 116.245 515.361C117.317 515.361 118.19 516.234 118.19 517.306V520.418H114.297V517.306H114.3Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M118.97 517.306C118.97 516.231 119.842 515.361 120.915 515.361C121.987 515.361 122.859 516.234 122.859 517.306V520.418H118.967V517.306H118.97Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M123.639 517.306C123.639 516.231 124.511 515.361 125.584 515.361C126.656 515.361 127.528 516.234 127.528 517.306V520.418H123.636V517.306H123.639Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M128.697 517.306C128.697 516.231 129.57 515.361 130.642 515.361C131.714 515.361 132.587 516.234 132.587 517.306V520.418H128.694V517.306H128.697Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M133.367 517.306C133.367 516.231 134.24 515.361 135.312 515.361C136.384 515.361 137.257 516.234 137.257 517.306V520.418H133.364V517.306H133.367Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M138.037 517.306C138.037 516.231 138.91 515.361 139.982 515.361C141.054 515.361 141.927 516.234 141.927 517.306V520.418H138.034V517.306H138.037Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M142.707 517.306C142.707 516.231 143.58 515.361 144.652 515.361C145.724 515.361 146.597 516.234 146.597 517.306V520.418H142.704V517.306H142.707Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M147.374 517.306C147.374 516.231 148.247 515.361 149.319 515.361C150.391 515.361 151.264 516.234 151.264 517.306V520.418H147.371V517.306H147.374Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M152.044 517.306C152.044 516.231 152.917 515.361 153.989 515.361C155.061 515.361 155.934 516.234 155.934 517.306V520.418H152.041V517.306H152.044Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M156.714 517.306C156.714 516.231 157.587 515.361 158.659 515.361C159.731 515.361 160.604 516.234 160.604 517.306V520.418H156.711V517.306H156.714Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M161.384 517.306C161.384 516.231 162.256 515.361 163.329 515.361C164.401 515.361 165.274 516.234 165.274 517.306V520.418H161.381V517.306H161.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M166.054 517.306C166.054 516.231 166.926 515.361 167.999 515.361C169.071 515.361 169.943 516.234 169.943 517.306V520.418H166.051V517.306H166.054Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3281 507.771C70.3281 506.589 71.2871 505.63 72.4695 505.63C73.6519 505.63 74.6109 506.589 74.6109 507.771V511.08H70.3311V507.771H70.3281Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3857 507.771C75.3857 506.589 76.3448 505.63 77.5271 505.63C78.7095 505.63 79.6686 506.589 79.6686 507.771V511.08H75.3887V507.771H75.3857Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M79.665 507.771C79.665 506.589 80.6241 505.63 81.8064 505.63C82.9888 505.63 83.9479 506.589 83.9479 507.771V511.08H79.668V507.771H79.665Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7256 507.771C84.7256 506.589 85.6846 505.63 86.867 505.63C88.0494 505.63 89.0084 506.589 89.0084 507.771V511.08H84.7286V507.771H84.7256Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0059 507.771C89.0059 506.589 89.9649 505.63 91.1473 505.63C92.3297 505.63 93.2887 506.589 93.2887 507.771V511.08H89.0088V507.771H89.0059Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4474 489.677H76.5527V502.129H87.4474V489.677Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0582 490.843H77.333V500.57H80.0582V490.843Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5582 490.843H80.833V500.57H83.5582V490.843Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6709 490.843H84.3359V500.57H86.6709V490.843Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0582 490.843H77.333V491.62H80.0582V490.843Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5582 490.843H80.833V491.62H83.5582V490.843Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8064 485.786C82.1281 485.786 82.3901 486.048 82.3901 486.37V487.928C82.3901 488.249 82.1281 488.511 81.8064 488.511C81.4848 488.511 81.2227 488.249 81.2227 487.928V486.37C81.2227 486.048 81.4848 485.786 81.8064 485.786Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5527 486.37C76.5527 486.048 76.8148 485.786 77.1365 485.786C77.4581 485.786 77.7202 486.048 77.7202 486.37V487.147C77.7202 487.832 77.2139 488.401 76.5527 488.496V486.37Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2832 486.37C86.2832 486.048 86.5453 485.786 86.867 485.786C87.1886 485.786 87.4507 486.048 87.4507 486.37V488.496C86.7895 488.401 86.2832 487.835 86.2832 487.147V486.37Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6709 490.843H84.3359V491.62H86.6709V490.843Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7834 500.573H74.2188V502.131H89.7834V500.573Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4976 509.132H76.5527V511.077H78.4976V509.132Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67925 510.302H4.9541V512.247H7.67925V510.302Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5845 510.302H29.8594V512.247H32.5845V510.302Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4879 510.302H54.7627V512.247H57.4879V510.302Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M109.244 510.302H106.519V512.247H109.244V510.302Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 510.302H131.423V512.247H134.148V510.302Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M159.052 510.302H156.327V512.247H159.052V510.302Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92605 508.356H6.7034C7.23949 508.356 7.6773 508.791 7.6773 509.33C7.6773 509.866 7.24247 510.304 6.7034 510.304H5.92605C5.38996 510.304 4.95215 509.869 4.95215 509.33C4.95215 508.794 5.38698 508.356 5.92605 508.356Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8294 508.356H31.6067C32.1428 508.356 32.5806 508.791 32.5806 509.33C32.5806 509.866 32.1458 510.304 31.6067 510.304H30.8294C30.2933 510.304 29.8555 509.869 29.8555 509.33C29.8555 508.794 30.2903 508.356 30.8294 508.356Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7337 508.356H56.511C57.0471 508.356 57.4849 508.791 57.4849 509.33C57.4849 509.866 57.0501 510.304 56.511 510.304H55.7337C55.1976 510.304 54.7598 509.869 54.7598 509.33C54.7598 508.794 55.1946 508.356 55.7337 508.356Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M107.49 508.356H108.267C108.803 508.356 109.241 508.791 109.241 509.33C109.241 509.866 108.806 510.304 108.267 510.304H107.49C106.953 510.304 106.516 509.869 106.516 509.33C106.516 508.794 106.95 508.356 107.49 508.356Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M132.394 508.356H133.171C133.707 508.356 134.145 508.791 134.145 509.33C134.145 509.866 133.71 510.304 133.171 510.304H132.394C131.858 510.304 131.42 509.869 131.42 509.33C131.42 508.794 131.855 508.356 132.394 508.356Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M157.298 508.356H158.075C158.612 508.356 159.049 508.791 159.049 509.33C159.049 509.866 158.615 510.304 158.075 510.304H157.298C156.762 510.304 156.324 509.869 156.324 509.33C156.324 508.794 156.759 508.356 157.298 508.356Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7779 509.132H80.833V511.077H82.7779V509.132Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8374 509.132H85.8926V511.077H87.8374V509.132Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4474 488.899H76.5527V489.677H87.4474V488.899Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1158 474.111H78.501V489.676H85.1158V474.111Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7252 465.552H78.8877V474.111H84.7252V465.552Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7131 465.551C84.6148 464.675 83.8732 463.993 82.9737 463.993H80.6387C79.7363 463.993 78.9947 464.675 78.8994 465.551H84.716H84.7131Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M80.835 463.994L81.2192 430.14H82.0025L82.3866 463.994H80.835Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6123 425.47V430.14",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.66016 531.313H1.45218V534.426H-1.66016V531.313Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39648 531.313H6.50882V534.426H3.39648V531.313Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45703 531.313H11.5694V534.426H8.45703V531.313Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5127 531.313H16.625V534.426H13.5127V531.313Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1836 531.313H21.2959V534.426H18.1836V531.313Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1836 531.313H21.2959V534.426H18.1836V531.313Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0205 530.535H25.5782V534.428H24.0205V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3008 530.535H30.6358V534.428H28.3008V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3584 530.535H35.3032V534.428H33.3584V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0283 530.535H39.9731V534.428H38.0283V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0889 530.535H45.0337V534.428H43.0889V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7588 530.535H50.0938V534.428H47.7588V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4287 530.535H54.7637V534.428H52.4287V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0957 530.535H59.4307V534.428H57.0957V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3789 530.535H62.9366V534.428H61.3789V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M100.682 530.535H102.239V534.428H100.682V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M104.961 530.535H107.296V534.428H104.961V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M110.021 530.535H111.965V534.428H110.021V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M114.688 530.535H116.633V534.428H114.688V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M119.747 530.535H121.692V534.428H119.747V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M124.026 530.535H126.361V534.428H124.026V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M128.697 530.535H131.032V534.428H128.697V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M133.758 530.535H136.093V534.428H133.758V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M138.814 530.535H140.372V534.428H138.814V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M142.708 530.535H145.433V534.428H142.708V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M148.154 530.535H150.489V534.428H148.154V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M152.824 530.535H155.549V534.428H152.824V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M157.882 530.535H160.607V534.428H157.882V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M162.941 530.535H165.667V534.428H162.941V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M167.611 530.535H170.336V534.428H167.611V530.535Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.0498 523.144H1.84285V528.204H-2.0498V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61816 523.144H6.51081V528.204H2.61816V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56445 517.692H6.89945V520.418H4.56445V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23438 517.692H11.5694V520.418H9.23438V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M14.291 517.692H16.2359V520.418H14.291V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9609 517.692H20.9058V520.418H18.9609V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0205 517.692H25.9653V520.418H24.0205V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6914 517.692H30.6362V520.418H28.6914V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3584 517.692H35.3032V520.418H33.3584V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0283 517.692H39.9731V520.418H38.0283V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6992 517.692H44.644V520.418H42.6992V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 517.692H49.314V520.418H47.3691V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0381 517.692H53.9829V520.418H52.0381V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M56.71 517.692H58.6548V520.418H56.71V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 517.692H62.9331V520.418H60.9883V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M101.069 517.692H103.404V520.418H101.069V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M105.737 517.692H108.072V520.418H105.737V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M110.798 517.692H112.743V520.418H110.798V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M115.467 517.692H117.412V520.418H115.467V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M120.138 517.692H122.083V520.418H120.138V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M124.805 517.692H126.75V520.418H124.805V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M129.864 517.692H131.809V520.418H129.864V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M134.535 517.692H136.48V520.418H134.535V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M139.205 517.692H141.15V520.418H139.205V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M143.875 517.692H145.82V520.418H143.875V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M148.542 517.692H150.487V520.418H148.542V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M153.211 517.692H155.156V520.418H153.211V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M157.494 517.692H159.439V520.418H157.494V517.692Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45703 523.144H12.3497V528.204H8.45703V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 523.144H17.0177V528.204H13.125V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M17.793 523.144H21.6856V528.204H17.793V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8555 523.144H26.7481V528.204H22.8555V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5244 523.144H31.4171V528.204H27.5244V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1934 523.144H36.086V528.204H32.1934V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8604 523.144H40.753V528.204H36.8604V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5312 523.144H45.4239V528.204H41.5312V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2002 523.144H50.0928V528.204H46.2002V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8701 523.144H54.7628V528.204H50.8701V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M55.541 523.144H59.4337V528.204H55.541V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2109 523.144H62.9361V528.204H60.2109V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9033 523.144H103.796V528.204H99.9033V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M104.569 523.144H108.462V528.204H104.569V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M109.24 523.144H113.133V528.204H109.24V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M115.077 523.144H118.97V528.204H115.077V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M119.747 523.144H123.64V528.204H119.747V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M124.418 523.144H128.311V528.204H124.418V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M129.476 523.144H133.368V528.204H129.476V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M134.145 523.144H138.037V528.204H134.145V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M138.814 523.144H142.707V528.204H138.814V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M195.239 518.475H171.502V534.039H195.239V518.475Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M143.483 523.144H147.376V528.204H143.483V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M148.154 523.144H152.047V528.204H148.154V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M152.824 523.144H156.717V528.204H152.824V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M157.494 523.144H161.387V528.204H157.494V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M162.161 523.144H166.054V528.204H162.161V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M166.833 523.144H170.726V528.204H166.833V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M172.277 523.144H176.17V528.204H172.277V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M176.948 523.144H180.841V528.204H176.948V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M181.618 523.144H185.511V528.204H181.618V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M186.289 523.144H190.182V528.204H186.289V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M190.959 523.144H194.852V528.204H190.959V523.144Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M195.239 518.475H171.502V534.039H195.239V518.475Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M195.239 518.475H171.502V520.419H195.239V518.475Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8064 482.673C82.9891 482.673 83.9479 481.715 83.9479 480.532C83.9479 479.349 82.9891 478.391 81.8064 478.391C80.6238 478.391 79.665 479.349 79.665 480.532C79.665 481.715 80.6238 482.673 81.8064 482.673Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8076 481.31C82.2369 481.31 82.585 480.962 82.585 480.532C82.585 480.103 82.2369 479.755 81.8076 479.755C81.3783 479.755 81.0303 480.103 81.0303 480.532C81.0303 480.962 81.3783 481.31 81.8076 481.31Z",
    fill: "white"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5271 508.352C78.2788 508.352 78.8882 507.743 78.8882 506.991C78.8882 506.239 78.2788 505.63 77.5271 505.63C76.7754 505.63 76.166 506.239 76.166 506.991C76.166 507.743 76.7754 508.352 77.5271 508.352Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8064 508.352C82.5581 508.352 83.1675 507.743 83.1675 506.991C83.1675 506.239 82.5581 505.63 81.8064 505.63C81.0547 505.63 80.4453 506.239 80.4453 506.991C80.4453 507.743 81.0547 508.352 81.8064 508.352Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8679 508.352C87.6196 508.352 88.229 507.743 88.229 506.991C88.229 506.239 87.6196 505.63 86.8679 505.63C86.1162 505.63 85.5068 506.239 85.5068 506.991C85.5068 507.743 86.1162 508.352 86.8679 508.352Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6128 421.624L82.1697 423.34L82.2144 423.474H84.1592L82.6998 424.534L82.5867 424.617L82.6313 424.751L83.1883 426.467L81.7289 425.406L81.6157 425.323L81.5026 425.406L80.0432 426.467L80.6001 424.751L80.6448 424.617L80.5316 424.534L79.0723 423.474H81.0171L81.0618 423.34L81.6187 421.624H81.6128Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5576 466.718H82.7803V469.053H83.5576V466.718Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4424 466.718H79.665V469.053H80.4424V466.718Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1748 525.478H6.50981V528.203H4.1748V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23438 525.478H11.5694V528.203H9.23438V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M14.291 525.478H16.2359V528.203H14.291V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9609 525.478H20.9058V528.203H18.9609V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0205 525.478H25.9653V528.203H24.0205V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6924 525.478H30.6372V528.203H28.6924V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3584 525.478H35.3032V528.203H33.3584V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0283 525.478H39.9731V528.203H38.0283V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6992 525.478H44.644V528.203H42.6992V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 525.478H49.314V528.203H47.3691V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0381 525.478H53.9829V528.203H52.0381V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M56.71 525.478H58.6548V528.203H56.71V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9883 525.478H62.9331V528.203H60.9883V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M101.069 525.478H103.404V528.203H101.069V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M105.737 525.478H108.072V528.203H105.737V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M110.798 525.478H112.743V528.203H110.798V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M115.467 525.478H117.412V528.203H115.467V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M120.138 525.478H122.083V528.203H120.138V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M124.805 525.478H126.75V528.203H124.805V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M129.864 525.478H131.809V528.203H129.864V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M134.535 525.478H136.48V528.203H134.535V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M139.205 525.478H141.15V528.203H139.205V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M143.875 525.478H145.82V528.203H143.875V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M148.542 525.478H150.487V528.203H148.542V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M153.211 525.478H155.156V528.203H153.211V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M157.494 525.478H159.439V528.203H157.494V525.478Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8994 512.245H62.9326V534.425H99.8994V512.245Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9385 519.64C69.9385 518.136 71.1566 516.915 72.6636 516.915C74.1707 516.915 75.3888 518.133 75.3888 519.64V528.2H69.9415V519.64H69.9385Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2783 519.64C79.2783 518.136 80.4964 516.915 82.0035 516.915C83.5105 516.915 84.7286 518.133 84.7286 519.64V528.2H79.2813V519.64H79.2783Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0059 519.64C89.0059 518.136 90.224 516.915 91.731 516.915C93.238 516.915 94.4562 518.133 94.4562 519.64V528.2H89.0088V519.64H89.0059Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9004 528.201H62.9336V534.426H99.9004V528.201Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9004 528.201H62.9336V528.979H99.9004V528.201Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8994 529.758H62.9326V530.535H99.8994V529.758Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9004 531.313H62.9336V532.091H99.9004V531.313Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8994 532.87H62.9326V533.647H99.8994V532.87Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M171.502 512.245H-7.49707V513.803H171.502V512.245Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M171.502 512.245H102.626V513.803H171.502V512.245Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3242 512.245H-7.49707V513.803H63.3242V512.245Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9405 516.525H66.0479V528.2H69.9405V516.525Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2784 516.525H75.3857V528.2H79.2784V516.525Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0054 516.525H84.7256V528.2H89.0054V516.525Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M98.733 516.525H94.4531V528.2H98.733V516.525Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5083 522.363H90.5635V528.201H92.5083V522.363Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1675 522.363H81.2227V528.201H83.1675V522.363Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4409 522.363H71.4961V528.201H73.4409V522.363Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7971 519.64C68.335 519.64 68.7711 519.204 68.7711 518.666C68.7711 518.128 68.335 517.692 67.7971 517.692C67.2593 517.692 66.8232 518.128 66.8232 518.666C66.8232 519.204 67.2593 519.64 67.7971 519.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7971 522.753C68.335 522.753 68.7711 522.316 68.7711 521.779C68.7711 521.241 68.335 520.805 67.7971 520.805C67.2593 520.805 66.8232 521.241 66.8232 521.779C66.8232 522.316 67.2593 522.753 67.7971 522.753Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7971 525.87C68.335 525.87 68.7711 525.434 68.7711 524.896C68.7711 524.358 68.335 523.922 67.7971 523.922C67.2593 523.922 66.8232 524.358 66.8232 524.896C66.8232 525.434 67.2593 525.87 67.7971 525.87Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M77.136 519.64C77.6739 519.64 78.1099 519.204 78.1099 518.666C78.1099 518.128 77.6739 517.692 77.136 517.692C76.5981 517.692 76.1621 518.128 76.1621 518.666C76.1621 519.204 76.5981 519.64 77.136 519.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M77.136 522.753C77.6739 522.753 78.1099 522.316 78.1099 521.779C78.1099 521.241 77.6739 520.805 77.136 520.805C76.5981 520.805 76.1621 521.241 76.1621 521.779C76.1621 522.316 76.5981 522.753 77.136 522.753Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M77.136 525.87C77.6739 525.87 78.1099 525.434 78.1099 524.896C78.1099 524.358 77.6739 523.922 77.136 523.922C76.5981 523.922 76.1621 524.358 76.1621 524.896C76.1621 525.434 76.5981 525.87 77.136 525.87Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8665 519.64C87.4044 519.64 87.8404 519.204 87.8404 518.666C87.8404 518.128 87.4044 517.692 86.8665 517.692C86.3286 517.692 85.8926 518.128 85.8926 518.666C85.8926 519.204 86.3286 519.64 86.8665 519.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8665 522.753C87.4044 522.753 87.8404 522.316 87.8404 521.779C87.8404 521.241 87.4044 520.805 86.8665 520.805C86.3286 520.805 85.8926 521.241 85.8926 521.779C85.8926 522.316 86.3286 522.753 86.8665 522.753Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8665 525.87C87.4044 525.87 87.8404 525.434 87.8404 524.896C87.8404 524.358 87.4044 523.922 86.8665 523.922C86.3286 523.922 85.8926 524.358 85.8926 524.896C85.8926 525.434 86.3286 525.87 86.8665 525.87Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M96.594 519.64C97.1319 519.64 97.5679 519.204 97.5679 518.666C97.5679 518.128 97.1319 517.692 96.594 517.692C96.0561 517.692 95.6201 518.128 95.6201 518.666C95.6201 519.204 96.0561 519.64 96.594 519.64Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M96.594 522.753C97.1319 522.753 97.5679 522.316 97.5679 521.779C97.5679 521.241 97.1319 520.805 96.594 520.805C96.0561 520.805 95.6201 521.241 95.6201 521.779C95.6201 522.316 96.0561 522.753 96.594 522.753Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M96.594 525.87C97.1319 525.87 97.5679 525.434 97.5679 524.896C97.5679 524.358 97.1319 523.922 96.594 523.922C96.0561 523.922 95.6201 524.358 95.6201 524.896C95.6201 525.434 96.0561 525.87 96.594 525.87Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3848 518.276C75.3848 518.598 75.1376 518.937 74.6342 519.205C74.1399 519.47 73.4429 519.637 72.6626 519.637C71.8823 519.637 71.1854 519.467 70.691 519.205C70.1876 518.937 69.9404 518.601 69.9404 518.276C69.9404 517.951 70.1876 517.615 70.691 517.347C71.1854 517.082 71.8823 516.915 72.6626 516.915C73.4429 516.915 74.1399 517.085 74.6342 517.347C75.1376 517.615 75.3848 517.951 75.3848 518.276Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7256 518.276C84.7256 518.598 84.4784 518.937 83.9751 519.205C83.4807 519.47 82.7837 519.637 82.0034 519.637C81.2231 519.637 80.5262 519.467 80.0318 519.205C79.5285 518.937 79.2812 518.601 79.2812 518.276C79.2812 517.951 79.5285 517.615 80.0318 517.347C80.5262 517.082 81.2231 516.915 82.0034 516.915C82.7837 516.915 83.4807 517.085 83.9751 517.347C84.4784 517.615 84.7256 517.951 84.7256 518.276Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4531 518.276C94.4531 518.598 94.2059 518.937 93.7026 519.205C93.2082 519.47 92.5113 519.637 91.731 519.637C90.9507 519.637 90.2537 519.467 89.7593 519.205C89.256 518.937 89.0088 518.601 89.0088 518.276C89.0088 517.951 89.256 517.615 89.7593 517.347C90.2537 517.082 90.9507 516.915 91.731 516.915C92.5113 516.915 93.2082 517.085 93.7026 517.347C94.2059 517.615 94.4531 517.951 94.4531 518.276Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5645 488.898C76.6628 488.023 77.4044 487.341 78.3038 487.341H85.696C86.5984 487.341 87.34 488.023 87.4353 488.898H76.5615H76.5645Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4266 474.111L76.2852 469.831H87.3287L85.1873 474.111H78.4236H78.4266Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4424 471H79.665V473.335H80.4424V471Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M82 471H81.2227V473.335H82V471Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5576 471H82.7803V473.335H83.5576V471Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2188 499.599C74.2188 499.278 74.4808 499.016 74.8025 499.016C75.1242 499.016 75.3863 499.278 75.3863 499.599V500.377C75.3863 501.062 74.8799 501.631 74.2188 501.726V499.599Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6182 499.599C88.6182 499.278 88.8802 499.016 89.2019 499.016C89.5236 499.016 89.7857 499.278 89.7857 499.599V501.726C89.1245 501.631 88.6182 501.065 88.6182 500.377V499.599Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.59 504.853H940.817V534.037H1013.59V504.853Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.59 525.089H940.817V534.039H1013.59V525.089Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M945.877 510.69H944.319V514.583H945.877V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.72 506.992H938.676V508.16H1015.72V506.992Z",
    fill: "#615E66"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M945.877 518.861H944.319V522.754H945.877V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M946.266 527.033H942.373V534.038H946.266V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M955.604 527.033H949.767V534.038H955.604V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M964.165 527.033H958.327V534.038H964.165V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M972.727 527.033H966.89V534.038H972.727V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M974.672 528.394C974.672 526.997 975.804 525.865 977.201 525.865C978.597 525.865 979.729 526.997 979.729 528.394V534.038H974.669V528.394H974.672Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M987.514 527.033H981.677V534.038H987.514V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M996.075 527.033H990.237V534.038H996.075V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.02 527.033H999.187V534.038H1005.02V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.64 527.033H1008.14V534.038H1011.64V527.033Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M946.266 528.201H942.373V534.039H946.266V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M955.604 528.201H949.767V534.039H955.604V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M964.165 528.201H958.327V534.039H964.165V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M972.727 528.201H966.89V534.039H972.727V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M974.672 529.562C974.672 528.165 975.804 527.033 977.201 527.033C978.597 527.033 979.729 528.165 979.729 529.562V534.038H974.669V529.562H974.672Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M987.514 528.201H981.677V534.039H987.514V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M996.075 528.201H990.237V534.039H996.075V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M1005.02 528.201H999.187V534.039H1005.02V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.64 528.201H1008.14V534.039H1011.64V528.201Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M952.492 510.69H950.935V514.583H952.492V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M952.492 518.861H950.935V522.754H952.492V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M956.772 510.69H955.215V514.583H956.772V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M956.772 518.861H955.215V522.754H956.772V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M961.052 510.69H959.494V514.583H961.052V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M961.052 518.861H959.494V522.754H961.052V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M964.944 510.69H963.387V514.583H964.944V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M964.944 518.861H963.387V522.754H964.944V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M969.614 510.69H968.057V514.583H969.614V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M969.614 518.861H968.057V522.754H969.614V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M973.504 510.69H971.946V514.583H973.504V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M973.504 518.861H971.946V522.754H973.504V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M978.175 510.69H976.617V514.583H978.175V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M978.175 518.861H976.617V522.754H978.175V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M982.845 510.69H981.287V514.583H982.845V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M982.845 518.861H981.287V522.754H982.845V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M987.125 510.69H985.567V514.583H987.125V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M987.125 518.861H985.567V522.754H987.125V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M991.017 510.69H989.459V514.583H991.017V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M991.017 518.861H989.459V522.754H991.017V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M995.684 510.69H994.126V514.583H995.684V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M995.684 518.861H994.126V522.754H995.684V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M999.966 510.69H998.408V514.583H999.966V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M999.966 518.861H998.408V522.754H999.966V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.86 510.69H1002.3V514.583H1003.86V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.86 518.861H1002.3V522.754H1003.86V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.08 510.69H1008.53V514.583H1010.08V510.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.08 518.861H1008.53V522.754H1010.08V518.861Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.75 504.853H939.65V507.188H1014.75V504.853Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M947.432 505.63H940.817V506.407H947.432V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M956.769 505.63H950.154V506.407H956.769V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M966.109 505.63H959.494V506.407H966.109V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M975.45 505.63H968.835V506.407H975.45V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M984.79 505.63H978.175V506.407H984.79V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M994.127 505.63H987.512V506.407H994.127V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.47 505.63H996.852V506.407H1003.47V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.81 505.63H1006.19V506.407H1012.81V505.63Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M979.884 503.103L979.502 503.18L979.565 503.493H979.884V503.103ZM981.48 503.103H981.87V502.713H981.48V503.103ZM981.48 505.048V505.438H981.87V505.048H981.48ZM973.698 505.048H973.308V505.438H973.698V505.048ZM973.698 503.103V502.713H973.308V503.103H973.698ZM975.294 503.103V503.493H975.613L975.675 503.18L975.294 503.103ZM979.884 503.493H981.48V502.716H979.884V503.493ZM981.093 503.103V505.048H981.87V503.103H981.093ZM981.48 504.658H973.698V505.435H981.48V504.658ZM974.088 505.048V503.103H973.311V505.048H974.088ZM973.698 503.493H975.294V502.716H973.698V503.493ZM975.675 503.18C975.818 502.472 976.45 501.936 977.2 501.936V501.158C976.071 501.158 975.13 501.959 974.913 503.026L975.675 503.18ZM977.2 501.936H977.978V501.158H977.2V501.936ZM977.978 501.936C978.728 501.936 979.359 502.472 979.502 503.18L980.265 503.026C980.047 501.959 979.106 501.158 977.978 501.158V501.936Z",
    fill: "#615E66"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M979.884 503.103H981.481V505.047H973.698V503.103H975.295C975.473 502.215 976.26 501.545 977.201 501.545H977.978C978.919 501.545 979.705 502.212 979.884 503.103Z",
    fill: "white"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.1 516.139H1013.58V534.038H1045.1V516.139Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.1 527.811H1013.58V534.035H1045.1V527.811Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.59 530.146H1017.86V534.038H1020.59V530.146Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.65 530.146H1022.92V534.038H1025.65V530.146Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.49 530.146H1028.76V534.038H1031.49V530.146Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.54 530.146H1033.82V534.038H1036.54V530.146Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.99 530.146H1039.27V534.038H1041.99V530.146Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.59 520.028H1017.86V525.866H1020.59V520.028Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.65 520.028H1022.92V525.866H1025.65V520.028Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.49 520.028H1028.76V525.866H1031.49V520.028Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.54 520.028H1033.82V525.866H1036.54V520.028Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.1 525.479H1019.81V527.814H1038.1V525.479Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.99 520.028H1039.27V525.866H1041.99V520.028Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.34 508.381L1014.2 516.139H1044.5L1029.35 508.381H1029.34Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.42 517.306L1011.44 516.332L1029.53 506.799L1047.04 516.332L1046.27 517.306L1029.53 508.356L1012.41 517.306H1012.42Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.39 529.434H1021.17V530.729H1017.28V529.434H1018.07C1018.13 528.85 1018.63 528.397 1019.22 528.397C1019.82 528.397 1020.32 528.85 1020.38 529.434H1020.39Z",
    fill: "#E8CD9C"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.39 529.434L1020 529.475L1020.04 529.821H1020.39V529.431V529.434ZM1021.17 529.434H1021.56V529.043H1021.17V529.434ZM1021.17 530.729V531.119H1021.56V530.729H1021.17ZM1017.28 530.729H1016.89V531.119H1017.28V530.729ZM1017.28 529.434V529.043H1016.89V529.434H1017.28ZM1018.07 529.434V529.824H1018.41L1018.45 529.478L1018.07 529.436V529.434ZM1020.39 529.824H1021.17V529.046H1020.39V529.824ZM1020.78 529.434V530.729H1021.56V529.434H1020.78ZM1021.17 530.342H1017.28V531.119H1021.17V530.342ZM1017.67 530.729V529.434H1016.89V530.729H1017.67ZM1017.28 529.824H1018.07V529.046H1017.28V529.824ZM1018.45 529.475C1018.49 529.085 1018.83 528.784 1019.23 528.784V528.007C1018.43 528.007 1017.77 528.611 1017.68 529.392L1018.45 529.478V529.475ZM1019.23 528.784C1019.63 528.784 1019.96 529.088 1020 529.475L1020.78 529.389C1020.69 528.611 1020.03 528.004 1019.23 528.004V528.781V528.784Z",
    fill: "#615E66"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1025.45 529.434H1026.23V530.729H1022.34V529.434H1023.13C1023.19 528.85 1023.69 528.397 1024.28 528.397C1024.88 528.397 1025.38 528.85 1025.44 529.434H1025.45Z",
    fill: "#E8CD9C"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.45 529.434L1025.06 529.475L1025.1 529.821H1025.45V529.431V529.434ZM1026.23 529.434H1026.62V529.043H1026.23V529.434ZM1026.23 530.729V531.119H1026.62V530.729H1026.23ZM1022.34 530.729H1021.95V531.119H1022.34V530.729ZM1022.34 529.434V529.043H1021.95V529.434H1022.34ZM1023.13 529.434V529.824H1023.47L1023.51 529.478L1023.13 529.436V529.434ZM1025.45 529.824H1026.23V529.046H1025.45V529.824ZM1025.84 529.434V530.729H1026.62V529.434H1025.84ZM1026.23 530.342H1022.34V531.119H1026.23V530.342ZM1022.73 530.729V529.434H1021.95V530.729H1022.73ZM1022.34 529.824H1023.13V529.046H1022.34V529.824ZM1023.51 529.475C1023.55 529.085 1023.88 528.784 1024.28 528.784V528.007C1023.48 528.007 1022.82 528.611 1022.74 529.392L1023.51 529.478V529.475ZM1024.28 528.784C1024.69 528.784 1025.02 529.088 1025.06 529.475L1025.83 529.389C1025.74 528.611 1025.09 528.004 1024.28 528.004V528.781V528.784Z",
    fill: "#615E66"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1031.28 529.434H1032.07V530.729H1028.17V529.434H1028.96C1029.02 528.85 1029.52 528.397 1030.12 528.397C1030.72 528.397 1031.21 528.85 1031.28 529.434H1031.28Z",
    fill: "#E8CD9C"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.28 529.434L1030.9 529.475L1030.94 529.821H1031.28V529.431V529.434ZM1032.07 529.434H1032.46V529.043H1032.07V529.434ZM1032.07 530.729V531.119H1032.46V530.729H1032.07ZM1028.18 530.729H1027.79V531.119H1028.18V530.729ZM1028.18 529.434V529.043H1027.79V529.434H1028.18ZM1028.96 529.434V529.824H1029.31L1029.35 529.478L1028.96 529.436V529.434ZM1031.28 529.824H1032.07V529.046H1031.28V529.824ZM1031.68 529.434V530.729H1032.46V529.434H1031.68ZM1032.07 530.342H1028.17V531.119H1032.07V530.342ZM1028.56 530.729V529.434H1027.79V530.729H1028.56ZM1028.18 529.824H1028.96V529.046H1028.18V529.824ZM1029.35 529.475C1029.39 529.085 1029.72 528.784 1030.12 528.784V528.007C1029.32 528.007 1028.66 528.611 1028.57 529.392L1029.35 529.478V529.475ZM1030.12 528.784C1030.52 528.784 1030.85 529.088 1030.9 529.475L1031.67 529.389C1031.58 528.611 1030.92 528.004 1030.12 528.004V528.781V528.784Z",
    fill: "#615E66"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1036.34 529.434H1037.13V530.729H1033.23V529.434H1034.02C1034.08 528.85 1034.58 528.397 1035.18 528.397C1035.78 528.397 1036.28 528.85 1036.34 529.434H1036.34Z",
    fill: "#E8CD9C"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.34 529.434L1035.96 529.475L1036 529.821H1036.34V529.431V529.434ZM1037.13 529.434H1037.52V529.043H1037.13V529.434ZM1037.13 530.729V531.119H1037.52V530.729H1037.13ZM1033.23 530.729H1032.84V531.119H1033.23V530.729ZM1033.23 529.434V529.043H1032.84V529.434H1033.23ZM1034.02 529.434V529.824H1034.37L1034.41 529.478L1034.02 529.436V529.434ZM1036.34 529.824H1037.13V529.046H1036.34V529.824ZM1036.74 529.434V530.729H1037.51V529.434H1036.74ZM1037.13 530.342H1033.23V531.119H1037.13V530.342ZM1033.63 530.729V529.434H1032.85V530.729H1033.63ZM1033.23 529.824H1034.02V529.046H1033.23V529.824ZM1034.41 529.475C1034.45 529.085 1034.78 528.784 1035.18 528.784V528.007C1034.38 528.007 1033.72 528.611 1033.63 529.392L1034.41 529.478V529.475ZM1035.18 528.784C1035.58 528.784 1035.92 529.088 1035.96 529.475L1036.73 529.389C1036.64 528.611 1035.98 528.004 1035.18 528.004V528.781V528.784Z",
    fill: "#615E66"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1041.79 529.434H1042.57V530.729H1038.68V529.434H1039.47C1039.53 528.85 1040.03 528.397 1040.63 528.397C1041.23 528.397 1041.72 528.85 1041.79 529.434H1041.79Z",
    fill: "#E8CD9C"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.79 529.434L1041.4 529.475L1041.44 529.821H1041.79V529.431V529.434ZM1042.57 529.434H1042.96V529.043H1042.57V529.434ZM1042.57 530.729V531.119H1042.96V530.729H1042.57ZM1038.68 530.729H1038.29V531.119H1038.68V530.729ZM1038.68 529.434V529.043H1038.29V529.434H1038.68ZM1039.47 529.434V529.824H1039.81L1039.85 529.478L1039.47 529.436V529.434ZM1041.79 529.824H1042.57V529.046H1041.79V529.824ZM1042.18 529.434V530.729H1042.96V529.434H1042.18ZM1042.57 530.342H1038.68V531.119H1042.57V530.342ZM1039.07 530.729V529.434H1038.29V530.729H1039.07ZM1038.68 529.824H1039.47V529.046H1038.68V529.824ZM1039.85 529.475C1039.9 529.085 1040.23 528.784 1040.63 528.784V528.007C1039.83 528.007 1039.17 528.611 1039.08 529.392L1039.85 529.478V529.475ZM1040.63 528.784C1041.03 528.784 1041.36 529.088 1041.4 529.475L1042.18 529.389C1042.09 528.611 1041.43 528.004 1040.63 528.004V528.781V528.784Z",
    fill: "#615E66"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.98 518.276C1020.98 518.312 1020.96 518.368 1020.89 518.437C1020.81 518.508 1020.7 518.58 1020.53 518.645C1020.21 518.776 1019.75 518.86 1019.23 518.86C1018.71 518.86 1018.25 518.776 1017.92 518.645C1017.76 518.58 1017.64 518.508 1017.57 518.437C1017.49 518.365 1017.48 518.312 1017.48 518.276C1017.48 518.24 1017.5 518.184 1017.57 518.115C1017.64 518.044 1017.76 517.972 1017.92 517.907C1018.24 517.776 1018.71 517.692 1019.23 517.692C1019.75 517.692 1020.21 517.776 1020.53 517.907C1020.7 517.972 1020.81 518.044 1020.89 518.115C1020.96 518.187 1020.98 518.24 1020.98 518.276Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.04 518.276C1026.04 518.312 1026.01 518.368 1025.94 518.437C1025.87 518.508 1025.75 518.58 1025.59 518.645C1025.27 518.776 1024.8 518.86 1024.28 518.86C1023.77 518.86 1023.3 518.776 1022.98 518.645C1022.82 518.58 1022.7 518.508 1022.63 518.437C1022.55 518.365 1022.53 518.312 1022.53 518.276C1022.53 518.24 1022.55 518.184 1022.63 518.115C1022.7 518.044 1022.82 517.972 1022.98 517.907C1023.3 517.776 1023.77 517.692 1024.28 517.692C1024.8 517.692 1025.26 517.776 1025.59 517.907C1025.75 517.972 1025.87 518.044 1025.94 518.115C1026.02 518.187 1026.04 518.24 1026.04 518.276Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.87 518.276C1031.87 518.312 1031.85 518.368 1031.78 518.437C1031.71 518.508 1031.59 518.58 1031.43 518.645C1031.1 518.776 1030.64 518.86 1030.12 518.86C1029.6 518.86 1029.14 518.776 1028.82 518.645C1028.65 518.58 1028.54 518.508 1028.46 518.437C1028.39 518.365 1028.37 518.312 1028.37 518.276C1028.37 518.24 1028.39 518.184 1028.46 518.115C1028.54 518.044 1028.65 517.972 1028.82 517.907C1029.14 517.776 1029.6 517.692 1030.12 517.692C1030.64 517.692 1031.1 517.776 1031.43 517.907C1031.59 517.972 1031.71 518.044 1031.78 518.115C1031.85 518.187 1031.87 518.24 1031.87 518.276Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.93 518.276C1036.93 518.312 1036.91 518.368 1036.84 518.437C1036.77 518.508 1036.65 518.58 1036.49 518.645C1036.16 518.776 1035.7 518.86 1035.18 518.86C1034.66 518.86 1034.2 518.776 1033.88 518.645C1033.71 518.58 1033.6 518.508 1033.52 518.437C1033.45 518.365 1033.43 518.312 1033.43 518.276C1033.43 518.24 1033.45 518.184 1033.52 518.115C1033.6 518.044 1033.71 517.972 1033.88 517.907C1034.2 517.776 1034.66 517.692 1035.18 517.692C1035.7 517.692 1036.16 517.776 1036.49 517.907C1036.65 517.972 1036.77 518.044 1036.84 518.115C1036.91 518.187 1036.93 518.24 1036.93 518.276Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.38 518.276C1042.38 518.312 1042.36 518.368 1042.29 518.437C1042.21 518.508 1042.1 518.58 1041.93 518.645C1041.61 518.776 1041.15 518.86 1040.63 518.86C1040.11 518.86 1039.65 518.776 1039.33 518.645C1039.16 518.58 1039.05 518.508 1038.97 518.437C1038.9 518.365 1038.88 518.312 1038.88 518.276C1038.88 518.24 1038.9 518.184 1038.97 518.115C1039.05 518.044 1039.16 517.972 1039.33 517.907C1039.65 517.776 1040.11 517.692 1040.63 517.692C1041.15 517.692 1041.61 517.776 1041.93 517.907C1042.1 517.972 1042.21 518.044 1042.29 518.115C1042.36 518.187 1042.38 518.24 1042.38 518.276Z",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.54 510.885L1024.28 513.413H1034.4L1029.54 510.885Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M203.802 514.972C206.381 514.972 208.472 517.062 208.472 519.642V525.479C208.472 528.058 206.381 530.149 203.802 530.149C201.223 530.149 199.132 528.058 199.132 525.479V519.642C199.132 517.062 201.223 514.972 203.802 514.972Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M204.386 516.333C206.536 516.333 208.278 518.075 208.278 520.226V525.673C208.278 527.823 206.536 529.566 204.386 529.566C202.235 529.566 200.493 527.823 200.493 525.673V520.226C200.493 518.075 202.235 516.333 204.386 516.333Z",
    fill: "#E9A59B"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M203.606 520.225V534.622",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M206.526 521.394L203.801 524.119",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M201.077 524.505L203.802 527.23",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M201.078 521.394L203.803 524.119",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M225.592 514.972C228.171 514.972 230.262 517.062 230.262 519.642C230.262 522.221 228.171 524.312 225.592 524.312C223.013 524.312 220.922 522.221 220.922 519.642C220.922 517.062 223.013 514.972 225.592 514.972Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M225.592 516.724H225.982C228.025 516.724 229.678 518.38 229.678 520.42C229.678 522.463 228.022 524.116 225.982 524.116H225.592C223.548 524.116 221.896 522.46 221.896 520.42C221.896 518.377 223.551 516.724 225.592 516.724Z",
    fill: "#62AE80"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M225.397 520.225V534.622",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M228.121 520.612L225.396 523.337",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M222.87 520.612L225.595 523.337",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M210.027 527.063C210.027 525.401 210.37 523.76 211.031 522.238L211.695 520.713C212.985 517.753 217.184 517.753 218.474 520.713L219.138 522.238C219.802 523.76 220.142 525.401 220.142 527.063C220.142 527.477 219.805 527.814 219.391 527.814H210.775C210.361 527.814 210.024 527.477 210.024 527.063H210.027Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M211.388 526.873C211.388 525.518 211.671 524.177 212.222 522.938L212.537 522.23C213.744 519.513 217.597 519.513 218.804 522.23L219.119 522.938C219.667 524.177 219.953 525.518 219.953 526.873C219.953 527.284 219.62 527.62 219.206 527.62H212.138C211.727 527.62 211.391 527.287 211.391 526.873H211.388Z",
    fill: "#62AE80"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M215.087 524.896V534.429",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M217.615 524.115L215.087 526.45",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M213.14 525.283L215.084 527.425",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M188.866 534.402C187.058 532.773 187.314 529.866 189.381 528.58L192.809 526.447C193.339 526.119 194.013 526.131 194.525 526.483L197.566 528.559C199.534 529.905 199.796 532.707 198.111 534.393C198.09 534.414 198.06 534.426 198.03 534.426H188.932C188.908 534.426 188.881 534.417 188.863 534.399L188.866 534.402Z",
    fill: "#E1F1F1"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M188.863 534.399C188.881 534.417 188.908 534.426 188.932 534.426H198.03C198.06 534.426 198.09 534.414 198.111 534.393C199.796 532.707 199.534 529.905 197.566 528.559L194.525 526.483C194.013 526.131 193.339 526.119 192.809 526.447L189.381 528.58C187.314 529.866 187.058 532.773 188.866 534.402L188.863 534.399ZM188.863 534.399L188.732 534.545",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M189.14 534.152C187.955 532.731 188.336 530.587 189.935 529.658L193.774 527.433C194.197 527.189 194.721 527.195 195.141 527.448L197.771 529.053C199.642 530.194 199.773 532.86 198.027 534.182C197.986 534.215 197.935 534.23 197.881 534.23H189.313C189.244 534.23 189.179 534.2 189.137 534.146L189.14 534.152Z",
    fill: "#62AE80"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M193.099 531.121V534.233",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M195.63 530.344L193.102 532.679",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M191.153 531.511L193.098 533.652",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M225.291 534.622H232.123C233.124 534.622 234.086 534.244 234.815 533.562L235.342 533.07C235.515 532.91 235.64 532.707 235.709 532.481L235.756 532.314C236.123 531.078 234.625 530.146 233.678 531.024V530.363C233.678 529.002 231.968 528.392 231.107 529.449C231.518 527.805 229.63 526.557 228.281 527.581L227.897 527.873L227.792 527.549C227.429 526.42 226.202 525.815 225.088 526.217C223.974 526.619 223.414 527.861 223.849 528.96L224.043 529.449C222.387 529.449 221.464 531.358 222.491 532.656L223.268 533.639C223.76 534.259 224.507 534.622 225.297 534.622H225.291Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M227.537 534.429L225.202 530.733",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M226.759 532.871L228.12 529.952",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M230.846 534.623L232.791 532.095",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M230.652 531.511L232.013 532.872",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M229.484 534.428L225.592 528.007",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M315.73 528.773C317.061 527.374 317.327 525.271 316.382 523.585L311.027 513.998C310.506 513.066 309.169 513.066 308.648 513.998L303.135 523.868C302.277 525.405 302.462 527.317 303.605 528.66C304.407 529.604 305.583 530.146 306.822 530.146H312.531C313.741 530.146 314.896 529.649 315.73 528.773Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M315.409 528.97C316.692 527.773 316.946 525.831 316.007 524.345L311.543 517.259C310.932 516.291 309.518 516.291 308.907 517.259L303.808 525.354C303.233 526.266 303.356 527.451 304.1 528.231C305.157 529.333 306.617 529.956 308.142 529.956H312.907C313.833 529.956 314.727 529.604 315.403 528.973L315.409 528.97Z",
    fill: "#62AE80"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M309.839 520.225V534.622",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M306.92 521.393L309.645 524.118",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M312.757 524.505L310.032 527.23",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M312.368 521.393L309.643 524.118",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M324.582 534.403C326.39 532.774 326.134 529.867 324.067 528.58L320.639 526.448C320.108 526.12 319.435 526.132 318.923 526.484L315.882 528.56C313.914 529.906 313.651 532.708 315.337 534.394C315.358 534.415 315.388 534.427 315.418 534.427H324.516C324.54 534.427 324.567 534.418 324.585 534.4L324.582 534.403Z",
    fill: "#FFD6D0"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M324.585 534.4C324.567 534.418 324.54 534.427 324.516 534.427H315.418C315.388 534.427 315.358 534.415 315.337 534.394C313.651 532.708 313.914 529.906 315.882 528.56L318.923 526.484C319.435 526.132 320.108 526.12 320.639 526.448L324.067 528.58C326.134 529.867 326.39 532.774 324.582 534.403L324.585 534.4ZM324.585 534.4L324.716 534.546",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M325.086 534.152C326.271 532.731 325.89 530.587 324.291 529.658L320.452 527.433C320.029 527.189 319.504 527.195 319.084 527.448L316.455 529.053C314.584 530.194 314.453 532.86 316.198 534.182C316.24 534.215 316.291 534.23 316.344 534.23H324.913C324.982 534.23 325.047 534.2 325.089 534.146L325.086 534.152Z",
    fill: "#E9A59B"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M320.347 531.121V534.233",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M317.817 530.343L320.346 532.678",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M322.292 531.51L320.347 533.651",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.28 534.039H-58.4746V546.101H1217.28V534.039Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.28 534.095H-58.668V545.908H1217.28V534.095Z",
    fill: "#A9D395"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M666.283 540.459C666.173 541.564 665.244 542.404 664.136 542.404H663.853C662.709 542.404 661.732 541.585 661.533 540.459C661.354 541.579 660.374 542.404 659.236 542.404C658.096 542.404 657.104 541.582 656.904 540.459C656.702 541.585 655.722 542.404 654.578 542.404H654.426C653.283 542.404 652.306 541.585 652.106 540.459L652.035 540.79C651.832 541.734 650.998 542.407 650.033 542.407H649.935C648.86 542.407 647.99 541.534 647.99 540.462",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.21 536.958C1077.09 537.631 1076.51 538.126 1075.83 538.126H1074.01C1073.29 538.126 1072.66 537.649 1072.45 536.958C1072.27 537.646 1071.65 538.126 1070.94 538.126H1069.39C1068.67 538.126 1068.03 537.649 1067.83 536.958C1067.62 537.652 1066.98 538.126 1066.26 538.126H1064.59C1063.86 538.126 1063.23 537.649 1063.03 536.958C1062.78 537.658 1062.11 538.126 1061.37 538.126H1060.08C1059.44 538.126 1058.91 537.604 1058.91 536.958",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.08 540.459C1045.97 541.564 1045.04 542.404 1043.93 542.404H1043.65C1042.5 542.404 1041.53 541.585 1041.33 540.459C1041.15 541.579 1040.17 542.404 1039.03 542.404C1037.89 542.404 1036.9 541.582 1036.7 540.459C1036.5 541.585 1035.52 542.404 1034.37 542.404H1034.22C1033.08 542.404 1032.1 541.585 1031.9 540.459L1031.83 540.79C1031.63 541.734 1030.79 542.407 1029.83 542.407H1029.73C1028.65 542.407 1027.79 541.534 1027.79 540.462",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.62 517.693C1074.04 517.693 1071.95 519.784 1071.95 522.363V528.201C1071.95 530.78 1074.04 532.871 1076.62 532.871C1079.2 532.871 1081.29 530.78 1081.29 528.201V522.363C1081.29 519.784 1079.2 517.693 1076.62 517.693Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.04 519.058C1073.89 519.058 1072.15 520.8 1072.15 522.95V528.398C1072.15 530.548 1073.89 532.29 1076.04 532.29C1078.19 532.29 1079.93 530.548 1079.93 528.398V522.95C1079.93 520.8 1078.19 519.058 1076.04 519.058Z",
    fill: "#AACAC9"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.82 522.947V534.232",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.9 524.115L1076.63 526.84",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.35 527.228L1076.62 529.953",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.35 524.115L1076.62 526.84",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.83 514.582C1052.25 514.582 1050.16 516.673 1050.16 519.252C1050.16 521.831 1052.25 523.922 1054.83 523.922C1057.41 523.922 1059.5 521.831 1059.5 519.252C1059.5 516.673 1057.41 514.582 1054.83 514.582Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.83 516.333H1054.44C1052.4 516.333 1050.75 517.989 1050.75 520.029C1050.75 522.072 1052.4 523.725 1054.44 523.725H1054.83C1056.88 523.725 1058.53 522.069 1058.53 520.029C1058.53 517.986 1056.87 516.333 1054.83 516.333Z",
    fill: "#AACAC9"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.03 519.835V534.232",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.3 520.225L1055.03 522.95",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.56 520.225L1054.83 522.95",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.4 526.672C1070.4 525.01 1070.05 523.369 1069.39 521.847L1068.73 520.322C1067.44 517.361 1063.24 517.361 1061.95 520.322L1061.29 521.847C1060.63 523.369 1060.28 525.01 1060.28 526.672C1060.28 527.086 1060.62 527.422 1061.03 527.422H1069.65C1070.07 527.422 1070.4 527.086 1070.4 526.672H1070.4Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.04 526.482C1069.04 525.127 1068.76 523.787 1068.2 522.548L1067.89 521.839C1066.68 519.123 1062.83 519.123 1061.62 521.839L1061.31 522.548C1060.76 523.787 1060.47 525.127 1060.47 526.482C1060.47 526.893 1060.81 527.23 1061.22 527.23H1068.29C1068.7 527.23 1069.04 526.896 1069.04 526.482H1069.04Z",
    fill: "#E9A59B"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.34 524.504V534.037",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.81 523.728L1065.34 526.063",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.29 524.895L1065.34 527.036",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.14 534.232H1048.31C1047.3 534.232 1046.34 533.853 1045.61 533.171L1045.09 532.68C1044.91 532.519 1044.79 532.316 1044.72 532.09L1044.67 531.923C1044.31 530.687 1045.8 529.755 1046.75 530.634V529.973C1046.75 528.611 1048.46 528.001 1049.32 529.058C1048.91 527.414 1050.8 526.166 1052.15 527.191L1052.54 527.483L1052.64 527.158C1053.01 526.029 1054.23 525.425 1055.35 525.827C1056.46 526.229 1057.02 527.471 1056.58 528.57L1056.39 529.058C1058.04 529.058 1058.97 530.967 1057.94 532.266L1057.17 533.249C1056.67 533.868 1055.93 534.232 1055.14 534.232Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.89 534.039L1055.22 530.343",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.67 532.481L1052.3 529.562",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.58 534.233L1047.64 531.704",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.77 531.121L1048.41 532.482",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.94 534.038L1054.83 527.617",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M479.578 549.345C477.034 548.496 475.098 549.699 474.452 550.405C474.214 550.521 473.707 550.652 473.567 550.229C474.979 548.639 477.808 548.109 479.575 549.345H479.578Z",
    fill: "url(#paint4_linear_6004_59723)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M161.069 540.608V541.868L174.034 541.722C173.677 541.007 172.947 540.558 172.149 540.558H161.12C161.093 540.558 161.069 540.581 161.069 540.608Z",
    fill: "#FFF9DE"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M146.794 555.562H149.129C149.129 556.206 148.608 556.73 147.961 556.73H146.794V555.562Z",
    fill: "#B7594C"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M918.248 526.646H931.242L957.279 539.099H918.248V526.646Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M927.975 526.646H918.248V539.099H927.975V526.646Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M924.862 529.759H921.359V539.099H924.862V529.759Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M925.548 525.8L924.396 522.575H924.357L923.52 524.353L922.656 522.557L921.474 525.797H921.167V526.056H922.844V525.797H922.51L922.844 524.784L923.52 526.059L924.172 524.784L924.503 525.797H924.172V526.056H925.834V525.797H925.545L925.548 525.8Z",
    fill: "#B7594C"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M566.47 539.902C566.47 538.24 566.812 536.599 567.473 535.077L568.138 533.552C569.424 530.592 573.63 530.592 574.916 533.552L575.58 535.077C576.242 536.599 576.584 538.24 576.584 539.902C576.584 540.316 576.251 540.653 575.834 540.653H567.217C566.8 540.653 566.467 540.316 566.467 539.902H566.47Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M567.835 539.711C567.835 538.355 568.118 537.015 568.669 535.776L568.985 535.067C570.191 532.351 574.045 532.351 575.251 535.067L575.567 535.776C576.115 537.015 576.401 538.355 576.401 539.711C576.401 540.122 576.067 540.458 575.653 540.458H568.586C568.172 540.458 567.838 540.125 567.838 539.711H567.835Z",
    fill: "#AACAC9"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M571.531 537.734V540.847",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M574.06 536.957L571.531 539.292",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M569.587 538.124L571.532 540.265",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M540.64 540.626C538.829 538.997 539.088 536.09 541.152 534.803L544.58 532.671C545.11 532.343 545.784 532.355 546.296 532.706L549.34 534.782C551.308 536.129 551.57 538.931 549.885 540.617C549.861 540.638 549.834 540.65 549.804 540.65H540.706C540.682 540.65 540.658 540.641 540.64 540.623V540.626Z",
    fill: "#FFD6D0"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M540.64 540.623C540.658 540.641 540.682 540.65 540.706 540.65H549.804C549.834 540.65 549.861 540.638 549.885 540.617C551.57 538.931 551.308 536.129 549.34 534.782L546.296 532.706C545.784 532.355 545.11 532.343 544.58 532.671L541.152 534.803C539.088 536.09 538.829 538.997 540.64 540.626V540.623ZM540.64 540.623L540.509 540.769",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M540.914 540.376C539.732 538.955 540.113 536.811 541.712 535.881L545.548 533.657C545.971 533.412 546.498 533.418 546.915 533.672L549.545 535.277C551.416 536.418 551.55 539.083 549.801 540.406C549.763 540.438 549.712 540.453 549.658 540.453H541.093C541.021 540.453 540.962 540.423 540.914 540.37V540.376Z",
    fill: "#E9A59B"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M544.874 537.348V540.46",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M547.403 536.566L544.874 538.901",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M542.93 537.734L544.875 539.876",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M577.065 540.847H583.897C584.898 540.847 585.857 540.469 586.589 539.786L587.113 539.295C587.289 539.134 587.414 538.932 587.48 538.705L587.53 538.539C587.897 537.303 586.399 536.37 585.452 537.249V536.588C585.452 535.227 583.739 534.616 582.878 535.673C583.289 534.029 581.404 532.781 580.049 533.806L579.665 534.098L579.563 533.773C579.197 532.644 577.973 532.04 576.856 532.442C575.742 532.844 575.182 534.086 575.62 535.185L575.814 535.673C574.161 535.673 573.234 537.583 574.262 538.881L575.036 539.864C575.528 540.483 576.272 540.847 577.065 540.847Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M579.313 540.653L576.979 536.957",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M578.535 539.095L579.896 536.176",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M582.619 540.845L584.564 538.316",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M582.426 537.734L583.787 539.095",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M581.258 540.653L577.365 534.231",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0176 539.903C17.0176 538.241 17.3601 536.6 18.0213 535.078L18.6855 533.553C19.9751 530.593 24.1745 530.593 25.4641 533.553L26.1283 535.078C26.7924 536.6 27.132 538.241 27.132 539.903C27.132 540.317 26.7954 540.654 26.3814 540.654H17.7652C17.3512 540.654 17.0146 540.317 17.0146 539.903H17.0176Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3779 539.712C18.3779 538.356 18.6609 537.016 19.2119 535.777L19.5276 535.068C20.7338 532.352 24.5877 532.352 25.7939 535.068L26.1096 535.777C26.6576 537.016 26.9436 538.356 26.9436 539.712C26.9436 540.123 26.61 540.459 26.196 540.459H19.1285C18.7175 540.459 18.3809 540.126 18.3809 539.712H18.3779Z",
    fill: "#62AE80"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0742 537.735V540.848",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6067 536.958L22.0781 539.293",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1299 538.125L22.0747 540.266",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.81365 540.627C-10.6215 538.998 -10.3654 536.091 -8.2984 534.804L-4.87037 532.672C-4.34023 532.344 -3.66713 532.356 -3.15486 532.707L-0.114012 534.783C1.85465 536.129 2.11675 538.932 0.431024 540.618C0.410176 540.639 0.380387 540.651 0.350604 540.651H-8.74813C-8.77196 540.651 -8.79877 540.642 -8.81664 540.624L-8.81365 540.627Z",
    fill: "#FFD6D0"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.81664 540.624C-8.79877 540.642 -8.77196 540.651 -8.74813 540.651H0.350604C0.380387 540.651 0.410176 540.639 0.431024 540.618C2.11675 538.932 1.85465 536.129 -0.114012 534.783L-3.15486 532.707C-3.66713 532.356 -4.34023 532.344 -4.87037 532.672L-8.2984 534.804C-10.3654 536.091 -10.6215 538.998 -8.81365 540.627L-8.81664 540.624ZM-8.81664 540.624L-8.94768 540.77",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.53956 540.377C-9.72493 538.956 -9.34371 536.812 -7.74436 535.882L-3.90531 533.658C-3.48239 533.413 -2.95821 533.419 -2.53827 533.673L0.0915724 535.278C1.96195 536.419 2.093 539.084 0.347712 540.407C0.306016 540.439 0.255378 540.454 0.201768 540.454H-8.36683C-8.43533 540.454 -8.50085 540.424 -8.54255 540.371L-8.53956 540.377Z",
    fill: "#E9A59B"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M27.611 540.848H34.4432C35.4439 540.848 36.4059 540.469 37.1356 539.787L37.6628 539.296C37.8355 539.135 37.9606 538.933 38.0291 538.706L38.0767 538.54C38.4431 537.304 36.945 536.371 35.9979 537.25V536.589C35.9979 535.228 34.2883 534.617 33.4276 535.674C33.8386 534.03 31.9504 532.782 30.6012 533.807L30.217 534.099L30.1127 533.774C29.7494 532.645 28.5223 532.041 27.4084 532.443C26.2945 532.845 25.7346 534.087 26.1695 535.186L26.363 535.674C24.7071 535.674 23.7838 537.584 24.8113 538.882L25.5887 539.865C26.0801 540.484 26.8277 540.848 27.6169 540.848H27.611Z",
    fill: "#62AE80",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8594 540.654L27.5244 536.958",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0791 539.095L30.4402 536.176",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M33.166 540.846L35.1108 538.317",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9717 537.735L34.3328 539.096",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8048 540.654L27.9121 534.232",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M962.607 538.347C962.607 536.686 962.265 535.044 961.604 533.523L960.94 531.998C959.653 529.037 955.448 529.037 954.161 531.998L953.497 533.523C952.836 535.044 952.493 536.686 952.493 538.347C952.493 538.761 952.827 539.098 953.244 539.098H961.86C962.277 539.098 962.61 538.761 962.61 538.347H962.607Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M961.245 538.157C961.245 536.802 960.962 535.462 960.411 534.223L960.096 533.514C958.889 530.798 955.035 530.798 953.829 533.514L953.514 534.223C952.966 535.462 952.68 536.802 952.68 538.157C952.68 538.568 953.013 538.904 953.427 538.904H960.495C960.906 538.904 961.242 538.571 961.242 538.157H961.245Z",
    fill: "#E9A59B"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M957.549 536.18V539.292",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M955.022 535.399L957.551 537.734",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M959.494 536.567L957.549 538.709",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M988.438 539.071C990.249 537.442 989.99 534.535 987.926 533.248L984.498 531.116C983.968 530.788 983.295 530.8 982.782 531.152L979.739 533.228C977.77 534.574 977.508 537.376 979.194 539.062C979.218 539.083 979.244 539.095 979.274 539.095H988.373C988.397 539.095 988.42 539.086 988.438 539.068V539.071Z",
    fill: "#E1F1F1"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M988.438 539.068C988.42 539.086 988.397 539.095 988.373 539.095H979.274C979.244 539.095 979.218 539.083 979.194 539.062C977.508 537.376 977.77 534.574 979.739 533.228L982.782 531.152C983.295 530.8 983.968 530.788 984.498 531.116L987.926 533.248C989.99 534.535 990.249 537.442 988.438 539.071V539.068ZM988.438 539.068L988.569 539.214",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M988.167 538.819C989.349 537.398 988.968 535.254 987.369 534.325L983.533 532.1C983.11 531.856 982.583 531.862 982.166 532.115L979.536 533.72C977.666 534.861 977.531 537.527 979.28 538.849C979.318 538.882 979.369 538.897 979.423 538.897H987.988C988.06 538.897 988.119 538.867 988.167 538.813V538.819Z",
    fill: "#AACAC9"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M984.206 535.79V538.902",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M981.678 535.013L984.206 537.348",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M986.151 536.18L984.206 538.321",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M952.016 539.292H945.184C944.183 539.292 943.222 538.914 942.492 538.232L941.968 537.74C941.792 537.58 941.667 537.377 941.601 537.151L941.551 536.984C941.184 535.748 942.682 534.816 943.63 535.694V535.033C943.63 533.672 945.342 533.061 946.203 534.119C945.789 532.475 947.677 531.227 949.032 532.251L949.416 532.543L949.518 532.219C949.884 531.09 951.108 530.485 952.225 530.887C953.339 531.289 953.899 532.531 953.461 533.63L953.267 534.119C954.92 534.119 955.847 536.028 954.819 537.326L954.045 538.309C953.553 538.929 952.809 539.292 952.016 539.292Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M949.768 539.095L952.103 535.399",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M950.546 537.541L949.185 534.622",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M946.459 539.293L944.514 536.765",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M946.656 536.18L945.295 537.541",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M947.82 539.097L951.713 532.676",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M519.291 532.287C519.559 532.287 519.78 532.505 519.78 532.776V540.585C519.78 540.853 519.562 541.073 519.291 541.073C519.023 541.073 518.803 540.856 518.803 540.585V532.776C518.803 532.508 519.02 532.287 519.291 532.287Z",
    fill: "#615E66"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M536.372 532.937H519.78V536.189H536.372V532.937Z",
    fill: "#FFF9DE"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M536.372 535.215H519.78V535.539H536.372V535.215Z",
    fill: "#615E66"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M536.372 533.914H519.78V534.239H536.372V533.914Z",
    fill: "#615E66"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M535.395 532.776C535.395 532.505 535.612 532.287 535.88 532.287C536.148 532.287 536.371 532.505 536.371 532.776V540.585C536.371 540.853 536.154 541.073 535.88 541.073C535.606 541.073 535.395 540.856 535.395 540.585V532.776Z",
    fill: "#615E66"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M521.894 537.817C522.162 537.817 522.382 538.035 522.382 538.306V541.234C522.382 541.502 522.165 541.722 521.894 541.722C521.626 541.722 521.405 541.505 521.405 541.234V538.306C521.405 538.038 521.623 537.817 521.894 537.817Z",
    fill: "#615E66"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M538.158 537.817C538.426 537.817 538.647 538.035 538.647 538.306V541.234C538.647 541.502 538.429 541.722 538.158 541.722C537.89 541.722 537.67 541.505 537.67 541.234V538.306C537.67 538.038 537.887 537.817 538.158 537.817Z",
    fill: "#615E66"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M519.78 537.818L518.803 537.005H536.372L538.647 537.818V538.795H521.406L519.78 537.818Z",
    fill: "#FFF9DE"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M538.65 537.817H521.405V538.794H538.65V537.817Z",
    fill: "#615E66"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M518.803 537.005L521.406 537.818V539.119L518.803 537.982V537.005Z",
    fill: "#615E66"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M899.287 535.241C899.475 535.241 899.63 535.394 899.63 535.584V541.063C899.63 541.251 899.477 541.405 899.287 541.405C899.099 541.405 898.944 541.253 898.944 541.063V535.584C898.944 535.396 899.097 535.241 899.287 535.241Z",
    fill: "#615E66"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M911.27 535.696H899.63V537.978H911.27V535.696Z",
    fill: "#FFF9DE"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M911.27 537.295H899.63V537.523H911.27V537.295Z",
    fill: "#615E66"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M911.27 536.382H899.63V536.61H911.27V536.382Z",
    fill: "#615E66"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M910.585 535.584C910.585 535.394 910.738 535.241 910.926 535.241C911.114 535.241 911.27 535.394 911.27 535.584V541.063C911.27 541.251 911.118 541.405 910.926 541.405C910.733 541.405 910.585 541.253 910.585 541.063V535.584Z",
    fill: "#615E66"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M901.113 539.121C901.301 539.121 901.456 539.274 901.456 539.464V541.518C901.456 541.706 901.303 541.86 901.113 541.86C900.925 541.86 900.771 541.708 900.771 541.518V539.464C900.771 539.276 900.923 539.121 901.113 539.121Z",
    fill: "#615E66"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M912.524 539.121C912.712 539.121 912.867 539.274 912.867 539.464V541.518C912.867 541.706 912.714 541.86 912.524 541.86C912.336 541.86 912.182 541.708 912.182 541.518V539.464C912.182 539.276 912.334 539.121 912.524 539.121Z",
    fill: "#615E66"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M899.631 539.121L898.945 538.551H911.271L912.868 539.121V539.807H900.772L899.631 539.121Z",
    fill: "#FFF9DE"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M912.869 539.121H900.771V539.806H912.869V539.121Z",
    fill: "#615E66"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M898.945 538.551L900.772 539.121V540.034L898.945 539.236V538.551Z",
    fill: "#615E66"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M602.994 533.566C602.806 533.566 602.652 533.719 602.652 533.909V539.388C602.652 539.576 602.804 539.73 602.994 539.73C603.182 539.73 603.337 539.578 603.337 539.388V533.909C603.337 533.721 603.184 533.566 602.994 533.566Z",
    fill: "#615E66"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M591.011 534.021H602.651V536.303H591.011V534.021Z",
    fill: "#FFF9DE"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M591.011 535.619H602.651V535.847H591.011V535.619Z",
    fill: "#615E66"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M591.011 534.708H602.651V534.936H591.011V534.708Z",
    fill: "#615E66"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M591.696 533.909C591.696 533.719 591.544 533.566 591.356 533.566C591.168 533.566 591.011 533.719 591.011 533.909V539.388C591.011 539.576 591.163 539.73 591.356 539.73C591.548 539.73 591.696 539.578 591.696 539.388V533.909Z",
    fill: "#615E66"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M601.168 537.446C600.98 537.446 600.825 537.599 600.825 537.789V539.843C600.825 540.031 600.978 540.186 601.168 540.186C601.356 540.186 601.511 540.033 601.511 539.843V537.789C601.511 537.601 601.358 537.446 601.168 537.446Z",
    fill: "#615E66"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M589.757 537.446C589.569 537.446 589.414 537.599 589.414 537.789V539.843C589.414 540.031 589.567 540.186 589.757 540.186C589.945 540.186 590.1 540.033 590.1 539.843V537.789C590.1 537.601 589.947 537.446 589.757 537.446Z",
    fill: "#615E66"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M602.651 537.446L603.336 536.876H591.01L589.414 537.446V538.132H601.51L602.651 537.446Z",
    fill: "#FFF9DE"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M589.413 537.446H601.511V538.132H589.413V537.446Z",
    fill: "#615E66"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M603.336 536.876L601.51 537.446V538.36L603.336 537.561V536.876Z",
    fill: "#615E66"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M171.499 530.783C171.659 530.783 171.79 530.913 171.79 531.075V535.735C171.79 535.895 171.66 536.027 171.499 536.027C171.339 536.027 171.207 535.897 171.207 535.735V531.075C171.207 530.915 171.337 530.783 171.499 530.783Z",
    fill: "#615E66"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M181.693 531.17H171.79V533.111H181.693V531.17Z",
    fill: "#FFF9DE"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M181.693 532.529H171.79V532.723H181.693V532.529Z",
    fill: "#615E66"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M181.693 531.754H171.79V531.948H181.693V531.754Z",
    fill: "#615E66"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M181.11 531.075C181.11 530.913 181.24 530.783 181.4 530.783C181.56 530.783 181.693 530.913 181.693 531.075V535.735C181.693 535.895 181.564 536.027 181.4 536.027C181.237 536.027 181.11 535.897 181.11 535.735V531.075Z",
    fill: "#615E66"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M173.052 534.083C173.212 534.083 173.344 534.213 173.344 534.375V536.122C173.344 536.282 173.214 536.413 173.052 536.413C172.892 536.413 172.761 536.284 172.761 536.122V534.375C172.761 534.215 172.89 534.083 173.052 534.083Z",
    fill: "#615E66"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M182.76 534.083C182.92 534.083 183.052 534.213 183.052 534.375V536.122C183.052 536.282 182.922 536.413 182.76 536.413C182.6 536.413 182.469 536.284 182.469 536.122V534.375C182.469 534.215 182.598 534.083 182.76 534.083Z",
    fill: "#615E66"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M171.791 534.084L171.208 533.599H181.694L183.052 534.084V534.667H172.762L171.791 534.084Z",
    fill: "#FFF9DE"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M183.053 534.083H172.761V534.666H183.053V534.083Z",
    fill: "#615E66"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M171.208 533.599L172.762 534.084V534.861L171.208 534.182V533.599Z",
    fill: "#615E66"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M295.144 416.759H291.891L295.546 415.237C296.761 414.73 298.141 414.776 299.32 415.365C299.942 414.744 301.829 413.693 304.428 414.437C301.084 415.182 299.631 417.225 299.32 418.152C298.114 417.247 296.647 416.759 295.139 416.759H295.144Z",
    fill: "#615E66"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M204.659 388.123H201.405L205.061 386.602C206.281 386.094 207.656 386.14 208.835 386.73C209.456 386.113 211.343 385.057 213.943 385.802C210.598 386.547 209.145 388.589 208.835 389.517C207.629 388.612 206.162 388.123 204.654 388.123H204.659Z",
    fill: "#615E66"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M963.397 422.491H966.65L962.995 420.97C961.775 420.463 960.4 420.508 959.221 421.098C958.599 420.481 956.712 419.425 954.113 420.17C957.457 420.915 958.91 422.957 959.221 423.885C960.427 422.98 961.894 422.491 963.402 422.491H963.397Z",
    fill: "#615E66"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.28 569.254H-58.668V573.885H1217.28V569.254Z",
    fill: "#C3E1B5"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.28 573.472H-58.668V576.646H1217.28V573.472Z",
    fill: "#FFF9DE"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M351.867 536.958C351.754 537.631 351.17 538.126 350.488 538.126H348.674C347.951 538.126 347.316 537.649 347.114 536.958C346.932 537.646 346.312 538.126 345.601 538.126H344.049C343.325 538.126 342.691 537.649 342.488 536.958C342.283 537.652 341.642 538.126 340.919 538.126H339.248C338.524 538.126 337.89 537.649 337.687 536.958C337.437 537.658 336.773 538.126 336.034 538.126H334.742C334.095 538.126 333.574 537.604 333.574 536.958",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M320.734 540.461C320.624 541.566 319.695 542.406 318.584 542.406H318.301C317.157 542.406 316.18 541.587 315.984 540.461C315.808 541.581 314.822 542.406 313.687 542.406C312.547 542.406 311.552 541.584 311.355 540.461C311.153 541.587 310.173 542.406 309.029 542.406H308.877C307.734 542.406 306.757 541.587 306.56 540.461L306.489 540.792C306.286 541.736 305.455 542.409 304.49 542.409H304.392C303.317 542.409 302.447 541.536 302.447 540.464",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M130.841 536.958C130.728 537.631 130.147 538.126 129.462 538.126H127.648C126.927 538.126 126.293 537.649 126.087 536.958C125.906 537.646 125.283 538.126 124.574 538.126H123.02C122.299 538.126 121.665 537.649 121.459 536.958C121.251 537.652 120.613 538.126 119.889 538.126H118.219C117.498 538.126 116.863 537.649 116.658 536.958C116.408 537.658 115.747 538.126 115.002 538.126H113.712C113.069 538.126 112.545 537.604 112.545 536.958",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7077 540.461C99.5975 541.566 98.6683 542.406 97.5574 542.406H97.2745C96.1308 542.406 95.1539 541.587 94.9573 540.461C94.7816 541.581 93.7958 542.406 92.6611 542.406C91.5204 542.406 90.5256 541.584 90.329 540.461C90.1265 541.587 89.1466 542.406 88.003 542.406H87.8511C86.7074 542.406 85.7305 541.587 85.534 540.461L85.4625 540.792C85.2599 541.736 84.429 542.409 83.464 542.409H83.3657C82.2906 542.409 81.4209 541.536 81.4209 540.464",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M463.937 536.958C463.824 537.631 463.24 538.126 462.558 538.126H460.745C460.021 538.126 459.386 537.649 459.184 536.958C459.002 537.646 458.383 538.126 457.671 538.126H456.119C455.396 538.126 454.761 537.649 454.559 536.958C454.353 537.652 453.713 538.126 452.989 538.126H451.318C450.594 538.126 449.96 537.649 449.758 536.958C449.507 537.658 448.843 538.126 448.105 538.126H446.812C446.166 538.126 445.645 537.604 445.645 536.958",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M432.805 540.461C432.694 541.566 431.765 542.406 430.657 542.406H430.374C429.231 542.406 428.254 541.587 428.054 540.461C427.875 541.581 426.896 542.406 425.758 542.406C424.617 542.406 423.625 541.584 423.426 540.461C423.223 541.587 422.243 542.406 421.1 542.406H420.948C419.804 542.406 418.827 541.587 418.628 540.461L418.556 540.792C418.354 541.736 417.52 542.409 416.555 542.409H416.457C415.381 542.409 414.512 541.536 414.512 540.464",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M697.417 536.958C697.304 537.631 696.72 538.126 696.038 538.126H694.224C693.5 538.126 692.866 537.649 692.663 536.958C692.482 537.646 691.862 538.126 691.15 538.126H689.599C688.875 538.126 688.241 537.649 688.038 536.958C687.833 537.652 687.192 538.126 686.469 538.126H684.798C684.074 538.126 683.44 537.649 683.237 536.958C682.987 537.658 682.323 538.126 681.584 538.126H680.291C679.645 538.126 679.124 537.604 679.124 536.958",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M862.382 538.562C862.268 539.235 861.685 539.729 861.003 539.729H859.189C858.465 539.729 857.831 539.252 857.628 538.562C857.447 539.25 856.827 539.729 856.115 539.729H854.564C853.84 539.729 853.205 539.252 853.003 538.562C852.797 539.255 852.157 539.729 851.433 539.729H849.763C849.039 539.729 848.404 539.252 848.202 538.562C847.952 539.261 847.288 539.729 846.549 539.729H845.256C844.61 539.729 844.089 539.208 844.089 538.562",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M784.582 540.461C784.472 541.566 783.542 542.406 782.434 542.406H782.152C781.008 542.406 780.031 541.587 779.831 540.461C779.653 541.581 778.673 542.406 777.535 542.406C776.394 542.406 775.403 541.584 775.203 540.461C775.001 541.587 774.021 542.406 772.877 542.406H772.725C771.582 542.406 770.605 541.587 770.405 540.461L770.334 540.792C770.131 541.736 769.297 542.409 768.332 542.409H768.234C767.159 542.409 766.289 541.536 766.289 540.464",
    stroke: "#615E66",
    strokeWidth: 0.297831
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M428.331 511.859C430.91 511.859 433.001 513.95 433.001 516.529V522.367C433.001 524.946 430.91 527.037 428.331 527.037C425.752 527.037 423.661 524.946 423.661 522.367V516.529C423.661 513.95 425.752 511.859 428.331 511.859Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M428.914 513.221C431.064 513.221 432.807 514.963 432.807 517.113V522.561C432.807 524.711 431.064 526.453 428.914 526.453C426.764 526.453 425.021 524.711 425.021 522.561V517.113C425.021 514.963 426.764 513.221 428.914 513.221Z",
    fill: "#AACAC9"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M428.135 517.11V534.233",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M431.053 518.278L428.134 521.525",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M425.605 521.394L428.134 523.922",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M425.605 518.278L428.134 520.807",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M442.338 518.862C444.917 518.862 447.008 520.953 447.008 523.532C447.008 526.112 444.917 528.202 442.338 528.202C439.759 528.202 437.668 526.112 437.668 523.532C437.668 520.953 439.759 518.862 442.338 518.862Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M442.338 520.613H442.728C444.771 520.613 446.424 522.269 446.424 524.309C446.424 526.352 444.768 528.005 442.728 528.005H442.338C440.295 528.005 438.642 526.35 438.642 524.309C438.642 522.266 440.298 520.613 442.338 520.613Z",
    fill: "#AACAC9"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M442.145 524.116V534.04",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M444.866 524.505L442.141 527.23",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M439.615 524.505L442.34 527.23",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M415.765 534.04C415.765 534.04 415.696 533.956 415.664 533.915C414.371 532.244 414.758 529.748 416.632 528.58L420.06 526.448C420.59 526.12 421.263 526.132 421.775 526.484L424.819 528.56C426.597 529.775 426.981 532.178 425.799 533.876C425.76 533.93 425.68 534.04 425.68 534.04H415.768H415.765Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M416.381 533.81C415.214 532.407 415.589 530.292 417.168 529.375L420.953 527.18C421.373 526.939 421.891 526.945 422.299 527.195L424.893 528.779C426.74 529.905 426.871 532.535 425.147 533.839C425.108 533.869 425.057 533.887 425.004 533.887H416.554C416.486 533.887 416.423 533.857 416.379 533.807L416.381 533.81Z",
    fill: "#AACAC9"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M420.352 531.121V534.04",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M422.88 530.343L420.352 532.678",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M418.407 531.511L420.352 533.652",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M441.597 534.039C441.597 534.039 442.028 533.745 442.222 533.563L442.746 533.071C442.922 532.911 443.047 532.708 443.113 532.482L443.163 532.315C443.53 531.079 442.031 530.147 441.084 531.025V530.364C441.084 529.003 439.372 528.393 438.511 529.45C438.922 527.806 437.037 526.558 435.682 527.582L435.297 527.874L435.196 527.55C434.83 526.421 433.606 525.816 432.489 526.218C431.375 526.62 430.815 527.862 431.253 528.961L431.446 529.45C429.794 529.45 428.867 531.359 429.895 532.657L430.669 533.64C430.785 533.789 431.062 534.039 431.062 534.039H441.597Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M434.697 534.038L432.609 530.729",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M433.877 532.737L435.53 529.952",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M438.701 534.04L440.199 532.095",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M438.057 531.511L439.546 532.94",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M436.654 534.041L433 528.01",
    stroke: "#615E66",
    strokeWidth: 0.297831,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.1948 547.472H1074.14V564.759H-12.1948V547.472Z",
    fill: "#CFCDC8"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.82 552.973L-6.14825 552.872",
    stroke: "white",
    strokeWidth: 0.557354,
    strokeDasharray: "2.79 2.79"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.1948 564.468H1074.14V568.927H-12.1948V564.468Z",
    fill: "#FFF9DE"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.1948 543.01H1074.14V547.469H-12.1948V543.01Z",
    fill: "#FFF9DE"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.1948 538.857H1074.14V545.745H-12.1948V538.857Z",
    fill: "#A9D395"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.58 545.746H848.951L923.826 543.736H1012.95L1073.58 545.746Z",
    fill: "#62AE80"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M919.421 545.746H656.695L720.636 543.736H809.757L919.419 545.746H919.421Z",
    fill: "#62AE80"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M690.491 545.746H287.623L394.635 543.736H603.026L690.491 545.746Z",
    fill: "#62AE80"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M763.584 538.287C766.379 538.931 770.487 541.19 772.765 542.323L772.82 545.668C772.977 545.864 773.312 546.425 773.351 547.094C773.387 547.644 772.966 548.543 772.64 549.126C772.524 549.333 772.3 549.455 772.062 549.455H738.446C738.061 549.455 737.749 549.145 737.749 548.761V547.241C737.749 545.864 739.245 544.731 740.259 544.338C741.072 544.023 743.833 542.895 745.973 542.37C745.973 542.37 749.226 539.564 753.976 538.334C757.124 537.519 760.809 537.646 763.587 538.284L763.584 538.287Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.251553
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M767.285 544.817C764.925 544.029 763.128 545.146 762.528 545.801C762.307 545.909 761.837 546.031 761.707 545.638C763.017 544.162 765.643 543.67 767.283 544.817H767.285Z",
    fill: "url(#paint5_linear_6004_59723)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M762.857 546.621C759.709 547.539 749.953 547.661 745.47 547.605V548.918H772.695C772.917 548.482 773.353 547.509 773.353 547.113C773.353 546.718 772.917 545.966 772.695 545.637C770.727 545.582 766.006 545.704 762.857 546.621Z",
    fill: "#FFF9DE"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M770.122 542.862L772.765 542.271L772.79 544.534L770.073 543.528C769.752 543.407 769.78 542.939 770.12 542.865L770.122 542.862Z",
    fill: "#B7594C"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M743.78 551.178C745.447 551.178 746.798 549.888 746.798 548.297C746.798 546.707 745.447 545.417 743.78 545.417C742.114 545.417 740.763 546.707 740.763 548.297C740.763 549.888 742.114 551.178 743.78 551.178Z",
    fill: "#76736C"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M743.78 549.605C744.536 549.605 745.149 549.019 745.149 548.297C745.149 547.574 744.536 546.988 743.78 546.988C743.025 546.988 742.412 547.574 742.412 548.297C742.412 549.019 743.025 549.605 743.78 549.605Z",
    fill: "white"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M765.691 551.178C767.358 551.178 768.709 549.888 768.709 548.297C768.709 546.707 767.358 545.417 765.691 545.417C764.025 545.417 762.674 546.707 762.674 548.297C762.674 549.888 764.025 551.178 765.691 551.178Z",
    fill: "#76736C"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M765.689 549.605C766.444 549.605 767.057 549.019 767.057 548.297C767.057 547.574 766.444 546.988 765.689 546.988C764.933 546.988 764.32 547.574 764.32 548.297C764.32 549.019 764.933 549.605 765.689 549.605Z",
    fill: "white"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M757.923 542.469C754.68 542.831 748.262 542.469 748.262 542.469C751.734 539.762 754.99 538.944 757.337 538.878C764.168 538.681 765.876 540.699 765.876 540.699C765.876 540.699 761.873 542.029 757.923 542.471V542.469Z",
    fill: "url(#paint6_linear_6004_59723)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M755.314 542.582L759.051 538.717V540.595L757.348 542.582H755.314Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M753.965 542.63L757.277 538.821H758.105L754.58 542.63H753.965Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M677.144 548.63C674.266 547.883 666.612 547.944 663.538 547.986C662.747 547.997 661.998 548.326 661.454 548.895L658.512 551.975C658.512 551.975 650.615 553.014 650.615 553.78V556.702C650.44 556.917 650.076 557.536 650.029 558.272C649.99 558.877 650.452 559.864 650.814 560.508C650.941 560.737 651.187 560.87 651.449 560.87H688.466C688.889 560.87 689.229 560.53 689.229 560.107V555.405C689.229 554.65 687.59 554.321 686.471 554.156C685.348 553.99 682.531 553.65 680.179 553.072C680.179 553.072 678.562 548.997 677.144 548.63Z",
    fill: "#D7D0B3",
    stroke: "#382456",
    strokeWidth: 0.276432
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M656.707 555.767C659.308 554.899 661.282 556.129 661.945 556.851C662.189 556.972 662.703 557.102 662.849 556.671C661.404 555.046 658.515 554.504 656.71 555.767H656.707Z",
    fill: "url(#paint7_linear_6004_59723)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M667.005 557.211C672.423 557.211 686.142 557.211 688.671 557.753V560.282H650.748C650.505 559.801 650.026 558.729 650.026 558.295C650.026 557.861 650.507 557.031 650.748 556.669C652.915 556.609 663.389 557.211 666.999 557.211H667.002H667.005Z",
    fill: "#FFF9DE"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M653.285 554.049L650.678 553.687L650.65 555.456L653.326 554.798C653.735 554.698 653.705 554.107 653.287 554.049H653.285Z",
    fill: "#C86A3F"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M684.027 562.767C685.958 562.767 687.524 561.169 687.524 559.198C687.524 557.227 685.958 555.629 684.027 555.629C682.096 555.629 680.53 557.227 680.53 559.198C680.53 561.169 682.096 562.767 684.027 562.767Z",
    fill: "#76736C"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M684.027 560.817C684.903 560.817 685.614 560.092 685.614 559.197C685.614 558.303 684.903 557.578 684.027 557.578C683.151 557.578 682.44 558.303 682.44 559.197C682.44 560.092 683.151 560.817 684.027 560.817Z",
    fill: "white"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M658.64 562.767C660.572 562.767 662.137 561.169 662.137 559.198C662.137 557.227 660.572 555.629 658.64 555.629C656.709 555.629 655.144 557.227 655.144 559.198C655.144 561.169 656.709 562.767 658.64 562.767Z",
    fill: "#76736C"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M658.64 560.817C659.517 560.817 660.227 560.092 660.227 559.197C660.227 558.303 659.517 557.578 658.64 557.578C657.764 557.578 657.054 558.303 657.054 559.197C657.054 560.092 657.764 560.817 658.64 560.817Z",
    fill: "white"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M668.899 553.234H679.536L677.117 549.264L669.352 548.723H662.85L659.42 552.336C659.42 552.336 664.476 553.234 668.901 553.234H668.899Z",
    fill: "url(#paint8_linear_6004_59723)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M668.899 553.234H679.536L677.117 549.264L669.352 548.723H662.85L659.42 552.336C659.42 552.336 664.476 553.234 668.901 553.234H668.899Z",
    fill: "url(#paint9_linear_6004_59723)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M670.087 548.858H669.833V553.428H670.087V548.858Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.193502
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M671.899 553.181L676.679 549.301V551.217L673.501 553.181H671.899Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M670.073 553.234L674.597 549.063L675.661 549.206L670.906 553.234H670.073Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M702.32 546.588C704.997 546.588 707.168 548.758 707.168 551.435C707.168 554.113 704.997 556.283 702.32 556.283C699.643 556.283 697.473 554.113 697.473 551.435C697.473 548.758 699.643 546.588 702.32 546.588Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M702.321 548.406H702.726C704.847 548.406 706.563 550.125 706.563 552.243C706.563 554.364 704.844 556.08 702.726 556.08H702.321C700.2 556.08 698.484 554.361 698.484 552.243C698.484 550.122 700.203 548.406 702.321 548.406Z",
    fill: "#62AE80"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M702.119 552.04V566.985",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M704.948 552.447L702.119 555.276",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M699.495 552.447L702.324 555.276",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M708.784 546.588C711.461 546.588 713.632 548.758 713.632 551.435C713.632 554.113 711.461 556.283 708.784 556.283C706.107 556.283 703.937 554.113 703.937 551.435C703.937 548.758 706.107 546.588 708.784 546.588Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M708.784 548.406H709.189C711.31 548.406 713.026 550.125 713.026 552.243C713.026 554.364 711.307 556.08 709.189 556.08H708.784C706.663 556.08 704.947 554.361 704.947 552.243C704.947 550.122 706.666 548.406 708.784 548.406Z",
    fill: "#62AE80"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M708.584 552.04V566.985",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M711.409 552.447L708.58 555.276",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M705.957 552.447L708.786 555.276",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M715.248 546.588C717.925 546.588 720.095 548.758 720.095 551.435C720.095 554.113 717.925 556.283 715.248 556.283C712.571 556.283 710.4 554.113 710.4 551.435C710.4 548.758 712.571 546.588 715.248 546.588Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M715.247 548.406H715.652C717.773 548.406 719.488 550.125 719.488 552.243C719.488 554.364 717.769 556.08 715.652 556.08H715.247C713.126 556.08 711.41 554.361 711.41 552.243C711.41 550.122 713.129 548.406 715.247 548.406Z",
    fill: "#62AE80"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M715.045 552.04V566.985",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M717.874 552.447L715.045 555.276",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M712.421 552.447L715.25 555.276",
    stroke: "#382456",
    strokeWidth: 0.309156
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M282.468 547.549C285.019 547.549 287.087 549.617 287.087 552.168C287.087 554.719 285.019 556.787 282.468 556.787C279.917 556.787 277.85 554.719 277.85 552.168C277.85 549.617 279.917 547.549 282.468 547.549Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M282.468 549.281H282.854C284.875 549.281 286.51 550.919 286.51 552.937C286.51 554.958 284.872 556.593 282.854 556.593H282.468C280.447 556.593 278.812 554.955 278.812 552.937C278.812 550.916 280.45 549.281 282.468 549.281Z",
    fill: "#62AE80"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M282.273 552.743V566.983",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M284.969 553.131L282.273 555.826",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M279.771 553.131L282.467 555.826",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M288.624 547.549C291.175 547.549 293.243 549.617 293.243 552.168C293.243 554.719 291.175 556.787 288.624 556.787C286.073 556.787 284.005 554.719 284.005 552.168C284.005 549.617 286.073 547.549 288.624 547.549Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M288.625 549.281H289.011C291.032 549.281 292.667 550.919 292.667 552.937C292.667 554.958 291.029 556.593 289.011 556.593H288.625C286.605 556.593 284.97 554.955 284.97 552.937C284.97 550.916 286.608 549.281 288.625 549.281Z",
    fill: "#62AE80"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M288.434 552.743V566.983",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M291.129 553.131L288.434 555.826",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M285.932 553.131L288.627 555.826",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M294.784 547.549C297.335 547.549 299.403 549.617 299.403 552.168C299.403 554.719 297.335 556.787 294.784 556.787C292.233 556.787 290.165 554.719 290.165 552.168C290.165 549.617 292.233 547.549 294.784 547.549Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M294.784 549.281H295.169C297.19 549.281 298.825 550.919 298.825 552.937C298.825 554.958 297.187 556.593 295.169 556.593H294.784C292.763 556.593 291.128 554.955 291.128 552.937C291.128 550.916 292.766 549.281 294.784 549.281Z",
    fill: "#62AE80"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M297.284 553.131L294.589 555.826",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M292.089 553.131L294.784 555.826",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M294.589 552.743V566.983",
    stroke: "#382456",
    strokeWidth: 0.294571
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M221.85 538.303V538.98L242.538 538.845L233.344 537.764H222.391C222.093 537.764 221.85 538.007 221.85 538.305V538.303Z",
    fill: "#CDD9F4"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M186.967 540.603C186.967 539.558 187.815 538.709 188.86 538.709H258.955C260.611 538.709 262.159 539.53 263.088 540.904C264.346 542.767 265.338 544.796 266.032 546.936L266.073 547.066C266.516 548.428 266.742 549.849 266.742 551.281V557.639C266.742 558.684 265.894 559.533 264.849 559.533H188.86C187.815 559.533 186.967 558.684 186.967 557.639V540.603Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M267.525 542.027L267.688 542.768L266.742 543.174C266.742 541.938 265.581 541.032 264.382 541.33L263.497 541.551L262.552 540.335H265.413C266.427 540.335 267.304 541.04 267.525 542.029V542.027Z",
    fill: "#FFF9DE",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M187.506 551.825H256.852",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M212.114 551.959V559.53",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 552.771H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 553.584H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 554.394H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 555.205H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 556.017H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 556.827H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 557.639H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M193.727 558.449H200.756",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M222.663 551.959V559.53",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M233.209 551.959V559.53",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M243.483 551.959V559.53",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M258.629 551.959V559.53",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M264.849 552.499V559.529",
    stroke: "#76736C",
    strokeWidth: 0.276432
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M188.857 549.662V548.039H246.728C249.54 548.039 250.966 548.49 251.325 548.716L258.49 551.691L263.087 552.501H266.739C266.83 552.86 266.955 553.717 266.739 554.259C264.575 554.394 259.439 554.123 258.49 553.582C254.272 550.552 250.421 549.706 249.025 549.659H188.854L188.857 549.662Z",
    fill: "#FFF9DE"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M206.978 563.05C209.069 563.05 210.765 561.294 210.765 559.128C210.765 556.961 209.069 555.205 206.978 555.205C204.886 555.205 203.19 556.961 203.19 559.128C203.19 561.294 204.886 563.05 206.978 563.05Z",
    fill: "#76736C"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M206.843 560.884C207.814 560.884 208.601 560.097 208.601 559.126C208.601 558.155 207.814 557.368 206.843 557.368C205.872 557.368 205.085 558.155 205.085 559.126C205.085 560.097 205.872 560.884 206.843 560.884Z",
    fill: "white"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M248.622 563.05C250.714 563.05 252.409 561.294 252.409 559.128C252.409 556.961 250.714 555.205 248.622 555.205C246.53 555.205 244.835 556.961 244.835 559.128C244.835 561.294 246.53 563.05 248.622 563.05Z",
    fill: "#76736C"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M248.487 560.884C249.458 560.884 250.245 560.097 250.245 559.126C250.245 558.155 249.458 557.368 248.487 557.368C247.516 557.368 246.729 558.155 246.729 559.126C246.729 560.097 247.516 560.884 248.487 560.884Z",
    fill: "white"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M218.336 558.182H216.172V559.262H218.336V558.182Z",
    fill: "#FFF9DE"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M228.882 558.182H226.718V559.262H228.882V558.182Z",
    fill: "#FFF9DE"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M239.161 558.182H236.996V559.262H239.161V558.182Z",
    fill: "#FFF9DE"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M257.548 554.123H255.926V555.204H257.548V554.123Z",
    fill: "#FFF9DE"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M257.548 556.559H255.926V557.639H257.548V556.559Z",
    fill: "#FFF9DE"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M188.858 541.414C188.858 540.817 189.342 540.333 189.939 540.333H258.76C259.926 540.333 261.087 540.513 262.198 540.867L262.281 540.894C263.061 541.143 263.713 541.679 264.108 542.398L265.126 544.25C266.53 546.81 267.141 549.732 266.876 552.64H263.088L258.491 551.83L252.407 549.265C250.71 548.549 248.888 548.181 247.047 548.181H188.855V541.419L188.858 541.414Z",
    fill: "url(#paint10_linear_6004_59723)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M262.812 540.742L263.666 542.674C265.07 545.856 265.794 549.295 265.794 552.772",
    stroke: "white",
    strokeWidth: 0.276432
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M244.839 548.184L252.952 539.335H255.772L244.839 550.201V548.184Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M243.081 548.717L251.601 539.388L251.949 539.871L243.084 549.201V548.717H243.081Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M225.004 548.184L233.117 539.335V541.82L225.004 550.204V548.186V548.184Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M223.246 548.717L231.766 539.388L232.114 539.871L223.249 549.201V548.717H223.246Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M204.092 548.184L212.205 539.335V541.82L204.092 550.204V548.186V548.184Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M212.114 540.333V548.51",
    stroke: "white",
    strokeWidth: 0.276432
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M201.298 540.333V548.869",
    stroke: "white",
    strokeWidth: 0.276432
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M222.663 540.333V548.51",
    stroke: "white",
    strokeWidth: 0.276432
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M233.209 540.333V548.869",
    stroke: "white",
    strokeWidth: 0.276432
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M243.484 540.333V548.69",
    stroke: "white",
    strokeWidth: 0.276432
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M258.63 540.333V551.962",
    stroke: "white",
    strokeWidth: 0.276432
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M268.05 545.921V543.129C268.05 542.93 267.887 542.767 267.688 542.767H267.282C266.834 542.767 266.472 543.129 266.472 543.577V545.47C266.472 545.918 266.834 546.283 267.282 546.283H267.688C267.887 546.283 268.05 546.12 268.05 545.921Z",
    fill: "#76736C"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.19 664.058V567.911H-20.9143V664.058H1071.19Z",
    fill: "#C4E1B5"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.86 801H-21.207V653.381H1081.86V801Z",
    fill: "#C3E1B5"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M687.855 586.465L167.869 588.969L329.206 653.444H707.924L687.855 586.465Z",
    fill: "#FFF5F5"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M167.869 588.969H-27.4339L-28 603.366H127.261C127.91 603.366 128.555 603.478 129.166 603.697L166.555 617.057L244.858 653.444H329.206L167.869 588.969Z",
    fill: "#FFF5F5"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M244.858 653.444L166.555 617.057H-21.572L-21.2069 653.444H244.858Z",
    fill: "#FFF5F5"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M795.669 653.444L868.695 653.131L1079.28 653.444L1081.86 608.688L819.709 607.864C795.789 607.788 772.278 601.652 751.373 590.027L743.991 585.921C741.427 584.495 742.458 580.591 745.391 580.617L1087.52 583.648V573.007L692.454 571.832C684.569 571.808 681.375 581.974 687.855 586.465V586.465L707.924 653.444H795.669Z",
    fill: "#FFF5F5"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M871.67 607.046C871.67 607.046 874.131 605.122 874.201 603.118C874.271 601.115 870.91 603.118 870.91 603.118C870.91 603.118 871.469 602.258 870.701 602.035C869.933 601.816 868.248 603.238 868.248 603.238C868.248 603.238 868.203 599.47 865.073 599.122C861.947 598.775 861.059 600.833 861.059 600.833C861.059 600.833 860.451 599.311 859.285 599.282C858.118 599.256 858.303 600.405 858.303 600.405C858.303 600.405 856.807 598.535 853.168 598.909C849.528 599.282 848.92 602.195 848.92 602.195C848.92 602.195 847.765 601.254 846.681 601.454C845.596 601.653 846.295 603.677 846.295 603.677C846.295 603.677 844.335 601.072 843.004 601.052C841.673 601.032 842.585 603.275 842.585 603.275C842.585 603.275 841.151 600.491 836.739 599.969C832.327 599.447 833.905 602.95 833.905 602.95C833.905 602.95 832.118 601.893 831.07 602.192C830.022 602.491 832.015 604.578 832.015 604.578C832.015 604.578 829.46 603.515 827.849 603.956C826.239 604.398 829.645 607.043 829.645 607.043H871.666L871.67 607.046Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.283048
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M751.327 653.552C751.327 653.552 753.787 651.628 753.857 649.624C753.927 647.621 750.567 649.624 750.567 649.624C750.567 649.624 751.125 648.763 750.357 648.541C749.589 648.322 747.905 649.744 747.905 649.744C747.905 649.744 747.859 645.976 744.729 645.628C741.603 645.281 740.715 647.338 740.715 647.338C740.715 647.338 740.107 645.816 738.941 645.788C737.774 645.762 737.959 646.911 737.959 646.911C737.959 646.911 736.464 645.041 732.824 645.415C729.184 645.788 728.576 648.701 728.576 648.701C728.576 648.701 727.422 647.76 726.337 647.96C725.253 648.159 725.951 650.183 725.951 650.183C725.951 650.183 723.991 647.578 722.66 647.558C721.329 647.538 722.241 649.781 722.241 649.781C722.241 649.781 720.808 646.996 716.396 646.475C711.983 645.953 713.561 649.456 713.561 649.456C713.561 649.456 711.774 648.399 710.726 648.698C709.679 648.997 711.671 651.084 711.671 651.084C711.671 651.084 709.116 650.02 707.506 650.462C705.895 650.904 709.301 653.549 709.301 653.549H751.323L751.327 653.552Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.283048
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M125.189 603.776C125.189 603.776 126.934 602.411 126.984 600.99C127.033 599.569 124.65 600.99 124.65 600.99C124.65 600.99 125.046 600.38 124.501 600.222C123.956 600.067 122.762 601.075 122.762 601.075C122.762 601.075 122.73 598.403 120.51 598.156C118.293 597.91 117.663 599.369 117.663 599.369C117.663 599.369 117.232 598.29 116.405 598.269C115.577 598.251 115.708 599.066 115.708 599.066C115.708 599.066 114.648 597.74 112.066 598.005C109.485 598.269 109.054 600.335 109.054 600.335C109.054 600.335 108.235 599.668 107.466 599.81C106.697 599.951 107.192 601.386 107.192 601.386C107.192 601.386 105.802 599.539 104.858 599.525C103.914 599.511 104.561 601.101 104.561 601.101C104.561 601.101 103.544 599.127 100.415 598.757C97.2859 598.387 98.4047 600.871 98.4047 600.871C98.4047 600.871 97.1373 600.121 96.3943 600.333C95.6514 600.546 97.0645 602.025 97.0645 602.025C97.0645 602.025 95.2522 601.271 94.1101 601.585C92.968 601.898 95.3833 603.774 95.3833 603.774H125.186L125.189 603.776Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.200742
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.307 647.609C230.307 647.609 225.444 649.115 227.25 653.857H260.992C261.372 653.219 261.647 652.483 261.728 651.644C260.123 648.279 257.283 648.621 257.283 648.621C257.283 648.621 258.665 647.174 257.938 646.967C257.212 646.759 255.973 647.492 255.973 647.492C255.973 647.492 257.067 645.063 254.007 645.425C250.947 645.787 249.952 647.718 249.952 647.718C249.952 647.718 250.585 646.162 249.662 646.176C248.738 646.19 247.379 647.997 247.379 647.997C247.379 647.997 247.864 646.593 247.112 646.455C246.359 646.316 245.559 646.969 245.559 646.969C245.559 646.969 245.137 644.948 242.613 644.689C240.088 644.431 239.051 645.727 239.051 645.727C239.051 645.727 239.179 644.931 238.37 644.948C237.561 644.968 237.139 646.024 237.139 646.024C237.139 646.024 236.524 644.597 234.356 644.838C232.185 645.079 232.153 647.692 232.153 647.692C232.153 647.692 230.985 646.706 230.452 646.858C229.919 647.012 230.307 647.609 230.307 647.609Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.283048
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M113.416 424.818H-100.697V575.732H113.416V424.818Z",
    fill: "#F9E3E1",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M113.416 540.884H-100.697V575.732H113.416V540.884Z",
    fill: "#D7C7A3",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6661 547.683H-2.50977V575.733H14.6661V547.683Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3742 547.683H19.1982V575.733H36.3742V547.683Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0434 553.13C41.0434 547.537 46.4061 543.005 53.0249 543.005C59.6436 543.005 65.0063 547.537 65.0063 553.13V575.73H41.0293V553.13H41.0434Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2484 547.683H69.0723V575.733H86.2484V547.683Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M108.557 547.683H91.3809V575.733H108.557V547.683Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6661 552.358H-2.50977V575.734H14.6661V552.358Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3742 552.358H19.1982V575.734H36.3742V552.358Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0434 557.808C41.0434 552.215 46.4061 547.683 53.0249 547.683C59.6436 547.683 65.0063 552.215 65.0063 557.808V575.733H41.0293V557.808H41.0434Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2484 552.358H69.0723V575.734H86.2484V552.358Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M108.557 552.358H91.3809V575.734H108.557V552.358Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54947 493.948H2.27637V507.977H9.54947V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54849 522.007H2.27539V536.036H9.54849V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4889 493.948H16.2158V507.977H23.4889V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4889 522.007H16.2158V536.036H23.4889V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4293 493.948H30.1562V507.977H37.4293V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4293 522.007H30.1562V536.036H37.4293V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3688 493.948H44.0957V507.977H51.3688V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3688 522.007H44.0957V536.036H51.3688V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3092 493.948H58.0361V507.977H65.3092V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3092 522.007H58.0361V536.036H65.3092V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2497 493.948H71.9766V507.977H79.2497V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2497 522.007H71.9766V536.036H79.2497V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1901 493.948H85.917V507.977H93.1901V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1901 522.007H85.917V536.036H93.1901V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M107.13 493.948H99.8564V507.977H107.13V493.948Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M107.13 522.007H99.8564V536.036H107.13V522.007Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54947 435.727H2.27637V449.756H9.54947V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54849 463.784H2.27539V477.813H9.54849V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4889 435.727H16.2158V449.756H23.4889V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4889 463.784H16.2158V477.813H23.4889V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4293 435.727H30.1562V449.756H37.4293V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4293 463.784H30.1562V477.813H37.4293V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3688 435.727H44.0957V449.756H51.3688V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3688 463.784H44.0957V477.813H51.3688V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3092 435.727H58.0361V449.756H65.3092V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3092 463.784H58.0361V477.813H65.3092V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2497 435.727H71.9766V449.756H79.2497V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2497 463.784H71.9766V477.813H79.2497V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1901 435.727H85.917V449.756H93.1901V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1901 463.784H85.917V477.813H93.1901V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M107.13 435.727H99.8564V449.756H107.13V435.727Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M107.13 463.784H99.8564V477.813H107.13V463.784Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M119.706 424.331H-107V427.766H119.706V424.331Z",
    fill: "#6B6770"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M116.842 417.129H-104.133V423.999H116.842V417.129Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20248 419.265H-18.2607V421.552H1.20248V419.265Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6829 419.114H9.21973V421.401H28.6829V419.114Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1556 419.114H36.6924V421.401H56.1556V419.114Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6373 419.114H64.1738V421.401H83.6373V419.114Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M111.12 419.114H91.6572V421.401H111.12V419.114Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 0.876329
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M82.375 547.341L81.608 547.497L81.734 548.126H82.375V547.341ZM85.5865 547.341H86.3715V546.556H85.5865V547.341ZM85.5865 551.254V552.039H86.3715V551.254H85.5865ZM69.9303 551.254H69.1455V552.039H69.9303V551.254ZM69.9303 547.341V546.556H69.1455V547.341H69.9303ZM73.1419 547.341V548.126H73.783L73.9088 547.497L73.1419 547.341ZM82.375 548.126H84.8076H85.5865V546.562H82.375V548.126ZM84.8076 547.341V548.126V550.469V551.254H86.3715V547.341H84.8076ZM85.5865 550.469H84.8076H70.7152H69.9303V552.033H85.5865V550.469ZM70.7152 551.254V550.469V548.126V547.341H69.1515V551.254H70.7152ZM69.9303 548.126H70.7152H73.1419V546.562H69.9303V548.126ZM73.9088 547.497C74.1964 546.071 75.4666 544.993 76.9765 544.993V543.429C74.7056 543.429 72.8123 545.04 72.3749 547.185L73.9088 547.497ZM76.9765 544.993H78.5404V543.429H76.9765V544.993ZM78.5404 544.993C80.0503 544.993 81.3204 546.071 81.608 547.497L83.1419 547.185C82.7045 545.04 80.8112 543.429 78.5404 543.429V544.993Z",
    fill: "#6B6770"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M81.734 548.126L81.608 547.497C81.3204 546.071 80.0503 544.993 78.5404 544.993H76.9765C75.4666 544.993 74.1964 546.071 73.9088 547.497L73.783 548.126H73.1419H70.7152V550.469H84.8076V548.126H82.375H81.734Z",
    fill: "#FFF9DE"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8554 547.341L10.0885 547.497L10.2144 548.126H10.8554V547.341ZM14.067 547.341H14.8519V546.556H14.067V547.341ZM14.067 551.254V552.039H14.8519V551.254H14.067ZM-1.58923 551.254H-2.37402V552.039H-1.58923V551.254ZM-1.58923 547.341V546.556H-2.37402V547.341H-1.58923ZM1.62235 547.341V548.126H2.2635L2.3893 547.497L1.62235 547.341ZM10.8554 548.126H13.2881H14.067V546.562H10.8554V548.126ZM13.2881 547.341V548.126V550.469V551.254H14.8519V547.341H13.2881ZM14.067 550.469H13.2881H-0.80429H-1.58923V552.033H14.067V550.469ZM-0.80429 551.254V550.469V548.126V547.341H-2.36803V551.254H-0.80429ZM-1.58923 548.126H-0.80429H1.62235V546.562H-1.58923V548.126ZM2.3893 547.497C2.6769 546.071 3.94705 544.993 5.45695 544.993V543.429C3.18611 543.429 1.2928 545.04 0.855406 547.185L2.3893 547.497ZM5.45695 544.993H7.02083V543.429H5.45695V544.993ZM7.02083 544.993C8.53072 544.993 9.80087 546.071 10.0885 547.497L11.6224 547.185C11.185 545.04 9.29166 543.429 7.02083 543.429V544.993Z",
    fill: "#6B6770"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2144 548.126L10.0885 547.497C9.80087 546.071 8.53072 544.993 7.02083 544.993H5.45695C3.94705 544.993 2.6769 546.071 2.3893 547.497L2.2635 548.126H1.62235H-0.80429V550.469H13.2881V548.126H10.8554H10.2144Z",
    fill: "#FFF9DE"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 547.341L104.033 547.497L104.159 548.126H104.8V547.341ZM108.011 547.341H108.796V546.556H108.011V547.341ZM108.011 551.254V552.039H108.796V551.254H108.011ZM92.3551 551.254H91.5703V552.039H92.3551V551.254ZM92.3551 547.341V546.556H91.5703V547.341H92.3551ZM95.5667 547.341V548.126H96.2078L96.3336 547.497L95.5667 547.341ZM104.8 548.126H107.232H108.011V546.562H104.8V548.126ZM107.232 547.341V548.126V550.469V551.254H108.796V547.341H107.232ZM108.011 550.469H107.232H93.14H92.3551V552.033H108.011V550.469ZM93.14 551.254V550.469V548.126V547.341H91.5763V551.254H93.14ZM92.3551 548.126H93.14H95.5667V546.562H92.3551V548.126ZM96.3336 547.497C96.6212 546.071 97.8914 544.993 99.4013 544.993V543.429C97.1304 543.429 95.2371 545.04 94.7997 547.185L96.3336 547.497ZM99.4013 544.993H100.965V543.429H99.4013V544.993ZM100.965 544.993C102.475 544.993 103.745 546.071 104.033 547.497L105.567 547.185C105.129 545.04 103.236 543.429 100.965 543.429V544.993Z",
    fill: "#6B6770"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M104.159 548.126L104.033 547.497C103.745 546.071 102.475 544.993 100.965 544.993H99.4013C97.8914 544.993 96.6212 546.071 96.3336 547.497L96.2078 548.126H95.5667H93.14V550.469H107.232V548.126H104.8H104.159Z",
    fill: "#FFF9DE"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2812 547.341L32.5143 547.497L32.6402 548.126H33.2812V547.341ZM36.4928 547.341H37.2777V546.556H36.4928V547.341ZM36.4928 551.254V552.039H37.2777V551.254H36.4928ZM20.8366 551.254H20.0518V552.039H20.8366V551.254ZM20.8366 547.341V546.556H20.0518V547.341H20.8366ZM24.0481 547.341V548.126H24.6893L24.8151 547.497L24.0481 547.341ZM33.2812 548.126H35.7138H36.4928V546.562H33.2812V548.126ZM35.7138 547.341V548.126V550.469V551.254H37.2777V547.341H35.7138ZM36.4928 550.469H35.7138H21.6215H20.8366V552.033H36.4928V550.469ZM21.6215 551.254V550.469V548.126V547.341H20.0578V551.254H21.6215ZM20.8366 548.126H21.6215H24.0481V546.562H20.8366V548.126ZM24.8151 547.497C25.1027 546.071 26.3728 544.993 27.8827 544.993V543.429C25.6119 543.429 23.7186 545.04 23.2812 547.185L24.8151 547.497ZM27.8827 544.993H29.4466V543.429H27.8827V544.993ZM29.4466 544.993C30.9565 544.993 32.2267 546.071 32.5143 547.497L34.0481 547.185C33.6108 545.04 31.7174 543.429 29.4466 543.429V544.993Z",
    fill: "#6B6770"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6402 548.126L32.5143 547.497C32.2267 546.071 30.9565 544.993 29.4466 544.993H27.8827C26.3728 544.993 25.1027 546.071 24.8151 547.497L24.6893 548.126H24.0481H21.6215V550.469H35.7138V548.126H33.2812H32.6402Z",
    fill: "#FFF9DE"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7233 458.66H52.4287V654.746H11.7233V458.66Z",
    fill: "#FCDACB"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7539 654.746V458.66C52.7539 458.484 52.6048 458.335 52.4286 458.335H11.7232C11.5334 458.335 11.3979 458.484 11.3979 458.66V654.746C11.3979 654.935 11.547 655.084 11.7232 655.084H52.4286C52.6048 655.084 52.7539 654.935 52.7539 654.746ZM12.0485 458.986H52.0897V654.42H12.0485V458.986Z",
    fill: "#6B6770"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.9045 474.684H29.0322V654.747H-29.9045V474.684Z",
    fill: "#DFDCCC"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3574 654.746V474.683C29.3574 474.493 29.2083 474.357 29.0321 474.357H-29.9047C-30.0809 474.357 -30.23 474.493 -30.23 474.683V654.746C-30.23 654.936 -30.0809 655.085 -29.9047 655.085H29.0321C29.2219 655.085 29.3574 654.936 29.3574 654.746ZM-29.5929 475.022H28.6932V654.421H-29.5929V475.022Z",
    fill: "#6B6770"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 480.754H22.6201V487.491H-24.9983V480.754Z",
    fill: "#6B6770"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 481.892H21.5078V487.07H-23.8876V481.892Z",
    fill: "#2B465B"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 481.892H21.5078V487.07H-23.8876V481.892Z",
    fill: "#FFFDF4"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 493.197H22.6201V499.948H-24.9983V493.197Z",
    fill: "#6B6770"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 494.35H21.5088V499.514H-23.8866V494.35Z",
    fill: "#2B465B"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 494.35H21.5088V499.514H-23.8866V494.35Z",
    fill: "#FFFDF4"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 505.654H22.6201V512.391H-24.9983V505.654Z",
    fill: "#6B6770"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 506.807H21.5078V511.971H-23.8876V506.807Z",
    fill: "#2B465B"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 506.807H21.5078V511.971H-23.8876V506.807Z",
    fill: "#FFFDF4"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 518.099H22.6201V524.849H-24.9983V518.099Z",
    fill: "#6B6770"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 519.266H21.5078V524.43H-23.8876V519.266Z",
    fill: "#2B465B"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 519.266H21.5078V524.43H-23.8876V519.266Z",
    fill: "#FFFDF4"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 530.555H22.6201V537.305H-24.9983V530.555Z",
    fill: "#6B6770"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 531.707H21.5088V536.871H-23.8866V531.707Z",
    fill: "#2B465B"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 531.707H21.5088V536.871H-23.8866V531.707Z",
    fill: "#FFFDF4"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 542.999H22.6201V549.736H-24.9983V542.999Z",
    fill: "#6B6770"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 544.165H21.5078V549.329H-23.8876V544.165Z",
    fill: "#2B465B"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 544.165H21.5078V549.329H-23.8876V544.165Z",
    fill: "#FFFDF4"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 555.457H22.6201V562.207H-24.9983V555.457Z",
    fill: "#6B6770"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 556.623H21.5078V561.787H-23.8876V556.623Z",
    fill: "#2B465B"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 556.623H21.5078V561.787H-23.8876V556.623Z",
    fill: "#FFFDF4"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 567.911H22.6201V574.661H-24.9983V567.911Z",
    fill: "#6B6770"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 569.062H21.5088V574.227H-23.8866V569.062Z",
    fill: "#2B465B"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 569.062H21.5088V574.227H-23.8866V569.062Z",
    fill: "#FFFDF4"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 580.355H22.6201V587.106H-24.9983V580.355Z",
    fill: "#6B6770"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 581.521H21.5078V586.686H-23.8876V581.521Z",
    fill: "#2B465B"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 581.521H21.5078V586.686H-23.8876V581.521Z",
    fill: "#FFFDF4"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 592.813H22.6201V599.564H-24.9983V592.813Z",
    fill: "#6B6770"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 593.966H21.5088V599.13H-23.8866V593.966Z",
    fill: "#2B465B"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 593.966H21.5088V599.13H-23.8866V593.966Z",
    fill: "#FFFDF4"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 605.254H22.6201V612.018H-24.9983V605.254Z",
    fill: "#6B6770"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 606.42H21.5078V611.584H-23.8876V606.42Z",
    fill: "#2B465B"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 606.42H21.5078V611.584H-23.8876V606.42Z",
    fill: "#FFFDF4"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 617.713H22.6201V624.463H-24.9983V617.713Z",
    fill: "#6B6770"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 618.879H21.5078V624.043H-23.8876V618.879Z",
    fill: "#2B465B"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 618.879H21.5078V624.043H-23.8876V618.879Z",
    fill: "#FFFDF4"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 630.154H22.6201V636.905H-24.9983V630.154Z",
    fill: "#6B6770"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 631.32H21.5088V636.485H-23.8866V631.32Z",
    fill: "#2B465B"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8866 631.32H21.5088V636.485H-23.8866V631.32Z",
    fill: "#FFFDF4"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9983 642.611H22.6201V649.362H-24.9983V642.611Z",
    fill: "#6B6770"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 643.777H21.5078V648.942H-23.8876V643.777Z",
    fill: "#2B465B"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.8876 643.777H21.5078V648.942H-23.8876V643.777Z",
    fill: "#FFFDF4"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 476.856H47.8018V511.284H34.743V476.856Z",
    fill: "#FFF9DE"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 511.789H48.3408V476.325H34.1804V511.789ZM47.2391 510.753H35.3089V477.386H47.2391V510.753Z",
    fill: "#6B6770"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 476.856H47.8018V493.477H34.743V476.856Z",
    fill: "white"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 494.006H48.3408V476.325H34.1804V494.006ZM47.2391 492.946H35.3089V477.361H47.2391V492.946Z",
    fill: "#6B6770"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 521.889H47.8018V556.316H34.743V521.889Z",
    fill: "#FFF9DE"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 556.845H48.3408V521.382H34.1804V556.845ZM47.2391 555.784H35.3089V522.417H47.2391V555.784Z",
    fill: "#6B6770"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 521.889H47.8018V538.534H34.743V521.889Z",
    fill: "white"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 539.063H48.3408V521.382H34.1804V539.063ZM47.2391 538.002H35.3089V522.443H47.2391V538.002Z",
    fill: "#6B6770"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 566.979H47.8018V601.381H34.743V566.979Z",
    fill: "#FFF9DE"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 601.911H48.3408V566.447H34.1804V601.911ZM47.2391 600.85H35.3089V567.483H47.2391V600.85Z",
    fill: "#6B6770"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 566.973H47.8018V583.593H34.743V566.973Z",
    fill: "white"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 584.099H48.3408V566.418H34.1804V584.099ZM47.2391 583.064H35.3089V567.504H47.2391V583.064Z",
    fill: "#6B6770"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 612.013H47.8018V646.415H34.743V612.013Z",
    fill: "#FFF9DE"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 646.97H48.3408V611.481H34.1804V646.97ZM47.2391 645.909H35.3089V612.542H47.2391V645.909Z",
    fill: "#6B6770"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M34.743 612.013H47.8018V628.633H34.743V612.013Z",
    fill: "#FFF9DE"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1804 629.163H48.3408V611.481H34.1804V629.163ZM47.2391 628.102H35.3089V612.542H47.2391V628.102Z",
    fill: "#6B6770"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7997 575.004C87.8094 574.995 87.8205 574.984 87.833 574.973C87.8841 574.925 87.9577 574.855 88.0463 574.764C88.2237 574.584 88.4607 574.326 88.699 574.015C89.18 573.387 89.6481 572.567 89.6737 571.748C89.68 571.548 89.6471 571.415 89.5988 571.329C89.5526 571.246 89.4867 571.195 89.401 571.166C89.2152 571.102 88.9362 571.141 88.6166 571.248C88.3055 571.352 87.9891 571.51 87.7482 571.644C87.6283 571.711 87.5283 571.77 87.4584 571.814C87.4235 571.835 87.3962 571.852 87.3777 571.864L87.3568 571.878L87.3517 571.881L87.3505 571.882L87.3503 571.882L87.3503 571.882L87.3502 571.882L87.3502 571.882L87.1301 571.674L87.1298 571.674L87.1298 571.674L87.1302 571.674L87.1327 571.669C87.1351 571.665 87.1389 571.658 87.1435 571.649C87.1529 571.631 87.166 571.604 87.18 571.571C87.2087 571.505 87.2393 571.418 87.2536 571.33C87.268 571.24 87.2633 571.163 87.237 571.104C87.2137 571.052 87.1661 570.997 87.0535 570.961C86.9601 570.931 86.811 570.952 86.6109 571.038C86.4179 571.121 86.2078 571.25 86.0103 571.39C85.8137 571.529 85.6347 571.674 85.5045 571.785C85.4395 571.84 85.387 571.887 85.3509 571.919C85.3328 571.936 85.3188 571.948 85.3095 571.957L85.299 571.967L85.2964 571.969L85.2958 571.97L85.2957 571.97L85.2957 571.97L85.2957 571.97L85.0374 572.213L85.0336 571.858L87.7997 575.004ZM87.7997 575.004H55.1562C55.1389 574.988 55.1167 574.968 55.0903 574.944C55.0212 574.882 54.9236 574.792 54.8103 574.682C54.5833 574.463 54.2955 574.169 54.0477 573.865C53.7957 573.556 53.6006 573.255 53.5374 573.02C53.5064 572.905 53.5128 572.825 53.5382 572.772C53.5617 572.723 53.615 572.668 53.7436 572.629C54.3255 572.451 55.0995 572.574 55.7506 572.756C56.0718 572.845 56.3549 572.947 56.5578 573.026C56.6591 573.065 56.7402 573.099 56.7957 573.123C56.8234 573.135 56.8447 573.145 56.859 573.151L56.8749 573.158L56.8788 573.16L56.8796 573.16L56.8798 573.16L56.8798 573.16L56.8799 573.16L57.0632 572.918L57.0633 572.918L57.0633 572.918L57.0631 572.918L57.0624 572.917L57.0594 572.913L57.0471 572.899C57.0364 572.886 57.0205 572.867 57.0005 572.842C56.9605 572.793 56.9041 572.723 56.8389 572.638C56.708 572.466 56.5434 572.237 56.4047 572.002C56.2635 571.763 56.1592 571.534 56.1331 571.359C56.1203 571.272 56.1289 571.215 56.1461 571.179C56.1607 571.149 56.1885 571.118 56.2558 571.097C56.4245 571.043 56.635 571.047 56.8676 571.094C57.0984 571.141 57.338 571.227 57.5573 571.323C57.776 571.418 57.9705 571.522 58.1106 571.602C58.1805 571.642 58.2365 571.676 58.2749 571.7C58.294 571.712 58.3087 571.721 58.3185 571.727L58.3295 571.734L58.332 571.736L58.3326 571.736L58.3326 571.736L87.7997 575.004ZM85.0336 571.858L85.0336 571.858L85.0336 571.857L85.0335 571.851L85.0327 571.825C85.0319 571.802 85.0304 571.769 85.0276 571.725C85.0221 571.638 85.0115 571.513 84.9913 571.361C84.9509 571.057 84.8723 570.651 84.7205 570.237C84.4159 569.407 83.8313 568.579 82.6947 568.438L82.6947 568.438C81.5208 568.293 80.7821 568.65 80.3368 569.031C80.1122 569.224 79.9593 569.425 79.8628 569.577C79.8147 569.653 79.7808 569.717 79.7593 569.761C79.7486 569.783 79.741 569.8 79.7362 569.81L79.7312 569.822L79.7303 569.825L79.7302 569.825L79.7302 569.825L79.7302 569.825L79.7301 569.825L79.5796 570.214L79.4388 569.821L79.4388 569.821L79.4388 569.821L79.4388 569.821L79.4387 569.821L79.4379 569.819L79.4343 569.809C79.431 569.8 79.4259 569.787 79.419 569.77C79.4052 569.736 79.3842 569.687 79.3563 569.628C79.3001 569.509 79.2166 569.351 79.1069 569.194C78.8816 568.87 78.5749 568.588 78.1978 568.578C78.0004 568.573 77.8761 568.623 77.795 568.688C77.712 568.753 77.659 568.845 77.6265 568.948C77.5939 569.052 77.5844 569.159 77.5837 569.243C77.5834 569.284 77.5853 569.319 77.5872 569.342C77.5881 569.354 77.589 569.363 77.5897 569.368L77.5904 569.374L77.5905 569.375L77.5905 569.375C77.5905 569.375 77.5905 569.375 77.5901 569.375L77.3106 569.488C77.3102 569.488 77.3102 569.488 77.3102 569.488L77.3102 569.488L77.3101 569.488L77.3085 569.486L77.3001 569.475C77.2923 569.465 77.2798 569.449 77.2626 569.429C77.2283 569.389 77.1752 569.331 77.1024 569.261C76.9568 569.122 76.7327 568.937 76.4225 568.762C75.8038 568.412 74.8359 568.095 73.4513 568.253C72.0838 568.409 71.2932 569.093 70.8414 569.736C70.6143 570.059 70.4722 570.372 70.387 570.604C70.3444 570.72 70.3162 570.816 70.2988 570.882C70.2901 570.914 70.2841 570.94 70.2803 570.956L70.2764 570.975L70.2755 570.979L70.2754 570.98L70.2754 570.98L70.2754 570.98L70.2754 570.98L70.2241 571.253L70.0181 571.066L85.0336 571.858ZM65.3297 571.836L65.0454 571.953C65.0435 571.954 65.0435 571.954 65.0435 571.954L65.0434 571.954L65.0432 571.953L65.0413 571.949L65.0325 571.932C65.0243 571.916 65.0116 571.891 64.994 571.859C64.9587 571.796 64.904 571.704 64.8275 571.591C64.6745 571.366 64.4347 571.059 64.0899 570.737C63.4013 570.096 62.2913 569.395 60.6075 569.173C59.7655 569.062 59.2379 569.169 58.9118 569.365C58.5913 569.558 58.4421 569.85 58.3866 570.17C58.3303 570.493 58.3723 570.836 58.4317 571.105C58.4612 571.238 58.4943 571.35 58.52 571.428C58.5328 571.468 58.5437 571.498 58.5512 571.519L58.5599 571.542L58.562 571.547L58.5624 571.548L58.5625 571.548L58.5625 571.548L58.5625 571.548L58.7497 572.011L58.3327 571.736L65.3297 571.836Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.311136
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M117.432 575.004C117.438 574.997 117.446 574.989 117.453 574.98C117.498 574.933 117.562 574.862 117.639 574.772C117.793 574.592 117.998 574.334 118.206 574.023C118.623 573.396 119.032 572.574 119.055 571.748C119.06 571.546 119.031 571.41 118.988 571.321C118.947 571.237 118.891 571.19 118.825 571.164C118.677 571.105 118.446 571.138 118.169 571.245C117.901 571.349 117.628 571.506 117.419 571.639C117.316 571.705 117.229 571.765 117.168 571.808C117.138 571.829 117.115 571.847 117.099 571.859L117.081 571.872L117.076 571.875L117.075 571.876L117.075 571.876L117.075 571.876L117.075 571.876L117.075 571.876L116.842 571.682L116.842 571.682L116.842 571.682L116.842 571.682L116.844 571.677C116.847 571.672 116.85 571.665 116.854 571.656C116.862 571.638 116.874 571.611 116.886 571.578C116.911 571.511 116.938 571.424 116.951 571.333C116.964 571.241 116.96 571.16 116.935 571.097C116.914 571.041 116.873 570.991 116.785 570.958C116.719 570.934 116.602 570.949 116.428 571.035C116.263 571.116 116.082 571.244 115.911 571.384C115.74 571.522 115.585 571.667 115.472 571.778C115.416 571.833 115.37 571.879 115.339 571.912C115.323 571.928 115.311 571.941 115.303 571.949L115.294 571.959L115.292 571.961L115.291 571.962L115.291 571.962L115.291 571.962L115.291 571.962L115.025 572.25L115.021 571.858V571.858L115.021 571.858L115.021 571.858L115.021 571.856L115.021 571.85L115.02 571.824C115.02 571.802 115.018 571.768 115.016 571.724C115.011 571.637 115.002 571.511 114.984 571.359C114.949 571.054 114.881 570.646 114.748 570.231C114.48 569.391 113.971 568.576 113.003 568.438L113.003 568.438C111.997 568.295 111.364 568.646 110.98 569.024C110.786 569.215 110.653 569.416 110.569 569.569C110.527 569.645 110.497 569.709 110.479 569.753C110.469 569.775 110.462 569.792 110.458 569.803L110.454 569.816L110.453 569.818L110.453 569.818L110.453 569.818L110.453 569.818L110.453 569.818L110.3 570.273L110.157 569.815L110.157 569.815L110.157 569.815L110.157 569.815L110.157 569.814L110.156 569.812L110.153 569.803C110.15 569.794 110.146 569.781 110.14 569.763C110.128 569.729 110.109 569.68 110.085 569.621C110.036 569.501 109.963 569.343 109.868 569.185C109.668 568.856 109.406 568.588 109.098 568.578C108.936 568.574 108.837 568.62 108.77 568.681C108.7 568.744 108.653 568.836 108.624 568.943C108.595 569.048 108.587 569.158 108.586 569.243C108.586 569.285 108.587 569.32 108.589 569.344C108.59 569.356 108.591 569.365 108.591 569.371L108.592 569.377L108.592 569.378L108.592 569.378C108.592 569.378 108.592 569.378 108.592 569.378L108.306 569.479C108.306 569.48 108.306 569.48 108.306 569.48L108.306 569.48L108.306 569.48L108.304 569.478L108.297 569.467C108.29 569.457 108.279 569.441 108.265 569.421C108.235 569.381 108.189 569.323 108.126 569.253C108 569.114 107.806 568.931 107.538 568.757C107.005 568.41 106.172 568.096 104.978 568.253C103.804 568.407 103.121 569.083 102.727 569.727C102.529 570.05 102.406 570.365 102.331 570.598C102.294 570.715 102.269 570.81 102.254 570.877C102.246 570.91 102.241 570.935 102.238 570.952L102.234 570.971L102.234 570.975L102.234 570.976L102.234 570.976L102.233 570.976L102.183 571.284L101.968 571.059L101.968 571.059L101.968 571.059L101.968 571.059L101.968 571.058L101.966 571.057L101.961 571.052C101.956 571.046 101.948 571.038 101.937 571.028C101.916 571.008 101.884 570.978 101.844 570.943C101.763 570.873 101.649 570.782 101.514 570.696C101.236 570.519 100.903 570.387 100.599 570.459C100.489 570.485 100.41 570.569 100.361 570.729C100.31 570.891 100.299 571.105 100.312 571.329C100.324 571.549 100.359 571.767 100.391 571.93C100.407 572.012 100.423 572.079 100.434 572.126C100.439 572.149 100.444 572.167 100.447 572.179L100.45 572.193L100.451 572.196L100.451 572.197L100.451 572.197L100.451 572.197L117.432 575.004ZM117.432 575.004H89.0844C89.0706 574.989 89.0539 574.972 89.0346 574.952C88.9746 574.889 88.8898 574.8 88.7914 574.69C88.5942 574.471 88.3443 574.177 88.1289 573.873C87.9105 573.565 87.7398 573.263 87.6842 573.025C87.6566 572.907 87.6616 572.823 87.6856 572.765C87.707 572.713 87.7518 572.663 87.8545 572.627C88.3483 572.453 89.0105 572.572 89.5758 572.754C89.8536 572.843 90.0986 572.944 90.2742 573.023C90.3619 573.062 90.432 573.096 90.48 573.12C90.5039 573.132 90.5223 573.141 90.5346 573.147L90.5483 573.154L90.5515 573.156L90.5522 573.156L90.5523 573.156L90.5524 573.156L90.5524 573.156L90.7501 572.926L90.7502 572.926L90.7502 572.926L90.7501 572.926L90.7495 572.925L90.7468 572.922L90.7362 572.907C90.7268 572.894 90.7131 572.875 90.6957 572.851C90.6609 572.802 90.6119 572.731 90.5552 572.646C90.4415 572.475 90.2983 572.246 90.1776 572.01C90.0551 571.771 89.9633 571.54 89.9401 571.362C89.9286 571.273 89.9361 571.211 89.9526 571.172C89.9664 571.139 89.9896 571.113 90.0387 571.095C90.1762 571.044 90.3509 571.047 90.5497 571.093C90.7466 571.139 90.9523 571.224 91.1419 571.319C91.3307 571.414 91.4989 571.517 91.6202 571.597C91.6806 571.637 91.7291 571.671 91.7622 571.694C91.7788 571.706 91.7915 571.715 91.7999 571.722L91.8093 571.729L91.8115 571.73L91.812 571.73L91.812 571.731L117.432 575.004ZM100.451 572.197L100.167 572.316L100.167 572.316L100.167 572.316L100.167 572.316L100.167 572.316L100.166 572.315L100.164 572.31L100.153 572.292C100.143 572.276 100.129 572.252 100.11 572.222C100.073 572.161 100.018 572.074 99.9494 571.969C99.8124 571.759 99.6209 571.48 99.4022 571.201C99.1828 570.921 98.9395 570.645 98.6995 570.441C98.4532 570.23 98.2369 570.118 98.0686 570.114C97.9852 570.113 97.9312 570.133 97.8932 570.162C97.8537 570.191 97.8191 570.238 97.7921 570.309C97.7361 570.455 97.7261 570.668 97.7464 570.904C97.7664 571.135 97.8136 571.37 97.8565 571.548C97.8778 571.637 97.8979 571.711 97.9125 571.762C97.9198 571.788 97.9258 571.808 97.9299 571.822L97.9345 571.837L97.9357 571.841L97.9359 571.841L97.936 571.842L97.936 571.842L100.451 572.197ZM97.935 571.842L97.6454 571.946C97.6434 571.947 97.6434 571.947 97.6434 571.947L97.6433 571.947L97.6431 571.946L97.6414 571.942L97.6337 571.924C97.6265 571.908 97.6154 571.883 97.6001 571.852C97.5693 571.788 97.5217 571.696 97.4552 571.583C97.322 571.357 97.1137 571.05 96.8145 570.73C96.217 570.089 95.257 569.393 93.8033 569.173C93.0774 569.063 92.6291 569.17 92.3538 569.36C92.0804 569.549 91.9483 569.841 91.899 570.166C91.8495 570.493 91.8865 570.84 91.9384 571.109C91.9642 571.243 91.9931 571.355 92.0155 571.434C92.0267 571.474 92.0362 571.504 92.0428 571.525L92.0504 571.548L92.0523 571.554L92.0527 571.555L92.0527 571.555L92.0527 571.555L92.0527 571.555L92.2243 572.043L91.812 571.731L97.935 571.842Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.311136
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M118.926 573.762H53.7737V576.534H118.926V573.762Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.311136
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6695 611.848C64.9651 611.848 70.0686 616.951 70.0686 623.247C70.0686 629.542 64.9651 634.646 58.6695 634.646C52.3738 634.646 47.2705 629.542 47.2705 623.247C47.2705 616.951 52.3738 611.848 58.6695 611.848Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6692 616.123H59.6216C64.6086 616.123 68.6435 620.165 68.6435 625.145C68.6435 630.132 64.6014 634.167 59.6216 634.167H58.6692C53.6821 634.167 49.6475 630.125 49.6475 625.145C49.6475 620.158 53.6894 616.123 58.6692 616.123Z",
    fill: "#62AE80"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1895 624.668V659.81",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8412 625.625L58.1895 632.277",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0176 625.625L58.6693 632.277",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8638 611.848C80.1594 611.848 85.2627 616.951 85.2627 623.247C85.2627 629.542 80.1594 634.646 73.8638 634.646C67.5682 634.646 62.4648 629.542 62.4648 623.247C62.4648 616.951 67.5682 611.848 73.8638 611.848Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8627 616.123H74.8151C79.8022 616.123 83.8368 620.165 83.8368 625.145C83.8368 630.132 79.7949 634.167 74.8151 634.167H73.8627C68.8757 634.167 64.8408 630.125 64.8408 625.145C64.8408 620.158 68.8829 616.123 73.8627 616.123Z",
    fill: "#62AE80"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3906 624.668V659.81",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0426 625.625L73.3906 632.277",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2188 625.625L73.8707 632.277",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M89.064 611.848C95.3596 611.848 100.463 616.951 100.463 623.247C100.463 629.542 95.3596 634.646 89.064 634.646C82.7684 634.646 77.665 629.542 77.665 623.247C77.665 616.951 82.7684 611.848 89.064 611.848Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0637 616.123H90.0161C95.0032 616.123 99.0378 620.165 99.0378 625.145C99.0378 630.132 94.9959 634.167 90.0161 634.167H89.0637C84.0766 634.167 80.042 630.125 80.042 625.145C80.042 620.158 84.0839 616.123 89.0637 616.123Z",
    fill: "#62AE80"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2358 625.625L88.584 632.277",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4121 625.625L89.0639 632.277",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M88.584 624.668V659.81",
    stroke: "#382456",
    strokeWidth: 0.726977
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 553.117C123.45 553.117 123.94 553.6 123.94 554.203V571.554C123.94 572.15 123.457 572.64 122.855 572.64C122.259 572.64 121.77 572.156 121.77 571.554V554.203C121.77 553.607 122.253 553.117 122.855 553.117Z",
    fill: "#615E66"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M160.808 554.558H123.94V561.784H160.808V554.558Z",
    fill: "#FFF9DE"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M160.808 559.62H123.94V560.341H160.808V559.62Z",
    fill: "#615E66"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M160.808 556.733H123.94V557.455H160.808V556.733Z",
    fill: "#615E66"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M158.636 554.203C158.636 553.6 159.119 553.117 159.715 553.117C160.31 553.117 160.806 553.6 160.806 554.203V571.554C160.806 572.15 160.323 572.64 159.715 572.64C159.106 572.64 158.636 572.156 158.636 571.554V554.203Z",
    fill: "#615E66"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M128.64 565.402C129.236 565.402 129.725 565.885 129.725 566.488V572.993C129.725 573.588 129.242 574.078 128.64 574.078C128.044 574.078 127.555 573.595 127.555 572.993V566.488C127.555 565.892 128.038 565.402 128.64 565.402Z",
    fill: "#615E66"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M164.779 565.402C165.374 565.402 165.864 565.885 165.864 566.488V572.993C165.864 573.588 165.381 574.078 164.779 574.078C164.183 574.078 163.693 573.595 163.693 572.993V566.488C163.693 565.892 164.176 565.402 164.779 565.402Z",
    fill: "#615E66"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M123.941 565.407L121.771 563.601H160.809L165.864 565.407V567.578H127.554L123.941 565.407Z",
    fill: "#FFF9DE"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M165.871 565.402H127.555V567.573H165.871V565.402Z",
    fill: "#615E66"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M121.771 563.601L127.554 565.407V568.299L121.771 565.771V563.601Z",
    fill: "#615E66"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9215 653.547C50.9458 653.529 50.9767 653.506 51.0137 653.478C51.1137 653.402 51.2573 653.29 51.4303 653.147C51.7766 652.861 52.2389 652.452 52.7037 651.96C53.644 650.963 54.5505 649.669 54.6001 648.384C54.612 648.073 54.5497 647.868 54.4557 647.731C54.363 647.597 54.2227 647.504 54.0303 647.451C53.6302 647.339 53.0544 647.41 52.4305 647.58C51.8165 647.747 51.1951 647.999 50.7244 648.212C50.4898 648.317 50.294 648.413 50.1572 648.481C50.0888 648.516 50.0352 648.543 49.9989 648.562L49.9578 648.584L49.9475 648.589L49.9451 648.591L49.9446 648.591L49.9445 648.591L49.9445 648.591L49.9444 648.591L49.6545 648.261C49.654 648.261 49.654 648.261 49.654 648.261L49.6541 648.261L49.6549 648.26L49.66 648.252C49.6647 648.245 49.672 648.234 49.6811 648.22C49.6994 648.191 49.7248 648.149 49.7522 648.097C49.808 647.992 49.8668 647.857 49.894 647.72C49.9213 647.583 49.9124 647.467 49.863 647.377C49.8165 647.292 49.7122 647.191 49.463 647.126C49.239 647.068 48.9146 647.114 48.5219 647.251C48.1373 647.385 47.7225 647.593 47.3365 647.815C46.9517 648.036 46.6017 648.266 46.3475 648.442C46.2206 648.53 46.1179 648.604 46.0472 648.655C46.0119 648.681 45.9846 648.701 45.9662 648.715L45.9455 648.731L45.9404 648.735L45.9393 648.735L45.939 648.736L45.939 648.736L45.939 648.736L45.5824 649.008L45.5765 648.56L45.5765 648.559L45.5765 648.559L45.5765 648.559L45.5764 648.557L45.5762 648.548C45.576 648.539 45.5755 648.526 45.5747 648.508C45.5732 648.473 45.5703 648.419 45.5649 648.351C45.5542 648.214 45.5337 648.017 45.4946 647.778C45.4162 647.3 45.2638 646.66 44.9691 646.007C44.3825 644.709 43.2379 643.367 40.9658 643.139L40.9658 643.139C38.6467 642.906 37.18 643.48 36.2979 644.093C35.8548 644.401 35.5547 644.722 35.3664 644.964C35.2723 645.085 35.2062 645.186 35.1644 645.255C35.1434 645.29 35.1286 645.316 35.1193 645.334C35.1147 645.342 35.1115 645.349 35.1096 645.352L35.1079 645.356L35.1077 645.356L35.1076 645.356L35.1075 645.356L34.8964 645.799L34.6979 645.35L34.6979 645.35L34.6979 645.35L34.6978 645.35L34.6976 645.349L34.6962 645.346L34.6892 645.331C34.6828 645.318 34.6729 645.297 34.6595 645.27C34.6326 645.217 34.5919 645.139 34.5375 645.045C34.4284 644.858 34.2656 644.608 34.051 644.357C33.6179 643.852 33.0005 643.376 32.2092 643.359C31.8005 643.351 31.5333 643.436 31.3571 643.549C31.182 643.661 31.0785 643.813 31.017 643.971C30.9544 644.132 30.9363 644.299 30.9351 644.429C30.9345 644.493 30.9381 644.547 30.9416 644.583C30.9434 644.601 30.9451 644.615 30.9464 644.623L30.9477 644.632L30.9478 644.633L30.9478 644.633L30.9478 644.633L30.9479 644.634L30.9479 644.634L31.0884 645.423L30.557 644.822L30.5569 644.822L30.5568 644.822L30.5566 644.822L30.5565 644.822L30.5531 644.818C30.5497 644.815 30.5441 644.809 30.5363 644.8C30.5206 644.784 30.496 644.759 30.4621 644.727C30.3944 644.663 30.2899 644.57 30.1467 644.458C29.8605 644.236 29.4194 643.941 28.8084 643.66C27.5881 643.1 25.6817 642.594 22.9623 642.846C20.2625 643.096 18.706 644.194 17.8234 645.213C17.3801 645.725 17.1035 646.221 16.9382 646.587C16.8556 646.77 16.8009 646.921 16.7672 647.024C16.7504 647.075 16.7388 647.115 16.7316 647.141C16.728 647.154 16.7255 647.164 16.7239 647.17L16.7224 647.176L16.7222 647.177L16.7222 647.177L16.7221 647.177L50.9215 653.547ZM50.9215 653.547H-12.6443C-12.6807 653.521 -12.7336 653.482 -12.7998 653.434C-12.9347 653.335 -13.1249 653.192 -13.3457 653.019C-13.7883 652.672 -14.3495 652.206 -14.8332 651.724C-15.3258 651.233 -15.706 650.756 -15.8282 650.387C-15.8872 650.208 -15.8744 650.091 -15.8272 650.011C-15.7782 649.928 -15.6593 649.828 -15.3834 649.76C-14.2175 649.471 -12.6834 649.672 -11.4149 649.96C-10.7858 650.102 -10.2316 650.264 -9.83473 650.39C-9.63641 650.452 -9.47766 650.506 -9.36882 650.544C-9.31441 650.563 -9.27249 650.578 -9.24436 650.589L-9.21268 650.6L-9.2049 650.603L-9.20308 650.604L-9.20269 650.604L-9.20266 650.604L-9.20258 650.604L-8.96814 650.229L-8.96807 650.229L-8.9681 650.229L-8.9684 650.229L-8.96982 650.227L-8.9758 650.222L-8.99977 650.198C-9.02086 650.178 -9.05183 650.148 -9.09082 650.109C-9.16885 650.031 -9.27883 649.92 -9.406 649.785C-9.66113 649.514 -9.98189 649.151 -10.2523 648.779C-10.5284 648.399 -10.7297 648.038 -10.7797 647.766C-10.8039 647.634 -10.7878 647.55 -10.7556 647.495C-10.7253 647.444 -10.6586 647.382 -10.4991 647.341C-10.1448 647.249 -9.71281 647.259 -9.25068 647.334C-8.79109 647.41 -8.31731 647.548 -7.88711 647.701C-7.45759 647.853 -7.07605 648.019 -6.80176 648.146C-6.66476 648.21 -6.55487 648.264 -6.47956 648.302C-6.44191 648.321 -6.41291 648.336 -6.39352 648.346L-6.37175 648.357L-6.36649 648.36L-6.3653 648.361L-6.36509 648.361L-6.36505 648.361L-5.74129 648.694L-6.05657 648.061L-6.05659 648.061L-6.05667 648.061L-6.05668 648.061L-6.05754 648.059L-6.06162 648.051C-6.06536 648.043 -6.07107 648.031 -6.0784 648.015C-6.09307 647.982 -6.1142 647.934 -6.13904 647.872C-6.1888 647.749 -6.25302 647.573 -6.31009 647.363C-6.42539 646.94 -6.50596 646.403 -6.39765 645.897C-6.29191 645.404 -6.00501 644.931 -5.35575 644.614C-4.69371 644.291 -3.63801 644.122 -1.98573 644.299C1.31643 644.652 3.49326 645.769 4.84094 646.789C5.51556 647.299 5.98403 647.787 6.28252 648.144C6.43177 648.323 6.5385 648.469 6.60721 648.569C6.64156 648.619 6.66641 648.658 6.6823 648.684C6.68623 648.69 6.68961 648.695 6.69246 648.7C6.69537 648.705 6.69771 648.709 6.6995 648.712L6.7032 648.718L6.7037 648.719L6.70381 648.719C6.7038 648.719 6.70378 648.719 6.70648 648.717L7.10403 648.515L50.9215 653.547ZM16.3685 647.308L16.3686 647.308L16.3685 647.308ZM16.3685 647.308L16.368 647.308L16.3651 647.305L16.3518 647.296C16.3397 647.287 16.3213 647.274 16.2971 647.258C16.2486 647.225 16.1767 647.178 16.0851 647.121C15.9016 647.009 15.6403 646.861 15.3296 646.722C14.7022 646.44 13.9028 646.207 13.1455 646.333C12.8134 646.388 12.6326 646.56 12.5298 646.793C12.4201 647.041 12.3958 647.37 12.4241 647.719C12.4521 648.063 12.5293 648.403 12.6007 648.66C12.6362 648.788 12.6699 648.893 12.6946 648.966C12.7069 649.003 12.717 649.031 12.7238 649.05L12.7316 649.072L12.7335 649.077L12.7339 649.078L12.7339 649.078L12.7339 649.078L16.3685 647.308ZM12.7334 649.078L12.3497 649.302L12.3496 649.302L12.3496 649.302L12.3493 649.302L12.3478 649.3L12.3418 649.293L12.3173 649.264C12.2957 649.239 12.2634 649.201 12.2214 649.153C12.1375 649.057 12.0151 648.919 11.8618 648.753C11.5549 648.421 11.1255 647.979 10.6346 647.537C10.1429 647.094 9.59438 646.655 9.04915 646.327C8.49924 645.995 7.97678 645.791 7.53192 645.785C7.09414 645.779 6.88946 645.935 6.78289 646.132C6.6627 646.353 6.63976 646.677 6.68471 647.046C6.72877 647.407 6.83327 647.774 6.92886 648.054C6.97635 648.194 7.02098 648.31 7.05358 648.391C7.06987 648.431 7.08312 648.463 7.09217 648.484L7.10246 648.508L7.10496 648.513L7.1055 648.515L7.10555 648.515L7.10559 648.515L12.7334 649.078Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.451246
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5468 652.064H-15.7639V656.084H52.5468V652.064Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.451246
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.63 445.019H1082.7V470.469H1056.63V445.019Z",
    fill: "#FDFDE7"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.98 470.48V445.03C1082.98 444.867 1082.85 444.75 1082.7 444.75H1056.63C1056.47 444.75 1056.34 444.878 1056.34 445.03V470.48C1056.34 470.632 1056.47 470.76 1056.63 470.76H1082.7C1082.85 470.76 1082.98 470.632 1082.98 470.48ZM1056.91 445.298H1082.41V470.201H1056.91V445.298Z",
    fill: "#706D74"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.63 449.537H1099.7V475H1073.63V449.537Z",
    fill: "#E8CD9C"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.98 475V449.537C1099.98 449.386 1099.85 449.258 1099.69 449.258H1073.62C1073.47 449.258 1073.34 449.386 1073.34 449.537V475C1073.34 475.163 1073.47 475.291 1073.62 475.291H1099.7C1099.86 475.291 1099.99 475.163 1099.99 475H1099.98ZM1073.91 449.829H1099.41V474.72H1073.91V449.829Z",
    fill: "#706D74"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.23 445.019H1045.3V470.469H1019.23V445.019Z",
    fill: "#FDFDE7"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.58 470.48V445.03C1045.58 444.867 1045.45 444.75 1045.3 444.75H1019.23C1019.07 444.75 1018.95 444.878 1018.95 445.03V470.48C1018.95 470.632 1019.08 470.76 1019.23 470.76H1045.3C1045.45 470.76 1045.58 470.632 1045.58 470.48ZM1019.51 445.298H1045.01V470.201H1019.51V445.298Z",
    fill: "#706D74"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.24 449.537H1062.29V475H1036.24V449.537Z",
    fill: "#E8CD9C"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.58 475V449.537C1062.58 449.386 1062.45 449.258 1062.29 449.258H1036.23C1036.07 449.258 1035.96 449.386 1035.96 449.537V475C1035.96 475.163 1036.08 475.291 1036.23 475.291H1062.29C1062.45 475.291 1062.58 475.163 1062.58 475ZM1036.51 449.829H1062.01V474.72H1036.51V449.829Z",
    fill: "#706D74"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.49 457.649H1104.77V648.67H1008.49V457.649Z",
    fill: "#FAF3CE",
    stroke: "#706D74",
    strokeWidth: 0.47922
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.05 648.67V457.65C1105.05 457.498 1104.92 457.37 1104.77 457.37H1008.49C1008.34 457.37 1008.21 457.498 1008.21 457.65V648.67C1008.21 648.834 1008.34 648.962 1008.49 648.962H1104.77C1104.93 648.962 1105.05 648.834 1105.05 648.67ZM1008.77 457.929H1104.48V648.391H1008.77V457.929Z",
    fill: "#C7CACB",
    stroke: "#706D74",
    strokeWidth: 0.47922
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 608.827H1052.04V617.8H1042.86V608.827Z",
    fill: "#FDFDE7"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 608.547H1042.58V618.079H1052.32V608.547ZM1043.14 609.106H1051.76V617.52H1043.14V609.106Z",
    fill: "#706D74"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 608.827H1042.84V617.8H1033.66V608.827Z",
    fill: "#FDFDE7"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 608.547H1033.38V618.079H1043.13V608.547ZM1033.94 609.106H1042.56V617.52H1033.94V609.106Z",
    fill: "#706D74"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 599.853H1042.84V608.814H1033.66V599.853Z",
    fill: "#FDFDE7"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 599.573H1033.38V609.106H1043.13V599.573ZM1033.94 600.133H1042.56V608.546H1033.94V600.133Z",
    fill: "#706D74"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 581.91H1042.84V590.883H1033.66V581.91Z",
    fill: "#FDFDE7"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 581.629H1033.38V591.161H1043.13V581.629ZM1033.94 582.188H1042.56V590.59H1033.94V582.188Z",
    fill: "#706D74"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 546.028H1042.84V555.001H1033.66V546.028Z",
    fill: "#FDFDE7"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 545.737H1033.38V555.281H1043.13V545.737ZM1033.94 546.308H1042.56V554.722H1033.94V546.308Z",
    fill: "#706D74"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 528.082H1042.84V537.055H1033.66V528.082Z",
    fill: "#FDFDE7"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 527.791H1033.38V537.323H1043.13V527.791ZM1033.94 528.362H1042.56V536.764H1033.94V528.362Z",
    fill: "#706D74"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 519.107H1042.84V528.08H1033.66V519.107Z",
    fill: "#FDFDE7"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 518.816H1033.38V528.349H1043.13V518.816ZM1033.94 519.387H1042.56V527.789H1033.94V519.387Z",
    fill: "#706D74"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 501.162H1042.84V510.123H1033.66V501.162Z",
    fill: "#FDFDE7"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 500.883H1033.38V510.415H1043.13V500.883ZM1033.94 501.442H1042.56V509.856H1033.94V501.442Z",
    fill: "#706D74"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 492.19H1042.84V501.163H1033.66V492.19Z",
    fill: "#FDFDE7"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 491.909H1033.38V501.442H1043.13V491.909ZM1033.94 492.48H1042.56V500.882H1033.94V492.48Z",
    fill: "#706D74"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 554.997H1042.84V563.97H1033.66V554.997Z",
    fill: "#FDFDE7"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 554.707H1033.38V564.239H1043.13V554.707ZM1033.94 555.278H1042.56V563.68H1033.94V555.278Z",
    fill: "#706D74"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 572.936H1042.84V581.909H1033.66V572.936Z",
    fill: "#FDFDE7"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 572.656H1033.38V582.189H1043.13V572.656ZM1033.94 573.216H1042.56V581.629H1033.94V573.216Z",
    fill: "#706D74"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 474.242H1052.04V483.215H1042.86V474.242Z",
    fill: "#FDFDE7"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 473.962H1042.58V483.506H1052.32V473.962ZM1043.14 474.533H1051.76V482.935H1043.14V474.533Z",
    fill: "#706D74"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 501.162H1033.66V510.123H1024.48V501.162Z",
    fill: "#FDFDE7"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 500.883H1024.19V510.415H1033.94V500.883ZM1024.76 501.442H1033.38V509.856H1024.76V501.442Z",
    fill: "#706D74"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 474.242H1033.66V483.215H1024.48V474.242Z",
    fill: "#FDFDE7"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 473.962H1024.19V483.506H1033.94V473.962ZM1024.76 474.533H1033.38V482.935H1024.76V474.533Z",
    fill: "#706D74"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 492.19H1033.66V501.163H1024.48V492.19Z",
    fill: "#FDFDE7"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 491.909H1024.19V501.442H1033.94V491.909ZM1024.76 492.48H1033.38V500.882H1024.76V492.48Z",
    fill: "#706D74"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 474.242H1042.84V483.215H1033.66V474.242Z",
    fill: "#FDFDE7"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 473.962H1033.38V483.506H1043.13V473.962ZM1033.94 474.533H1042.56V482.935H1033.94V474.533Z",
    fill: "#706D74"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 501.162H1052.04V510.123H1042.86V501.162Z",
    fill: "#FDFDE7"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 500.883H1042.58V510.415H1052.32V500.883ZM1043.14 501.442H1051.76V509.856H1043.14V501.442Z",
    fill: "#706D74"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 519.107H1052.04V528.08H1042.86V519.107Z",
    fill: "#FDFDE7"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 518.816H1042.58V528.349H1052.32V518.816ZM1043.14 519.387H1051.76V527.789H1043.14V519.387Z",
    fill: "#706D74"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 492.188H1052.04V501.162H1042.86V492.188Z",
    fill: "#FDFDE7"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 491.909H1042.58V501.442H1052.32V491.909ZM1043.14 492.48H1051.76V500.882H1043.14V492.48Z",
    fill: "#706D74"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 554.997H1052.04V563.97H1042.86V554.997Z",
    fill: "#FDFDE7"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 554.707H1042.58V564.239H1052.32V554.707ZM1043.14 555.278H1051.76V563.68H1043.14V555.278Z",
    fill: "#706D74"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 528.08H1052.04V537.053H1042.86V528.08Z",
    fill: "#FDFDE7"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 527.789H1042.58V537.321H1052.32V527.789ZM1043.14 528.36H1051.76V536.762H1043.14V528.36Z",
    fill: "#706D74"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 546.028H1052.04V555.001H1042.86V546.028Z",
    fill: "#FDFDE7"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 545.737H1042.58V555.281H1052.32V545.737ZM1043.14 546.308H1051.76V554.722H1043.14V546.308Z",
    fill: "#706D74"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 572.934H1052.04V581.907H1042.86V572.934Z",
    fill: "#FDFDE7"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 572.654H1042.58V582.187H1052.32V572.654ZM1043.14 573.214H1051.76V581.627H1043.14V573.214Z",
    fill: "#706D74"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 599.853H1052.04V608.814H1042.86V599.853Z",
    fill: "#FDFDE7"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 599.573H1042.58V609.106H1052.32V599.573ZM1043.14 600.133H1051.76V608.546H1043.14V600.133Z",
    fill: "#706D74"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 581.91H1052.04V590.883H1042.86V581.91Z",
    fill: "#FDFDE7"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 581.629H1042.58V591.161H1052.32V581.629ZM1043.14 582.188H1051.76V590.59H1043.14V582.188Z",
    fill: "#706D74"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 626.772H1042.84V635.046H1033.66V626.772Z",
    fill: "#FDFDE7"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 626.493H1033.38V635.338H1043.13V626.493ZM1033.94 627.053H1042.56V634.767H1033.94V627.053Z",
    fill: "#706D74"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 599.853H1024.48V608.814H1015.25V599.853Z",
    fill: "#FDFDE7"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 599.573H1014.96V609.106H1024.76V599.573ZM1015.53 600.133H1024.19V608.546H1015.53V600.133Z",
    fill: "#706D74"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 581.91H1024.48V590.883H1015.25V581.91Z",
    fill: "#FDFDE7"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 581.629H1014.96V591.161H1024.76V581.629ZM1015.53 582.188H1024.19V590.59H1015.53V582.188Z",
    fill: "#706D74"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 608.827H1024.48V617.8H1015.25V608.827Z",
    fill: "#FDFDE7"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 608.547H1014.96V618.079H1024.76V608.547ZM1015.53 609.106H1024.19V617.52H1015.53V609.106Z",
    fill: "#706D74"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 465.97H1024.48V474.244H1015.25V465.97Z",
    fill: "#FDFDE7"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 465.689H1014.96V474.534H1024.76V465.689ZM1015.53 466.249H1024.19V473.963H1015.53V466.249Z",
    fill: "#706D74"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 626.772H1033.66V635.046H1024.48V626.772Z",
    fill: "#FDFDE7"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 626.493H1024.19V635.338H1033.94V626.493ZM1024.76 627.053H1033.38V634.767H1024.76V627.053Z",
    fill: "#706D74"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 626.772H1024.48V635.046H1015.25V626.772Z",
    fill: "#FDFDE7"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 626.493H1014.96V635.338H1024.76V626.493ZM1015.53 627.053H1024.19V634.767H1015.53V627.053Z",
    fill: "#706D74"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 572.934H1024.48V581.907H1015.25V572.934Z",
    fill: "#FDFDE7"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 572.654H1014.96V582.187H1024.76V572.654ZM1015.53 573.214H1024.19V581.627H1015.53V573.214Z",
    fill: "#706D74"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 492.188H1024.48V501.162H1015.25V492.188Z",
    fill: "#FDFDE7"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 491.909H1014.96V501.442H1024.76V491.909ZM1015.53 492.48H1024.19V500.882H1015.53V492.48Z",
    fill: "#706D74"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 501.162H1024.48V510.123H1015.25V501.162Z",
    fill: "#FDFDE7"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 500.883H1014.96V510.415H1024.76V500.883ZM1015.53 501.442H1024.19V509.856H1015.53V501.442Z",
    fill: "#706D74"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 474.242H1024.48V483.215H1015.25V474.242Z",
    fill: "#FDFDE7"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 473.962H1014.96V483.506H1024.76V473.962ZM1015.53 474.533H1024.19V482.935H1015.53V474.533Z",
    fill: "#706D74"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 519.107H1024.48V528.08H1015.25V519.107Z",
    fill: "#FDFDE7"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 518.816H1014.96V528.349H1024.76V518.816ZM1015.53 519.387H1024.19V527.789H1015.53V519.387Z",
    fill: "#706D74"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 546.028H1024.48V555.001H1015.25V546.028Z",
    fill: "#FDFDE7"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 545.737H1014.96V555.281H1024.76V545.737ZM1015.53 546.308H1024.19V554.722H1015.53V546.308Z",
    fill: "#706D74"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 554.997H1024.48V563.97H1015.25V554.997Z",
    fill: "#FDFDE7"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 554.707H1014.96V564.239H1024.76V554.707ZM1015.53 555.278H1024.19V563.68H1015.53V555.278Z",
    fill: "#706D74"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.25 528.082H1024.48V537.055H1015.25V528.082Z",
    fill: "#FDFDE7"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.76 527.791H1014.96V537.323H1024.76V527.791ZM1015.53 528.362H1024.19V536.764H1015.53V528.362Z",
    fill: "#706D74"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 626.772H1052.04V635.046H1042.86V626.772Z",
    fill: "#FDFDE7"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 626.493H1042.58V635.338H1052.32V626.493ZM1043.14 627.053H1051.76V634.767H1043.14V627.053Z",
    fill: "#706D74"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 554.997H1033.66V563.97H1024.48V554.997Z",
    fill: "#FDFDE7"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 554.707H1024.19V564.239H1033.94V554.707ZM1024.76 555.278H1033.38V563.68H1024.76V555.278Z",
    fill: "#706D74"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 546.028H1033.66V555.001H1024.48V546.028Z",
    fill: "#FDFDE7"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 545.737H1024.19V555.281H1033.94V545.737ZM1024.76 546.308H1033.38V554.722H1024.76V546.308Z",
    fill: "#706D74"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 528.082H1033.66V537.055H1024.48V528.082Z",
    fill: "#FDFDE7"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 527.791H1024.19V537.323H1033.94V527.791ZM1024.76 528.362H1033.38V536.764H1024.76V528.362Z",
    fill: "#706D74"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 581.91H1033.66V590.883H1024.48V581.91Z",
    fill: "#FDFDE7"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 581.629H1024.19V591.161H1033.94V581.629ZM1024.76 582.188H1033.38V590.59H1024.76V582.188Z",
    fill: "#706D74"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 572.936H1033.66V581.909H1024.48V572.936Z",
    fill: "#FDFDE7"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 572.656H1024.19V582.189H1033.94V572.656ZM1024.76 573.216H1033.38V581.629H1024.76V573.216Z",
    fill: "#706D74"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 599.853H1033.66V608.814H1024.48V599.853Z",
    fill: "#FDFDE7"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 599.573H1024.19V609.106H1033.94V599.573ZM1024.76 600.133H1033.38V608.546H1024.76V600.133Z",
    fill: "#706D74"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 608.827H1033.66V617.8H1024.48V608.827Z",
    fill: "#FDFDE7"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 608.547H1024.19V618.079H1033.94V608.547ZM1024.76 609.106H1033.38V617.52H1024.76V609.106Z",
    fill: "#706D74"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 465.97H1033.66V474.244H1024.48V465.97Z",
    fill: "#FDFDE7"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 465.689H1024.19V474.534H1033.94V465.689ZM1024.76 466.249H1033.38V473.963H1024.76V466.249Z",
    fill: "#706D74"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.66 465.97H1042.84V474.244H1033.66V465.97Z",
    fill: "#FDFDE7"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.13 465.689H1033.38V474.534H1043.13V465.689ZM1033.94 466.249H1042.56V473.963H1033.94V466.249Z",
    fill: "#706D74"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.86 465.97H1052.04V474.244H1042.86V465.97Z",
    fill: "#FDFDE7"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.32 465.689H1042.58V474.534H1052.32V465.689ZM1043.14 466.249H1051.76V473.963H1043.14V466.249Z",
    fill: "#706D74"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 519.107H1033.66V528.08H1024.48V519.107Z",
    fill: "#FDFDE7"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.94 518.816H1024.19V528.349H1033.94V518.816ZM1024.76 519.387H1033.38V527.789H1024.76V519.387Z",
    fill: "#706D74"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.66 455.808H1106.61V459.478H1006.66V455.808Z",
    fill: "#C6C8CA"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.89 459.479V455.808C1106.89 455.645 1106.76 455.528 1106.61 455.528H1006.66C1006.5 455.528 1006.38 455.657 1006.38 455.808V459.479C1006.38 459.642 1006.51 459.77 1006.66 459.77H1106.61C1106.77 459.77 1106.89 459.642 1106.89 459.479ZM1006.93 456.099H1106.33V459.211H1006.94V456.099H1006.93Z",
    fill: "#636562"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.21 511.768L1016.94 538.966V546.762L1049.21 519.354V511.768Z",
    fill: "#C6C8CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.21 597.186L1016.94 624.373V632.18L1049.21 604.76V597.186Z",
    fill: "#C6C8CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.97 484.793H1104.65V493.055H1063.97V484.793Z",
    fill: "#EAEAEC"
  }))), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.98 482.334H1106.07V490.585H1063.98V482.334Z",
    fill: "#FDFDE7"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.35 490.585V482.334C1106.35 482.171 1106.22 482.043 1106.07 482.043H1063.98C1063.82 482.043 1063.7 482.171 1063.7 482.334V490.585C1063.7 490.736 1063.83 490.865 1063.98 490.865H1106.07C1106.22 490.865 1106.35 490.736 1106.35 490.585ZM1064.26 482.614H1105.78V490.305H1064.26V482.614Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.97 527.172H1104.65V535.434H1063.97V527.172Z",
    fill: "#EAEAEC"
  }))), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.98 524.712H1106.07V532.962H1063.98V524.712Z",
    fill: "#FDFDE7"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.35 532.952V524.702C1106.35 524.55 1106.22 524.422 1106.07 524.422H1063.98C1063.82 524.422 1063.7 524.55 1063.7 524.702V532.952C1063.7 533.115 1063.83 533.243 1063.98 533.243H1106.07C1106.22 533.243 1106.35 533.115 1106.35 532.952ZM1064.26 524.993H1105.78V532.672H1064.26V524.993Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.97 569.558H1104.65V577.82H1063.97V569.558Z",
    fill: "#EAEAEC"
  }))), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.98 567.098H1106.07V575.36H1063.98V567.098Z",
    fill: "#FDFDE7"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.35 575.347V567.085C1106.35 566.922 1106.22 566.794 1106.07 566.794H1063.98C1063.82 566.794 1063.7 566.922 1063.7 567.085V575.347C1063.7 575.499 1063.83 575.627 1063.98 575.627H1106.07C1106.22 575.627 1106.35 575.499 1106.35 575.347ZM1064.26 567.377H1105.78V575.068H1064.26V567.377Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.97 611.953H1104.65V620.204H1063.97V611.953Z",
    fill: "#EAEAEC"
  }))), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.98 609.472H1106.07V617.734H1063.98V609.472Z",
    fill: "#FDFDE7"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.35 617.733V609.471C1106.35 609.32 1106.22 609.191 1106.07 609.191H1063.98C1063.82 609.191 1063.7 609.32 1063.7 609.471V617.733C1063.7 617.885 1063.83 618.013 1063.98 618.013H1106.07C1106.22 618.013 1106.35 617.885 1106.35 617.733ZM1064.26 609.762H1105.78V617.442H1064.26V609.762Z",
    fill: "#706D74"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M937.022 522.64H1018.78V657.754H937.022V522.64Z",
    fill: "#DAC591"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.46 522.952H937.333V657.44H1018.46V522.952Z",
    fill: "#F6E1D8",
    stroke: "#706D74",
    strokeWidth: 0.626417
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1836-inside-1_6004_59723",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.08 657.752V522.638C1019.08 522.47 1018.94 522.333 1018.77 522.333H937.021C936.853 522.333 936.716 522.47 936.716 522.638V657.752C936.716 657.935 936.853 658.072 937.021 658.072H1018.77C1018.94 658.072 1019.08 657.935 1019.08 657.752ZM937.325 522.942H1018.47V657.462H937.325V522.942Z"
  }))), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.08 657.752V522.638C1019.08 522.47 1018.94 522.333 1018.77 522.333H937.021C936.853 522.333 936.716 522.47 936.716 522.638V657.752C936.716 657.935 936.853 658.072 937.021 658.072H1018.77C1018.94 658.072 1019.08 657.935 1019.08 657.752ZM937.325 522.942H1018.47V657.462H937.325V522.942Z",
    fill: "#F9E3E1"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M937.325 522.942H936.699V522.316H937.325V522.942ZM1018.47 522.942V522.316H1019.1V522.942H1018.47ZM1018.47 657.462H1019.1V658.089H1018.47V657.462ZM937.325 657.462V658.089H936.699V657.462H937.325ZM1018.45 657.752V522.638H1019.71V657.752H1018.45ZM1018.45 522.638C1018.45 522.816 1018.6 522.959 1018.77 522.959V521.707C1019.29 521.707 1019.71 522.124 1019.71 522.638H1018.45ZM1018.77 522.959H937.021V521.707H1018.77V522.959ZM937.021 522.959C937.199 522.959 937.342 522.816 937.342 522.638H936.089C936.089 522.124 936.507 521.707 937.021 521.707V522.959ZM937.342 522.638V657.752H936.089V522.638H937.342ZM937.342 657.752C937.342 657.609 937.219 657.445 937.021 657.445V658.698C936.487 658.698 936.089 658.26 936.089 657.752H937.342ZM937.021 657.445H1018.77V658.698H937.021V657.445ZM1018.77 657.445C1018.58 657.445 1018.45 657.609 1018.45 657.752H1019.71C1019.71 658.26 1019.31 658.698 1018.77 658.698V657.445ZM937.325 522.316H1018.47V523.569H937.325V522.316ZM1019.1 522.942V657.462H1017.84V522.942H1019.1ZM1018.47 658.089H937.325V656.836H1018.47V658.089ZM936.699 657.462V522.942H937.952V657.462H936.699Z",
    fill: "#706D74",
    mask: "url(#path-1836-inside-1_6004_59723)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M937.021 522.64H964.638V657.754H937.021V522.64Z",
    fill: "#C6C8CA"
  }))), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M970.061 538.48H1012.99V581.345H970.061V538.48Z",
    fill: "#706D74"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M971.171 539.974H1011.86V579.883H971.171V539.974Z",
    fill: "#554B3F"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M971.706 540.475H1011.31V579.318H971.706V540.475Z",
    fill: "url(#paint11_linear_6004_59723)"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.17 539.347H1003.24V580.505H1002.17V539.347Z",
    fill: "#706D74"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M990.976 539.347H992.042V580.505H990.976V539.347Z",
    fill: "#706D74"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M979.777 539.347H980.844V580.505H979.777V539.347Z",
    fill: "#706D74"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M970.898 554.687H1012.16V555.738H970.898V554.687Z",
    fill: "#706D74"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M970.898 546.096H1012.16V547.132H970.898V546.096Z",
    fill: "#706D74"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M970.898 563.278H1012.16V564.314H970.898V563.278Z",
    fill: "#706D74"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M970.898 571.853H1012.16V572.904H970.898V571.853Z",
    fill: "#706D74"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M992.771 611.565H1014.54V642.747H992.771V611.565Z",
    fill: "#706D74"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M994.416 613.104H1012.91V641.223H994.416V613.104Z",
    fill: "#554B3F"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M994.965 613.531H1012.38V640.706H994.965V613.531Z",
    fill: "url(#paint12_linear_6004_59723)"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.18 613.104H1004.14V641.223H1003.18V613.104Z",
    fill: "#706D74"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M994.462 619.366H1012.88V620.326H994.462V619.366Z",
    fill: "#706D74"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M994.462 626.875H1012.88V627.835H994.462V626.875Z",
    fill: "#706D74"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M994.462 634.414H1012.88V635.358H994.462V634.414Z",
    fill: "#706D74"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M968.475 611.565H990.242V642.747H968.475V611.565Z",
    fill: "#706D74"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M970.134 613.104H988.611V641.223H970.134V613.104Z",
    fill: "#554B3F"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M970.653 613.531H988.079V640.706H970.653V613.531Z",
    fill: "url(#paint13_linear_6004_59723)"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M978.892 613.104H979.837V641.223H978.892V613.104Z",
    fill: "#706D74"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M970.148 619.366H988.564V620.326H970.148V619.366Z",
    fill: "#706D74"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M970.148 626.875H988.564V627.835H970.148V626.875Z",
    fill: "#706D74"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M970.148 634.414H988.564V635.358H970.148V634.414Z",
    fill: "#706D74"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.85 589.914H956.312V599.204H1020.85V589.914Z",
    fill: "#F6E1D8",
    stroke: "#706D74",
    strokeWidth: 0.626417
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1864-inside-2_6004_59723",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1021.47 599.501V589.585C1021.47 589.417 1021.33 589.28 1021.17 589.28H956C955.832 589.28 955.695 589.417 955.695 589.585V599.501C955.695 599.669 955.832 599.806 956 599.806H1021.17C1021.33 599.806 1021.47 599.669 1021.47 599.501ZM956.304 589.905H1020.86V599.212H956.304V589.905Z"
  }))), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.47 599.501V589.585C1021.47 589.417 1021.33 589.28 1021.17 589.28H956C955.832 589.28 955.695 589.417 955.695 589.585V599.501C955.695 599.669 955.832 599.806 956 599.806H1021.17C1021.33 599.806 1021.47 599.669 1021.47 599.501ZM956.304 589.905H1020.86V599.212H956.304V589.905Z",
    fill: "#636562"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M956.304 589.905H955.678V589.278H956.304V589.905ZM1020.86 589.905V589.278H1021.49V589.905H1020.86ZM1020.86 599.212H1021.49V599.838H1020.86V599.212ZM956.304 599.212V599.838H955.678V599.212H956.304ZM1020.84 599.501V589.585H1022.1V599.501H1020.84ZM1020.84 589.585C1020.84 589.763 1020.99 589.907 1021.17 589.907V588.654C1021.68 588.654 1022.1 589.072 1022.1 589.585H1020.84ZM1021.17 589.907H956V588.654H1021.17V589.907ZM956 589.907C956.178 589.907 956.321 589.763 956.321 589.585H955.069C955.069 589.071 955.486 588.654 956 588.654V589.907ZM956.321 589.585V599.501H955.069V589.585H956.321ZM956.321 599.501C956.321 599.323 956.178 599.18 956 599.18V600.432C955.486 600.432 955.069 600.015 955.069 599.501H956.321ZM956 599.18H1021.17V600.432H956V599.18ZM1021.17 599.18C1020.99 599.18 1020.84 599.323 1020.84 599.501H1022.1C1022.1 600.015 1021.68 600.432 1021.17 600.432V599.18ZM956.304 589.278H1020.86V590.531H956.304V589.278ZM1021.49 589.905V599.212H1020.23V589.905H1021.49ZM1020.86 599.838H956.304V598.586H1020.86V599.838ZM955.678 599.212V589.905H956.931V599.212H955.678Z",
    fill: "#706D74",
    mask: "url(#path-1864-inside-2_6004_59723)"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M937.021 522.637H963.13V657.751H937.021V522.637Z",
    fill: "#F7D2CF",
    stroke: "#706D74",
    strokeWidth: 0.626417
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M963.435 657.752V522.638C963.435 522.47 963.297 522.333 963.13 522.333H937.021C936.853 522.333 936.716 522.47 936.716 522.638V657.752C936.716 657.935 936.853 658.072 937.021 658.072H963.13C963.297 658.072 963.435 657.935 963.435 657.752ZM937.326 522.942H962.825V657.462H937.326V522.942Z",
    fill: "#F9E3E1",
    stroke: "#706D74",
    strokeWidth: 0.626417
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M937.02 522.635H1018.77V531.409H937.02V522.635Z",
    fill: "#EAEAEC"
  }))), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M935.405 521.006H1019.9V528.851H935.405V521.006Z",
    fill: "#FFBC9E"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.21 528.85V521.005C1020.21 520.853 1020.07 520.716 1019.9 520.716H935.406C935.238 520.716 935.101 520.853 935.101 521.005V528.85C935.101 529.018 935.238 529.155 935.406 529.155H1019.9C1020.07 529.155 1020.21 529.018 1020.21 528.85ZM935.71 521.325H1019.6V528.561H935.71V521.325Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M936.015 521.936H1018.99V523.55H936.015V521.936Z",
    fill: "#EAEAEC"
  }))), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 539.077H953.775V559.839H946.372V539.077Z",
    fill: "#FFF9DE"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 560.144H954.081V538.757H946.053V560.144ZM953.457 559.519H946.693V539.397H953.457V559.519Z",
    fill: "#706D74"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 539.077H953.775V549.1H946.372V539.077Z",
    fill: "white"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 549.42H954.081V538.757H946.053V549.42ZM953.457 548.78H946.693V539.381H953.457V548.78Z",
    fill: "#706D74"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 566.235H953.775V586.998H946.372V566.235Z",
    fill: "#FFF9DE"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 587.316H954.081V565.93H946.053V587.316ZM953.457 586.677H946.693V566.554H953.457V586.677Z",
    fill: "#706D74"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 566.235H953.775V576.274H946.372V566.235Z",
    fill: "white"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 576.593H954.081V565.93H946.053V576.593ZM953.457 575.953H946.693V566.569H953.457V575.953Z",
    fill: "#706D74"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 593.427H953.775V614.174H946.372V593.427Z",
    fill: "#FFF9DE"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 614.492H954.081V593.105H946.053V614.492ZM953.457 613.852H946.693V593.73H953.457V613.852Z",
    fill: "#706D74"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 593.423H953.775V603.446H946.372V593.423Z",
    fill: "white"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 603.752H954.081V593.089H946.053V603.752ZM953.457 603.127H946.693V593.744H953.457V603.127Z",
    fill: "#706D74"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 620.584H953.775V641.331H946.372V620.584Z",
    fill: "#FFF9DE"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 641.666H954.081V620.264H946.053V641.666ZM953.457 641.026H946.693V620.903H953.457V641.026Z",
    fill: "#706D74"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M946.372 620.584H953.775V630.607H946.372V620.584Z",
    fill: "#FFF9DE"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M946.053 630.927H954.081V620.264H946.053V630.927ZM953.457 630.287H946.693V620.903H953.457V630.287Z",
    fill: "#706D74"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.06 648.874C1065.08 648.862 1065.09 648.849 1065.11 648.834C1065.17 648.773 1065.27 648.682 1065.38 648.566C1065.61 648.334 1065.91 648.002 1066.22 647.601C1066.84 646.793 1067.44 645.739 1067.47 644.684C1067.48 644.427 1067.44 644.257 1067.38 644.146C1067.32 644.039 1067.23 643.974 1067.12 643.936C1066.88 643.854 1066.53 643.903 1066.11 644.041C1065.71 644.175 1065.31 644.379 1065 644.551C1064.84 644.636 1064.71 644.713 1064.62 644.769C1064.58 644.797 1064.54 644.819 1064.52 644.834L1064.49 644.852L1064.49 644.856L1064.49 644.857L1064.48 644.857L1064.48 644.857L1064.48 644.857L1064.48 644.857L1064.2 644.59C1064.2 644.59 1064.2 644.59 1064.2 644.59L1064.2 644.59L1064.2 644.589L1064.21 644.583C1064.21 644.577 1064.21 644.568 1064.22 644.557C1064.23 644.534 1064.25 644.499 1064.27 644.457C1064.3 644.372 1064.34 644.26 1064.36 644.147C1064.38 644.031 1064.37 643.932 1064.34 643.856C1064.31 643.789 1064.25 643.718 1064.1 643.671C1063.98 643.633 1063.79 643.661 1063.53 643.771C1063.29 643.878 1063.01 644.044 1062.76 644.224C1062.51 644.403 1062.28 644.59 1062.11 644.732C1062.03 644.803 1061.96 644.863 1061.91 644.905C1061.89 644.926 1061.87 644.942 1061.86 644.954L1061.85 644.966L1061.84 644.969L1061.84 644.97L1061.84 644.97L1061.84 644.97L1061.84 644.97L1061.51 645.283L1061.5 644.826L1061.5 644.826L1061.5 644.826L1061.5 644.824L1061.5 644.817L1061.5 644.784C1061.5 644.755 1061.5 644.711 1061.5 644.655C1061.49 644.543 1061.48 644.382 1061.45 644.187C1061.4 643.796 1061.3 643.273 1061.1 642.74C1060.71 641.672 1059.96 640.607 1058.49 640.426L1058.49 640.426C1056.98 640.239 1056.03 640.698 1055.46 641.189C1055.17 641.436 1054.97 641.695 1054.85 641.891C1054.79 641.989 1054.75 642.071 1054.72 642.128C1054.7 642.156 1054.69 642.177 1054.69 642.192L1054.68 642.207L1054.68 642.21L1054.68 642.21L1054.68 642.21L1054.68 642.21L1054.68 642.21L1054.49 642.71L1054.3 642.205L1054.3 642.205L1054.3 642.205L1054.3 642.205L1054.3 642.205L1054.3 642.202L1054.3 642.19C1054.29 642.179 1054.29 642.162 1054.28 642.14C1054.26 642.096 1054.23 642.033 1054.2 641.957C1054.13 641.804 1054.02 641.601 1053.88 641.398C1053.59 640.982 1053.19 640.619 1052.71 640.606C1052.45 640.6 1052.29 640.664 1052.19 640.747C1052.08 640.831 1052.01 640.95 1051.97 641.082C1051.93 641.215 1051.92 641.354 1051.92 641.461C1051.92 641.515 1051.92 641.559 1051.92 641.589C1051.92 641.604 1051.92 641.616 1051.93 641.623L1051.93 641.63L1051.93 641.631L1051.93 641.631C1051.93 641.631 1051.93 641.631 1051.93 641.631L1051.57 641.776C1051.57 641.777 1051.57 641.777 1051.57 641.777L1051.57 641.777L1051.57 641.777L1051.56 641.774L1051.55 641.76C1051.54 641.747 1051.53 641.727 1051.5 641.701C1051.46 641.649 1051.39 641.574 1051.3 641.485C1051.11 641.305 1050.82 641.068 1050.42 640.842C1049.63 640.392 1048.38 639.984 1046.6 640.188C1044.84 640.389 1043.82 641.269 1043.24 642.095C1042.95 642.511 1042.77 642.914 1042.66 643.213C1042.6 643.362 1042.57 643.485 1042.54 643.57C1042.53 643.612 1042.53 643.645 1042.52 643.666L1042.52 643.69L1042.51 643.695L1042.51 643.696L1042.51 643.696L1042.51 643.696L1042.51 643.696L1042.45 644.048L1065.06 648.874ZM1065.06 648.874H1023.06C1023.04 648.854 1023.01 648.828 1022.97 648.798C1022.89 648.717 1022.76 648.601 1022.61 648.461C1022.32 648.179 1021.95 647.8 1021.63 647.409C1021.31 647.011 1021.06 646.623 1020.98 646.321C1020.94 646.173 1020.94 646.071 1020.98 646.002C1021.01 645.939 1021.08 645.868 1021.24 645.818C1021.99 645.589 1022.99 645.747 1023.82 645.981C1024.24 646.096 1024.6 646.227 1024.86 646.329C1024.99 646.38 1025.1 646.423 1025.17 646.454C1025.2 646.469 1025.23 646.482 1025.25 646.49L1025.27 646.499L1025.28 646.501L1025.28 646.502L1025.28 646.502L1025.28 646.502L1025.28 646.502L1025.51 646.19L1025.51 646.19L1025.51 646.19L1025.51 646.19L1025.51 646.189L1025.51 646.184L1025.49 646.165C1025.48 646.149 1025.46 646.124 1025.43 646.093C1025.38 646.03 1025.31 645.939 1025.22 645.829C1025.06 645.609 1024.84 645.314 1024.67 645.012C1024.48 644.704 1024.35 644.409 1024.32 644.184C1024.3 644.073 1024.31 643.999 1024.33 643.953C1024.35 643.914 1024.39 643.874 1024.47 643.847C1024.69 643.778 1024.96 643.783 1025.26 643.843C1025.56 643.903 1025.87 644.014 1026.15 644.137C1026.43 644.26 1026.68 644.394 1026.86 644.497C1026.95 644.549 1027.02 644.592 1027.07 644.623C1027.1 644.638 1027.12 644.65 1027.13 644.658L1027.14 644.667L1027.15 644.669L1027.15 644.67L1027.15 644.67L1065.06 648.874ZM1042.18 643.807L1042.18 643.807L1042.18 643.807L1042.18 643.807L1042.18 643.806L1042.17 643.798C1042.16 643.791 1042.15 643.781 1042.14 643.768C1042.11 643.741 1042.06 643.703 1042 643.658C1041.88 643.567 1041.71 643.449 1041.51 643.337C1041.09 643.11 1040.59 642.931 1040.11 643.027C1039.93 643.066 1039.81 643.185 1039.74 643.381C1039.67 643.586 1039.65 643.857 1039.67 644.143C1039.69 644.426 1039.74 644.704 1039.79 644.914C1039.81 645.018 1039.83 645.104 1039.85 645.164C1039.86 645.194 1039.86 645.217 1039.87 645.233L1039.87 645.25L1039.88 645.254L1039.88 645.255L1039.88 645.255L1039.88 645.255L1042.18 643.807ZM1039.88 645.255L1039.52 645.426L1039.52 645.426L1039.52 645.426L1039.52 645.426L1039.52 645.426L1039.52 645.425L1039.51 645.419L1039.5 645.395C1039.48 645.375 1039.46 645.344 1039.43 645.305C1039.38 645.227 1039.3 645.114 1039.2 644.98C1038.99 644.71 1038.71 644.35 1038.39 643.991C1038.06 643.631 1037.7 643.276 1037.34 643.011C1036.98 642.742 1036.65 642.587 1036.38 642.583C1036.25 642.58 1036.15 642.61 1036.09 642.651C1036.03 642.692 1035.98 642.754 1035.94 642.842C1035.86 643.025 1035.84 643.294 1035.87 643.596C1035.9 643.892 1035.97 644.192 1036.03 644.421C1036.07 644.535 1036.1 644.63 1036.12 644.696C1036.13 644.729 1036.14 644.754 1036.14 644.772L1036.15 644.791L1036.15 644.796L1036.15 644.797L1036.15 644.797L1036.15 644.797L1039.88 645.255ZM1036.15 644.797L1035.78 644.948C1035.78 644.95 1035.78 644.95 1035.78 644.95L1035.78 644.95L1035.78 644.949L1035.78 644.944L1035.77 644.921C1035.76 644.9 1035.74 644.869 1035.72 644.828C1035.67 644.747 1035.6 644.628 1035.5 644.483C1035.31 644.193 1035 643.798 1034.55 643.384C1033.67 642.559 1032.24 641.657 1030.07 641.371C1028.99 641.229 1028.31 641.367 1027.89 641.619C1027.48 641.867 1027.29 642.243 1027.22 642.654C1027.14 643.07 1027.2 643.512 1027.27 643.857C1027.31 644.028 1027.35 644.173 1027.39 644.273C1027.4 644.324 1027.42 644.363 1027.43 644.39C1027.43 644.403 1027.44 644.413 1027.44 644.419L1027.44 644.426L1027.44 644.428L1027.44 644.428L1027.44 644.428L1027.44 644.428L1027.68 645.023L1027.15 644.67L1036.15 644.797ZM1051.93 641.632C1051.93 641.632 1051.93 641.632 1051.93 641.632L1051.93 641.632Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.40035
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.19 648.874C1103.2 648.865 1103.21 648.855 1103.22 648.844C1103.28 648.783 1103.36 648.692 1103.46 648.576C1103.66 648.344 1103.92 648.012 1104.19 647.612C1104.72 646.806 1105.25 645.748 1105.28 644.685C1105.29 644.424 1105.25 644.25 1105.19 644.135C1105.14 644.027 1105.07 643.966 1104.98 643.933C1104.79 643.858 1104.5 643.9 1104.14 644.038C1103.8 644.171 1103.45 644.373 1103.18 644.544C1103.04 644.63 1102.93 644.707 1102.85 644.762C1102.81 644.789 1102.78 644.812 1102.76 644.827L1102.74 644.844L1102.73 644.848L1102.73 644.849L1102.73 644.85L1102.73 644.85L1102.73 644.85L1102.73 644.849L1102.43 644.6C1102.43 644.6 1102.43 644.6 1102.43 644.6L1102.43 644.6L1102.43 644.599L1102.44 644.593C1102.44 644.587 1102.44 644.578 1102.45 644.567C1102.46 644.543 1102.47 644.509 1102.49 644.466C1102.52 644.38 1102.56 644.267 1102.57 644.151C1102.59 644.033 1102.58 643.928 1102.55 643.847C1102.53 643.775 1102.47 643.711 1102.36 643.669C1102.27 643.638 1102.12 643.657 1101.9 643.767C1101.69 643.872 1101.46 644.037 1101.23 644.216C1101.02 644.394 1100.82 644.58 1100.67 644.723C1100.6 644.794 1100.54 644.854 1100.5 644.895C1100.48 644.916 1100.46 644.933 1100.45 644.944L1100.44 644.956L1100.44 644.959L1100.44 644.96L1100.44 644.96L1100.44 644.96L1100.44 644.96L1100.1 645.33L1100.09 644.826L1100.09 644.826L1100.09 644.826L1100.09 644.826L1100.09 644.824L1100.09 644.816L1100.09 644.783C1100.09 644.754 1100.09 644.71 1100.08 644.654C1100.08 644.541 1100.07 644.379 1100.04 644.184C1100 643.791 1099.91 643.266 1099.74 642.732C1099.39 641.652 1098.74 640.603 1097.49 640.426L1097.49 640.426C1096.2 640.241 1095.38 640.693 1094.89 641.179C1094.64 641.426 1094.47 641.684 1094.36 641.881C1094.31 641.979 1094.27 642.061 1094.25 642.118C1094.23 642.146 1094.22 642.168 1094.22 642.183L1094.21 642.198L1094.21 642.201L1094.21 642.201L1094.21 642.201L1094.21 642.202L1094.21 642.202L1094.02 642.786L1093.83 642.197L1093.83 642.197L1093.83 642.197L1093.83 642.197L1093.83 642.197L1093.83 642.194L1093.83 642.181C1093.82 642.17 1093.82 642.153 1093.81 642.131C1093.79 642.087 1093.77 642.024 1093.74 641.947C1093.68 641.794 1093.58 641.59 1093.46 641.387C1093.2 640.964 1092.87 640.618 1092.47 640.606C1092.26 640.6 1092.13 640.66 1092.05 640.738C1091.96 640.82 1091.9 640.938 1091.86 641.075C1091.82 641.211 1091.81 641.352 1091.81 641.461C1091.81 641.515 1091.81 641.56 1091.81 641.591C1091.81 641.606 1091.82 641.618 1091.82 641.626L1091.82 641.634L1091.82 641.635L1091.82 641.635C1091.82 641.635 1091.82 641.635 1091.82 641.635L1091.45 641.766C1091.45 641.766 1091.45 641.766 1091.45 641.766L1091.45 641.766L1091.45 641.766L1091.45 641.763L1091.44 641.749C1091.43 641.736 1091.42 641.716 1091.4 641.69C1091.36 641.639 1091.3 641.564 1091.22 641.475C1091.06 641.296 1090.81 641.06 1090.46 640.836C1089.78 640.39 1088.7 639.985 1087.17 640.187C1085.66 640.386 1084.78 641.256 1084.27 642.085C1084.02 642.5 1083.86 642.905 1083.76 643.205C1083.71 643.355 1083.68 643.478 1083.66 643.563C1083.65 643.606 1083.65 643.639 1083.64 643.661L1083.64 643.685L1083.64 643.69L1083.64 643.691L1083.64 643.691L1083.64 643.691L1083.57 644.087L1083.29 643.798L1083.29 643.798L1083.29 643.798L1083.29 643.798L1083.29 643.797L1083.29 643.796L1083.28 643.788C1083.28 643.782 1083.27 643.772 1083.25 643.759C1083.23 643.732 1083.19 643.694 1083.13 643.649C1083.03 643.559 1082.88 643.441 1082.71 643.331C1082.35 643.104 1081.92 642.934 1081.53 643.026C1081.39 643.06 1081.29 643.167 1081.23 643.373C1081.16 643.582 1081.15 643.857 1081.16 644.145C1081.18 644.429 1081.22 644.709 1081.27 644.919C1081.29 645.024 1081.31 645.11 1081.32 645.171C1081.33 645.201 1081.33 645.224 1081.34 645.24L1081.34 645.257L1081.34 645.261L1081.34 645.262L1081.34 645.262L1081.34 645.262L1103.19 648.874ZM1103.19 648.874H1066.72H1103.19ZM1081.34 645.262L1080.98 645.416L1080.98 645.416L1080.98 645.416L1080.98 645.416L1080.98 645.415L1080.98 645.414L1080.97 645.408L1080.96 645.385C1080.95 645.364 1080.93 645.333 1080.9 645.294C1080.86 645.216 1080.79 645.104 1080.7 644.969C1080.52 644.699 1080.27 644.339 1079.99 643.98C1079.71 643.62 1079.4 643.266 1079.09 643.002C1078.77 642.732 1078.49 642.587 1078.28 642.583C1078.17 642.581 1078.1 642.607 1078.05 642.643C1078 642.681 1077.96 642.742 1077.92 642.833C1077.85 643.021 1077.84 643.295 1077.86 643.598C1077.89 643.896 1077.95 644.198 1078 644.428C1078.03 644.542 1078.06 644.637 1078.08 644.703C1078.09 644.736 1078.09 644.762 1078.1 644.78L1078.1 644.799L1078.11 644.804L1078.11 644.805L1078.11 644.805L1078.11 644.805L1081.34 645.262ZM1078.1 644.805L1077.73 644.939C1077.73 644.94 1077.73 644.94 1077.73 644.94L1077.73 644.94L1077.73 644.939L1077.73 644.934L1077.72 644.911C1077.71 644.89 1077.69 644.859 1077.67 644.818C1077.63 644.736 1077.57 644.617 1077.49 644.472C1077.32 644.182 1077.05 643.787 1076.66 643.374C1075.89 642.55 1074.66 641.654 1072.79 641.371C1071.85 641.229 1071.28 641.367 1070.92 641.612C1070.57 641.855 1070.4 642.23 1070.34 642.649C1070.27 643.07 1070.32 643.516 1070.39 643.863C1070.42 644.035 1070.46 644.18 1070.49 644.281C1070.5 644.332 1070.51 644.371 1070.52 644.398L1070.53 644.428L1070.54 644.435L1070.54 644.436L1070.54 644.436L1070.54 644.436L1078.1 644.805ZM1070.23 644.662L1070.23 644.662L1070.22 644.66L1070.21 644.651C1070.2 644.643 1070.18 644.631 1070.16 644.616C1070.12 644.585 1070.06 644.542 1069.98 644.491C1069.82 644.388 1069.61 644.255 1069.36 644.133C1069.12 644.01 1068.86 643.901 1068.6 643.842C1068.35 643.783 1068.12 643.779 1067.94 643.844C1067.88 643.867 1067.85 643.901 1067.83 643.943C1067.81 643.994 1067.8 644.073 1067.82 644.187C1067.85 644.417 1067.97 644.715 1068.12 645.022C1068.28 645.325 1068.46 645.62 1068.61 645.84C1068.68 645.95 1068.75 646.041 1068.79 646.104C1068.81 646.135 1068.83 646.16 1068.84 646.176L1068.86 646.195L1068.86 646.199L1068.86 646.2L1068.86 646.201L1068.86 646.201L1068.86 646.201L1068.61 646.497L1068.61 646.497L1070.23 644.662ZM1103.13 648.936C1103.13 648.936 1103.13 648.936 1103.13 648.936L1103.13 648.936Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.40035
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.12 647.276H1021.28V650.843H1105.12V647.276Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.40035
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.18 657.445C1028.21 657.424 1028.25 657.396 1028.29 657.363C1028.41 657.274 1028.58 657.142 1028.78 656.973C1029.19 656.636 1029.74 656.153 1030.28 655.572C1031.39 654.396 1032.46 652.87 1032.52 651.353C1032.54 650.987 1032.46 650.745 1032.35 650.584C1032.24 650.425 1032.08 650.316 1031.85 650.253C1031.38 650.122 1030.7 650.205 1029.96 650.405C1029.24 650.603 1028.51 650.9 1027.95 651.151C1027.67 651.275 1027.44 651.388 1027.28 651.469C1027.2 651.509 1027.14 651.542 1027.09 651.564L1027.05 651.59L1027.03 651.596L1027.03 651.598L1027.03 651.598L1027.03 651.598L1027.03 651.598L1027.03 651.598L1026.69 651.209C1026.69 651.209 1026.69 651.209 1026.69 651.209L1026.69 651.208L1026.69 651.207L1026.69 651.198C1026.7 651.19 1026.71 651.177 1026.72 651.16C1026.74 651.126 1026.77 651.077 1026.8 651.016C1026.87 650.892 1026.94 650.732 1026.97 650.571C1027 650.408 1026.99 650.272 1026.93 650.166C1026.88 650.066 1026.76 649.947 1026.46 649.87C1026.2 649.801 1025.81 649.856 1025.35 650.018C1024.9 650.176 1024.41 650.421 1023.95 650.682C1023.5 650.943 1023.09 651.215 1022.79 651.422C1022.64 651.526 1022.52 651.613 1022.43 651.674C1022.39 651.704 1022.36 651.728 1022.34 651.745L1022.31 651.763L1022.31 651.767L1022.3 651.769L1022.3 651.769L1022.3 651.769L1022.3 651.769L1021.88 652.09L1021.88 651.561V651.561L1021.88 651.561L1021.88 651.561L1021.88 651.558L1021.88 651.547C1021.88 651.543 1021.88 651.539 1021.88 651.533C1021.88 651.524 1021.88 651.513 1021.87 651.5C1021.87 651.458 1021.87 651.396 1021.86 651.315C1021.85 651.154 1021.83 650.921 1021.78 650.639C1021.69 650.075 1021.51 649.319 1021.16 648.55C1020.47 647.018 1019.12 645.435 1016.44 645.166L1016.44 645.166C1013.7 644.891 1011.97 645.568 1010.93 646.292C1010.41 646.655 1010.05 647.034 1009.83 647.319C1009.72 647.462 1009.64 647.581 1009.59 647.662C1009.57 647.703 1009.55 647.735 1009.54 647.755C1009.53 647.765 1009.53 647.773 1009.53 647.777L1009.53 647.781L1009.53 647.782L1009.53 647.782L1009.53 647.782L1009.28 648.305L1028.18 657.445ZM1028.18 657.445H953.191C953.148 657.414 953.085 657.369 953.007 657.311C952.848 657.194 952.624 657.026 952.363 656.822C951.841 656.413 951.179 655.863 950.608 655.294C950.027 654.715 949.579 654.152 949.434 653.717C949.365 653.506 949.38 653.368 949.436 653.273C949.493 653.175 949.634 653.058 949.959 652.977C951.335 652.636 953.144 652.874 954.641 653.213C955.383 653.381 956.037 653.572 956.505 653.72C956.739 653.794 956.926 653.858 957.055 653.902C957.119 653.925 957.168 653.943 957.202 653.955L957.239 653.968L957.248 653.972L957.25 653.973L957.251 653.973L957.251 653.973L957.251 653.973L957.528 653.531L957.528 653.53L957.528 653.53L957.527 653.53L957.526 653.528L957.518 653.522L957.49 653.494C957.465 653.47 957.429 653.435 957.383 653.389C957.291 653.297 957.161 653.166 957.011 653.006C956.71 652.687 956.332 652.259 956.013 651.82C955.687 651.371 955.449 650.946 955.39 650.624C955.362 650.469 955.381 650.37 955.419 650.306C955.455 650.245 955.533 650.172 955.721 650.123C956.139 650.015 956.649 650.026 957.194 650.116C957.736 650.204 958.295 650.368 958.803 650.548C959.31 650.728 959.76 650.923 960.083 651.073C960.245 651.148 960.375 651.212 960.463 651.257C960.508 651.279 960.542 651.297 960.565 651.309L960.591 651.322L960.597 651.325L960.598 651.326L960.598 651.326L961.334 651.72L960.962 650.973L960.962 650.973L960.962 650.973L960.961 650.971L960.956 650.961C960.952 650.952 960.945 650.937 960.937 650.918C960.919 650.88 960.894 650.823 960.865 650.75C960.806 650.605 960.731 650.397 960.663 650.15C960.527 649.651 960.432 649.016 960.56 648.42C960.685 647.838 961.023 647.281 961.789 646.907C962.57 646.526 963.816 646.326 965.765 646.535C969.661 646.951 972.229 648.269 973.819 649.472C974.615 650.074 975.167 650.649 975.52 651.071C975.696 651.282 975.821 651.454 975.903 651.572C975.943 651.632 975.972 651.677 975.991 651.707C976.001 651.722 976.007 651.733 976.011 651.74L976.016 651.748L976.016 651.749L976.017 651.749C976.016 651.749 976.016 651.749 976.02 651.747L976.489 651.509L1028.18 657.445ZM1006.11 645.425C1007.04 645.446 1007.77 646.008 1008.28 646.604C1008.53 646.899 1008.72 647.194 1008.85 647.415C1008.92 647.526 1008.97 647.617 1009 647.68C1009.01 647.712 1009.02 647.736 1009.03 647.752L1009.04 647.77L1009.04 647.774L1009.04 647.774L1009.04 647.774L1009.04 647.775L1006.11 645.425ZM1006.11 645.425C1005.62 645.416 1005.31 645.516 1005.1 645.649C1004.89 645.782 1004.77 645.961 1004.7 646.148C1004.63 646.338 1004.6 646.535 1004.6 646.688C1004.6 646.764 1004.61 646.827 1004.61 646.87C1004.61 646.891 1004.62 646.907 1004.62 646.917L1004.62 646.928L1004.62 646.929L1004.62 646.929L1004.62 646.929L1004.62 646.929L1004.62 646.93L1004.78 647.861L1004.16 647.152L1004.16 647.152L1004.16 647.152L1004.16 647.152L1004.16 647.152L1004.15 647.147C1004.15 647.145 1004.15 647.143 1004.15 647.14C1004.14 647.136 1004.14 647.132 1004.13 647.126C1004.11 647.107 1004.09 647.078 1004.05 647.04C1003.97 646.964 1003.84 646.854 1003.67 646.722C1003.34 646.46 1002.82 646.112 1002.09 645.781C1000.65 645.12 998.406 644.523 995.197 644.82C992.012 645.116 990.176 646.411 989.135 647.613C988.612 648.217 988.286 648.802 988.091 649.234C987.993 649.45 987.929 649.627 987.889 649.749C987.869 649.81 987.855 649.857 987.847 649.888C987.843 649.903 987.84 649.915 987.838 649.922L987.836 649.929L987.836 649.93L987.836 649.93L987.836 649.93L1006.11 645.425ZM987.418 650.084L987.419 650.084L987.418 650.084ZM987.418 650.084L987.418 650.084L987.414 650.081L987.399 650.07C987.384 650.06 987.363 650.045 987.334 650.025C987.277 649.987 987.192 649.931 987.084 649.864C986.868 649.731 986.559 649.557 986.193 649.393C985.453 649.061 984.51 648.786 983.616 648.934C983.224 648.999 983.011 649.203 982.89 649.477C982.76 649.77 982.732 650.157 982.765 650.569C982.798 650.975 982.889 651.376 982.973 651.679C983.015 651.83 983.055 651.954 983.084 652.041C983.099 652.084 983.111 652.117 983.119 652.14L983.128 652.165L983.13 652.171L983.13 652.172L983.13 652.172L983.131 652.172C983.131 652.172 983.131 652.172 983.13 652.172L982.677 652.437L982.677 652.437L982.677 652.437L982.677 652.437L982.675 652.435L982.668 652.426L982.639 652.392C982.613 652.362 982.575 652.318 982.526 652.261C982.427 652.147 982.282 651.985 982.102 651.789C981.74 651.397 981.233 650.876 980.654 650.354C980.074 649.832 979.427 649.314 978.783 648.927C978.135 648.536 977.518 648.295 976.993 648.288C976.477 648.281 976.236 648.465 976.11 648.697C975.968 648.958 975.941 649.341 975.994 649.775C976.046 650.201 976.169 650.634 976.282 650.965C976.338 651.129 976.391 651.266 976.429 651.362C976.448 651.41 976.464 651.447 976.475 651.472L976.487 651.5L976.49 651.506L976.49 651.508L976.49 651.508L976.491 651.508L987.418 650.084Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.532358
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.1 655.693H949.509V660.436H1030.1V655.693Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.532358
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M890.867 610.374C897.58 610.374 903.023 615.816 903.023 622.529C903.023 629.243 897.58 634.685 890.867 634.685C884.154 634.685 878.712 629.243 878.712 622.529C878.712 615.816 884.154 610.374 890.867 610.374Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M890.867 614.933H891.883C897.201 614.933 901.503 619.243 901.503 624.553C901.503 629.871 897.193 634.173 891.883 634.173H890.867C885.549 634.173 881.247 629.863 881.247 624.553C881.247 619.235 885.557 614.933 890.867 614.933Z",
    fill: "#62AE80"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M890.355 624.045V661.519",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M897.449 625.065L890.355 632.159",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M883.774 625.065L890.867 632.159",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M907.069 610.374C913.783 610.374 919.224 615.816 919.224 622.529C919.224 629.243 913.783 634.685 907.069 634.685C900.356 634.685 894.914 629.243 894.914 622.529C894.914 615.816 900.356 610.374 907.069 610.374Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M907.069 614.933H908.084C913.402 614.933 917.705 619.243 917.705 624.553C917.705 629.871 913.394 634.173 908.084 634.173H907.069C901.751 634.173 897.448 629.863 897.448 624.553C897.448 619.235 901.759 614.933 907.069 614.933Z",
    fill: "#62AE80"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M906.565 624.045V661.519",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M913.659 625.065L906.565 632.159",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M899.983 625.065L907.077 632.159",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M923.278 610.374C929.992 610.374 935.433 615.816 935.433 622.529C935.433 629.243 929.992 634.685 923.278 634.685C916.565 634.685 911.123 629.243 911.123 622.529C911.123 615.816 916.565 610.374 923.278 610.374Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M923.277 614.933H924.293C929.611 614.933 933.913 619.243 933.913 624.553C933.913 629.871 929.603 634.173 924.293 634.173H923.277C917.96 634.173 913.657 629.863 913.657 624.553C913.657 619.235 917.967 614.933 923.277 614.933Z",
    fill: "#62AE80"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M929.86 625.065L922.767 632.159",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M916.185 625.065L923.278 632.159",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M922.767 624.045V661.519",
    stroke: "#382456",
    strokeWidth: 0.775208
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M884.316 570.586C883.624 570.586 883.055 571.147 883.055 571.846V591.999C883.055 592.691 883.616 593.26 884.316 593.26C885.007 593.26 885.576 592.699 885.576 591.999V571.846C885.576 571.155 885.015 570.586 884.316 570.586Z",
    fill: "#615E66"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M840.236 572.259H883.055V580.652H840.236V572.259Z",
    fill: "#FFF9DE"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M840.236 578.138H883.055V578.975H840.236V578.138Z",
    fill: "#615E66"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M840.236 574.785H883.055V575.623H840.236V574.785Z",
    fill: "#615E66"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M842.759 571.846C842.759 571.147 842.198 570.586 841.506 570.586C840.814 570.586 840.238 571.147 840.238 571.846V591.999C840.238 592.691 840.799 593.26 841.506 593.26C842.213 593.26 842.759 592.699 842.759 591.999V571.846Z",
    fill: "#615E66"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M877.597 584.854C876.905 584.854 876.336 585.416 876.336 586.115V593.67C876.336 594.362 876.898 594.931 877.597 594.931C878.289 594.931 878.857 594.37 878.857 593.67V586.115C878.857 585.423 878.296 584.854 877.597 584.854Z",
    fill: "#615E66"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M835.623 584.854C834.932 584.854 834.363 585.416 834.363 586.115V593.67C834.363 594.362 834.924 594.931 835.623 594.931C836.315 594.931 836.884 594.37 836.884 593.67V586.115C836.884 585.423 836.323 584.854 835.623 584.854Z",
    fill: "#615E66"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M883.055 584.859L885.576 582.761H840.236L834.364 584.859V587.38H878.859L883.055 584.859Z",
    fill: "#FFF9DE"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M834.356 584.854H878.857V587.375H834.356V584.854Z",
    fill: "#615E66"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M885.576 582.761L878.859 584.859V588.218L885.576 585.282V582.761Z",
    fill: "#615E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6004_59723",
    x1: 540,
    y1: -82.0302,
    x2: 500.042,
    y2: 763.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741703,
    stopColor: "#F7F0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6004_59723",
    x1: 540.031,
    y1: -81.5302,
    x2: 500.075,
    y2: 763.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741703,
    stopColor: "#F7F0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6004_59723",
    x1: 2365.17,
    y1: 585.518,
    x2: 2365.17,
    y2: 406.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#726D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B7E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6004_59723",
    x1: 2365.17,
    y1: 585.518,
    x2: 2365.17,
    y2: 406.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6004_59723",
    x1: 473.544,
    y1: 549.818,
    x2: 481.138,
    y2: 548.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6004_59723",
    x1: 761.685,
    y1: 545.257,
    x2: 768.734,
    y2: 544.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6004_59723",
    x1: 757.069,
    y1: 538.864,
    x2: 757.069,
    y2: 542.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6004_59723",
    x1: 662.877,
    y1: 556.251,
    x2: 655.109,
    y2: 555.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6004_59723",
    x1: 659.42,
    y1: 550.978,
    x2: 679.536,
    y2: 550.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6004_59723",
    x1: 669.478,
    y1: 548.723,
    x2: 669.478,
    y2: 553.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6004_59723",
    x1: 227.896,
    y1: 540.333,
    x2: 227.896,
    y2: 552.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6004_59723",
    x1: 991.508,
    y1: 579.318,
    x2: 991.508,
    y2: 540.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6004_59723",
    x1: 1003.67,
    y1: 640.706,
    x2: 1003.67,
    y2: 613.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6004_59723",
    x1: 979.366,
    y1: 640.706,
    x2: 979.366,
    y2: 613.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6004_59723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 800,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroLostBgTablet);
export default __webpack_public_path__ + "static/media/MetroLostBgTablet.aefcbaeb8e25cc71d97e.svg";
export { ForwardRef as ReactComponent };